/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"036b50c8"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 72);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(79);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export date */
/* unused harmony export time */
/* unused harmony export number */
/* unused harmony export select */
/* unused harmony export plural */
/* unused harmony export selectOrdinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Trans__ = __webpack_require__(88);
/* unused harmony reexport Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useTranslation__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__useTranslation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withTranslation__ = __webpack_require__(101);
/* unused harmony reexport withTranslation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translation__ = __webpack_require__(102);
/* unused harmony reexport Translation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(103);
/* unused harmony reexport I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withSSR__ = __webpack_require__(104);
/* unused harmony reexport withSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useSSR__ = __webpack_require__(47);
/* unused harmony reexport useSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context__ = __webpack_require__(7);
/* unused harmony reexport I18nContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["f"]; });
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */
/* unused harmony reexport composeInitialProps */
/* unused harmony reexport getInitialProps */








var date = function date() {
  return '';
};
var time = function time() {
  return '';
};
var number = function number() {
  return '';
};
var select = function select() {
  return '';
};
var plural = function plural() {
  return '';
};
var selectOrdinal = function selectOrdinal() {
  return '';
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export handleOnKeyDown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEpisodePlayable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasPlayableEpisodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFirstPlayableEpisode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getModalText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return onMoviePress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return onEpisodePress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chunkArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIdForSTB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isSTBSessionStale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearIdsForSTB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return useFocusable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Movie__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Focus__ = __webpack_require__(3);
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};



var handleOnKeyDown = function (e, action) {
    if (e.keyCode === 13 || e.keyCode === 66) {
        e.preventDefault();
        // e.stopPropagation();
        action();
    }
};
var isEpisodePlayable = function (episode) {
    return (episode.status !== __WEBPACK_IMPORTED_MODULE_0__types_Movie__["a" /* MovieStatusEnum */].CS &&
        episode.status !== __WEBPACK_IMPORTED_MODULE_0__types_Movie__["a" /* MovieStatusEnum */].HI);
};
var hasPlayableEpisodes = function (episodes) {
    var _a;
    return (_a = episodes === null || episodes === void 0 ? void 0 : episodes.some(isEpisodePlayable)) !== null && _a !== void 0 ? _a : false;
};
var getFirstPlayableEpisode = function (episodes) {
    return episodes === null || episodes === void 0 ? void 0 : episodes.find(isEpisodePlayable);
};
var getModalText = function (type, t) {
    if (type === "buy") {
        return t("buy_movie_modal.title");
    }
    return t("coming_soon_modal." + type);
};
var onMoviePress = function (movie) {
    var isContentComingSoon = movie.status === __WEBPACK_IMPORTED_MODULE_0__types_Movie__["a" /* MovieStatusEnum */].CS;
    var hasPlayableEpisode = hasPlayableEpisodes(movie.episodes);
    var isSeriesComingSoon = movie.movieType === "series" && movie.episodes && !hasPlayableEpisode;
    if (isContentComingSoon || isSeriesComingSoon) {
        return {
            type: "modal",
            modalType: movie.movieType === "series" ? "series" : "movie",
        };
    }
    if (movie.type === "EST" && !movie.bought) {
        return { type: "modal", modalType: "buy" };
    }
    return { type: "navigate", slug: movie.slug };
};
var onEpisodePress = function (episode, slug, navigate) {
    return navigate("watch", { slug: slug, episode: episode.id });
};
var chunkArray = function (arr, size) {
    var result = [];
    for (var i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
};
var getIdForSTB = function (key, paramName) {
    var stored = localStorage.getItem(key);
    if (stored)
        return stored;
    var paramValue = new URLSearchParams(window.location.search).get(paramName);
    if (paramValue) {
        localStorage.setItem(key, paramValue);
        return paramValue;
    }
    return null;
};
var isStoredIdStale = function (key, paramName) {
    var stored = localStorage.getItem(key);
    var paramValue = new URLSearchParams(window.location.search).get(paramName);
    return !!stored && !!paramValue && stored !== paramValue;
};
var isSTBSessionStale = function () {
    return (isStoredIdStale("accountId", "user_id") ||
        isStoredIdStale("stbId", "stb_id"));
};
var clearIdsForSTB = function () {
    localStorage.removeItem("accountId");
    localStorage.removeItem("stbId");
};
var useFocusable = function (_a) {
    var group = _a.group, index = _a.index, id = _a.id, direction = _a.direction, onKeyDown = _a.onKeyDown, onKeyBack = _a.onKeyBack;
    var nodeRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
    var resolvedId = id !== null && id !== void 0 ? id : "item-" + group + "-" + index;
    // Keep callbacks in refs so registration always has fresh references
    var onKeyDownRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(onKeyDown);
    var onKeyBackRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(onKeyBack);
    onKeyDownRef.current = onKeyDown;
    onKeyBackRef.current = onKeyBack;
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (nodeRef.current) {
            __WEBPACK_IMPORTED_MODULE_2__Focus__["b" /* focusManager */].register(group, index, resolvedId, nodeRef.current, direction, function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = onKeyDownRef.current) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArrays([onKeyDownRef], args));
            }, function () { var _a; return (_a = onKeyBackRef.current) === null || _a === void 0 ? void 0 : _a.call(onKeyBackRef); });
        }
        return function () {
            __WEBPACK_IMPORTED_MODULE_2__Focus__["b" /* focusManager */].unregister(group, resolvedId);
        };
    }, [group, index, resolvedId, direction]);
    return nodeRef;
};


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusableItemDirectionEnum; });
/* unused harmony export FocusManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusManager; });
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var FocusableItemDirectionEnum;
(function (FocusableItemDirectionEnum) {
    FocusableItemDirectionEnum["Horizontal"] = "horizontal";
    FocusableItemDirectionEnum["Vertical"] = "vertical";
})(FocusableItemDirectionEnum || (FocusableItemDirectionEnum = {}));
var KEYS = {
    LEFT: [37],
    UP: [38],
    RIGHT: [39],
    DOWN: [40],
    ENTER: [13],
    BACK: [8, 461, 27],
    EXIT: [403, 67],
    TOP: [90, 406],
};
// Pre-computed set for preventDefault check
var PREVENTABLE_KEYS = new Set(__spreadArrays(KEYS.UP, KEYS.DOWN, KEYS.LEFT, KEYS.RIGHT, KEYS.ENTER));
// O(1) keycode → action lookup
var KEY_ACTION = new Map();
KEYS.LEFT.forEach(function (k) { return KEY_ACTION.set(k, "LEFT"); });
KEYS.RIGHT.forEach(function (k) { return KEY_ACTION.set(k, "RIGHT"); });
KEYS.UP.forEach(function (k) { return KEY_ACTION.set(k, "UP"); });
KEYS.DOWN.forEach(function (k) { return KEY_ACTION.set(k, "DOWN"); });
KEYS.ENTER.forEach(function (k) { return KEY_ACTION.set(k, "ENTER"); });
KEYS.BACK.forEach(function (k) { return KEY_ACTION.set(k, "BACK"); });
var FocusManager = /** @class */ (function () {
    function FocusManager() {
        var _this = this;
        this.groups = new Map();
        this.groupOrder = [];
        this.groupIndexMap = new Map();
        this.groupOrderDirty = false;
        this.currentGroup = "main-navbar";
        this.currentIndex = 0;
        this.isEnabled = true;
        this.layerStack = [];
        this.activeLayerGroupName = null;
        this.activeLayerIsolated = false;
        this.pendingUpdate = false;
        this.lastFocusedNode = null;
        this.lastMoveDirection = null;
        this.direction = FocusableItemDirectionEnum.Horizontal;
        this.forceHorizontalRecenter = false;
        this.pendingVerticalFocus = null;
        this.offsets = new Map();
        this.viewportHeight = typeof window !== "undefined" ? window.innerHeight : 0;
        this.resizeHandler = null;
        // Cached parent rects — invalidated on resize
        this.parentRects = new Map();
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.tick = this.tick.bind(this);
        if (typeof window !== "undefined") {
            window.addEventListener("keydown", this.handleKeyDown);
            this.resizeHandler = function () {
                _this.viewportHeight = window.innerHeight;
                _this.parentRects.clear();
            };
            window.addEventListener("resize", this.resizeHandler);
        }
    }
    FocusManager.prototype.targetMap = function (groupName) {
        if (this.activeLayerIsolated &&
            this.layerStack.length > 0 &&
            groupName !== this.activeLayerGroupName) {
            return this.layerStack[this.layerStack.length - 1].groups;
        }
        return this.groups;
    };
    FocusManager.prototype.removeGroup = function (groupName) {
        var _a;
        this.targetMap(groupName).delete(groupName);
        this.groupOrderDirty = true;
        if (((_a = this.pendingVerticalFocus) === null || _a === void 0 ? void 0 : _a.groupName) === groupName) {
            this.pendingVerticalFocus = null;
        }
    };
    FocusManager.prototype.addGroupOrder = function (groupName, position) {
        this.registerGroup({ name: groupName, position: position });
    };
    FocusManager.prototype.registerGroup = function (_a) {
        var groupName = _a.name, position = _a.position, itemHeight = _a.itemHeight, horizontalContainer = _a.horizontalContainer, verticalContainer = _a.verticalContainer, resetIndexOnVerticalMove = _a.resetIndexOnVerticalMove;
        var map = this.targetMap(groupName);
        if (!map.has(groupName)) {
            map.set(groupName, {
                name: groupName,
                items: [],
                itemsById: new Map(),
                savedIndex: 0,
                position: position || 0,
                itemHeight: itemHeight || 0,
                horizontalContainer: horizontalContainer,
                verticalContainer: verticalContainer,
                resetIndexOnVerticalMove: resetIndexOnVerticalMove,
            });
        }
        else {
            var group = map.get(groupName);
            if (position !== undefined)
                group.position = position;
            if (itemHeight !== undefined)
                group.itemHeight = itemHeight;
            if (horizontalContainer !== undefined)
                group.horizontalContainer = horizontalContainer;
            if (verticalContainer !== undefined)
                group.verticalContainer = verticalContainer;
            if (resetIndexOnVerticalMove !== undefined)
                group.resetIndexOnVerticalMove = resetIndexOnVerticalMove;
        }
        this.groupOrderDirty = true;
    };
    FocusManager.prototype.ensureGroupOrder = function () {
        var _this = this;
        if (!this.groupOrderDirty)
            return;
        this.groupOrder.length = 0;
        this.groups.forEach(function (_, name) { return _this.groupOrder.push(name); });
        this.groupOrder.sort(function (a, b) { return _this.groups.get(a).position - _this.groups.get(b).position; });
        this.groupIndexMap.clear();
        for (var i = 0; i < this.groupOrder.length; i++) {
            this.groupIndexMap.set(this.groupOrder[i], i);
        }
        this.groupOrderDirty = false;
    };
    FocusManager.prototype.updateGroupOrder = function () {
        this.groupOrderDirty = true;
    };
    FocusManager.prototype.clearGroupsAndResetOrder = function () {
        this.groups.clear();
        this.groupOrder.length = 0;
        this.groupIndexMap.clear();
        this.groupOrderDirty = false;
        this.offsets.clear();
        this.parentRects.clear();
        this.pendingVerticalFocus = null;
    };
    // Drop the per-container scroll/layout caches without touching groups or the
    // current focus. These maps are keyed by scroll-container elements and are
    // never otherwise pruned, so a left screen's detached container stays pinned
    // here — keeping its whole poster subtree (and textures) alive. Safe to call
    // on navigation: the incoming screen rebuilds its entries on the next tick.
    FocusManager.prototype.clearScrollCaches = function () {
        this.offsets.clear();
        this.parentRects.clear();
    };
    FocusManager.prototype.getGroupTotalHeight = function (group) {
        var _a;
        if (!group.itemHeight)
            return 0;
        if (((_a = group.items[0]) === null || _a === void 0 ? void 0 : _a.direction) === FocusableItemDirectionEnum.Vertical) {
            return group.itemHeight * group.items.length;
        }
        return group.itemHeight;
    };
    FocusManager.prototype.binaryInsert = function (items, item) {
        var lo = 0;
        var hi = items.length;
        while (lo < hi) {
            var mid = (lo + hi) >>> 1;
            if (items[mid].index < item.index)
                lo = mid + 1;
            else
                hi = mid;
        }
        items.splice(lo, 0, item);
    };
    FocusManager.prototype.register = function (groupName, index, id, node, direction, onClick, onBack) {
        var _a;
        var map = this.targetMap(groupName);
        if (!map.has(groupName)) {
            map.set(groupName, {
                name: groupName,
                items: [],
                itemsById: new Map(),
                savedIndex: 0,
                position: 0,
                itemHeight: 0,
            });
            this.groupOrderDirty = true;
        }
        var group = map.get(groupName);
        var existing = group.itemsById.get(id);
        var wasEmpty = group.items.length === 0;
        if (existing) {
            existing.node = node;
            existing.index = index;
            existing.onClick = onClick;
            existing.onBack = onBack;
            existing.direction = direction;
        }
        else {
            var newItem = {
                id: id,
                group: groupName,
                index: index,
                node: node,
                onClick: onClick,
                onBack: onBack,
                direction: direction || FocusableItemDirectionEnum.Horizontal,
            };
            group.itemsById.set(id, newItem);
            this.binaryInsert(group.items, newItem);
        }
        if (this.currentGroup === groupName && this.currentIndex === index) {
            this.requestTick();
        }
        if (wasEmpty &&
            this.pendingVerticalFocus &&
            this.pendingVerticalFocus.groupName === groupName) {
            var pending = this.pendingVerticalFocus;
            this.pendingVerticalFocus = null;
            var targetIdx = pending.resetToStart
                ? 0
                : Math.min(group.items.length - 1, pending.preferredIndex);
            this.currentGroup = groupName;
            this.currentIndex = targetIdx;
            group.savedIndex = targetIdx;
            this.forceHorizontalRecenter = true;
            this.requestTick();
            if (typeof window !== "undefined") {
                this.ensureGroupOrder();
                window.dispatchEvent(new CustomEvent("focus-group-change", {
                    detail: {
                        group: groupName,
                        index: (_a = this.groupIndexMap.get(groupName)) !== null && _a !== void 0 ? _a : -1,
                        total: this.groupOrder.length,
                    },
                }));
            }
        }
    };
    FocusManager.prototype.unregister = function (groupName, id) {
        var _a;
        var map = this.targetMap(groupName);
        var group = map.get(groupName);
        if (group) {
            var item = group.itemsById.get(id);
            if (item) {
                group.itemsById.delete(id);
                var idx = group.items.indexOf(item);
                if (idx !== -1)
                    group.items.splice(idx, 1);
            }
            if (group.items.length === 0) {
                map.delete(groupName);
                this.groupOrderDirty = true;
                if (((_a = this.pendingVerticalFocus) === null || _a === void 0 ? void 0 : _a.groupName) === groupName) {
                    this.pendingVerticalFocus = null;
                }
            }
        }
    };
    FocusManager.prototype.handleKeyDown = function (event) {
        if (!this.isEnabled)
            return;
        var code = event.keyCode;
        var action = KEY_ACTION.get(code);
        if (!action)
            return;
        if (PREVENTABLE_KEYS.has(code)) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (action === "LEFT" || action === "RIGHT")
            this.lastMoveDirection = "HORIZONTAL";
        else if (action === "UP" || action === "DOWN")
            this.lastMoveDirection = "VERTICAL";
        if (!this.direction) {
            this.direction = FocusableItemDirectionEnum.Horizontal;
        }
        if (action === "ENTER") {
            this.handleEnter();
            return;
        }
        if (action === "BACK") {
            this.handleBack();
            return;
        }
        if (this.direction === FocusableItemDirectionEnum.Horizontal) {
            this.move(action);
        }
        else {
            if (action === "UP")
                this.move("LEFT");
            else if (action === "DOWN")
                this.move("RIGHT");
        }
    };
    FocusManager.prototype.move = function (direction) {
        var _a;
        this.ensureGroupOrder();
        var group = this.groups.get(this.currentGroup);
        if (!group || group.items.length === 0)
            return;
        var targetIndex = this.currentIndex;
        var targetGroup = this.currentGroup;
        if (direction === "LEFT") {
            this.pendingVerticalFocus = null;
            targetIndex = Math.max(0, this.currentIndex - 1);
        }
        else if (direction === "RIGHT") {
            this.pendingVerticalFocus = null;
            targetIndex = Math.min(group.items.length - 1, this.currentIndex + 1);
        }
        else if (direction === "UP" || direction === "DOWN") {
            var currentGroupOrderIndex = this.groupIndexMap.get(this.currentGroup);
            if (currentGroupOrderIndex === undefined)
                return;
            var nextGroupIndex = direction === "DOWN"
                ? currentGroupOrderIndex + 1
                : currentGroupOrderIndex - 1;
            if (nextGroupIndex >= 0 && nextGroupIndex < this.groupOrder.length) {
                var nextGroupName = this.groupOrder[nextGroupIndex];
                var nextGroup = this.groups.get(nextGroupName);
                if (nextGroup) {
                    if (nextGroup.items.length > 0) {
                        targetGroup = nextGroupName;
                        targetIndex = nextGroup.resetIndexOnVerticalMove
                            ? 0
                            : Math.min(nextGroup.items.length - 1, this.currentIndex);
                    }
                    else {
                        // Row is registered in order but hasn't committed items yet.
                        // Remember the intended move so register() can finish it once
                        // the row actually populates, instead of dead-ending here.
                        this.pendingVerticalFocus = {
                            groupName: nextGroupName,
                            preferredIndex: this.currentIndex,
                            resetToStart: !!nextGroup.resetIndexOnVerticalMove,
                        };
                        if (direction === "DOWN" && typeof window !== "undefined") {
                            window.dispatchEvent(new Event("focus-end-reached"));
                        }
                    }
                }
            }
            else if (direction === "DOWN") {
                if (typeof window !== "undefined") {
                    window.dispatchEvent(new Event("focus-end-reached"));
                }
            }
        }
        if (targetGroup !== this.currentGroup ||
            targetIndex !== this.currentIndex) {
            if (targetGroup !== this.currentGroup) {
                group.savedIndex = this.currentIndex;
                this.pendingVerticalFocus = null;
                this.forceHorizontalRecenter = true;
            }
            this.currentGroup = targetGroup;
            this.currentIndex = targetIndex;
            var newGroup = this.groups.get(targetGroup);
            if (newGroup)
                newGroup.savedIndex = targetIndex;
            this.requestTick();
            if (typeof window !== "undefined") {
                window.dispatchEvent(new CustomEvent("focus-group-change", {
                    detail: {
                        group: targetGroup,
                        index: (_a = this.groupIndexMap.get(targetGroup)) !== null && _a !== void 0 ? _a : -1,
                        total: this.groupOrder.length,
                    },
                }));
            }
        }
    };
    FocusManager.prototype.handleEnter = function () {
        var currentItem = this.getCurrentItem();
        if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.onClick)
            currentItem.onClick();
    };
    FocusManager.prototype.handleBack = function () {
        var currentItem = this.getCurrentItem();
        if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.onBack) {
            currentItem.onBack();
            return;
        }
        if (this.layerStack.length > 0) {
            this.popLayer();
        }
    };
    FocusManager.prototype.getCurrentItem = function () {
        var group = this.groups.get(this.currentGroup);
        if (!group)
            return undefined;
        return group.items[this.currentIndex] || group.items[0];
    };
    FocusManager.prototype.requestTick = function () {
        if (!this.pendingUpdate) {
            this.pendingUpdate = true;
            requestAnimationFrame(this.tick);
        }
    };
    FocusManager.prototype.getParentRect = function (container) {
        var parent = container.parentElement;
        if (!parent)
            return container.getBoundingClientRect();
        var cached = this.parentRects.get(parent);
        if (!cached) {
            cached = parent.getBoundingClientRect();
            this.parentRects.set(parent, cached);
        }
        return cached;
    };
    FocusManager.prototype.getOffset = function (container) {
        var offset = this.offsets.get(container);
        if (!offset) {
            offset = { x: 0, y: 0, writtenX: NaN, writtenY: NaN };
            this.offsets.set(container, offset);
        }
        return offset;
    };
    FocusManager.prototype.tick = function () {
        var group = this.groups.get(this.currentGroup);
        var item = (group === null || group === void 0 ? void 0 : group.items[this.currentIndex]) || (group === null || group === void 0 ? void 0 : group.items[0]);
        if (!(item === null || item === void 0 ? void 0 : item.node)) {
            this.pendingUpdate = false;
            this.forceHorizontalRecenter = false;
            return;
        }
        this.direction = item.direction;
        if (this.lastFocusedNode !== item.node) {
            if (this.lastFocusedNode) {
                this.lastFocusedNode.classList.remove("is-focused");
            }
            item.node.classList.add("is-focused");
            item.node.focus({ preventScroll: true });
        }
        var forceHorizontal = this.forceHorizontalRecenter;
        this.forceHorizontalRecenter = false;
        var hasHorizontal = (this.lastMoveDirection !== "VERTICAL" || forceHorizontal) &&
            !!group.horizontalContainer;
        var hasVertical = (this.lastMoveDirection === "VERTICAL" ||
            this.lastMoveDirection === null) &&
            !!group.verticalContainer;
        if (hasHorizontal || hasVertical) {
            var rect = item.node.getBoundingClientRect();
            // --- Horizontal Scroll ---
            if (hasHorizontal) {
                var container = group.horizontalContainer;
                var offset = this.getOffset(container);
                var parentRect = this.getParentRect(container);
                var targetLeft = parentRect.width / 2 - rect.width / 2;
                var diffX = rect.left - parentRect.left - targetLeft;
                offset.x -= diffX;
                if (offset.x > 0)
                    offset.x = 0;
                if (offset.x !== offset.writtenX) {
                    container.style.transform = "translateX(" + offset.x + "px)";
                    offset.writtenX = offset.x;
                }
            }
            // --- Vertical Scroll ---
            if (hasVertical) {
                var container = group.verticalContainer;
                var offset = this.getOffset(container);
                var parentRect = this.getParentRect(container);
                var viewportHeight = parentRect.height || this.viewportHeight;
                var parentTop = parentRect.top;
                var targetTop = viewportHeight / 2 - rect.height / 2;
                var diffY = rect.top - parentTop - targetTop;
                // Total content height from pre-set itemHeights — no DOM measurement
                this.ensureGroupOrder();
                var contentHeight = 0;
                for (var i = 0; i < this.groupOrder.length; i++) {
                    var g = this.groups.get(this.groupOrder[i]);
                    if (g)
                        contentHeight += this.getGroupTotalHeight(g);
                }
                if (contentHeight <= 0)
                    contentHeight = container.scrollHeight;
                offset.y -= diffY;
                var minY = Math.min(0, viewportHeight - contentHeight);
                if (offset.y < minY)
                    offset.y = minY;
                if (offset.y > 0)
                    offset.y = 0;
                if (offset.y !== offset.writtenY) {
                    container.style.transform = "translateY(" + offset.y + "px)";
                    offset.writtenY = offset.y;
                }
            }
        }
        this.lastFocusedNode = item.node;
        this.pendingUpdate = false;
    };
    FocusManager.prototype.destroy = function () {
        if (typeof window !== "undefined") {
            window.removeEventListener("keydown", this.handleKeyDown);
            if (this.resizeHandler) {
                window.removeEventListener("resize", this.resizeHandler);
                this.resizeHandler = null;
            }
        }
        this.groups.clear();
        this.offsets.clear();
        this.parentRects.clear();
        this.groupIndexMap.clear();
        this.pendingVerticalFocus = null;
    };
    FocusManager.prototype.jumpToTop = function () {
        this.lastMoveDirection = null;
        this.pendingVerticalFocus = null;
        this.offsets.forEach(function (offset, container) {
            container.style.transform = "translateY(0px)";
        });
        this.offsets.clear();
        this.manualFocus("main-navbar", 0);
    };
    FocusManager.prototype.getCurrentGroup = function () {
        return this.currentGroup;
    };
    FocusManager.prototype.manualFocus = function (groupName, itemIndex, force) {
        if (force === void 0) { force = false; }
        this.pendingVerticalFocus = null;
        if (force) {
            this.currentGroup = groupName;
            this.currentIndex = itemIndex;
            return;
        }
        var group = this.groups.get(groupName);
        if (group) {
            this.currentGroup = groupName;
            var itemIdx = group.items.findIndex(function (i) { return i.index === itemIndex; });
            this.currentIndex = itemIdx !== -1 ? itemIdx : 0;
            this.forceHorizontalRecenter = true;
            this.requestTick();
        }
    };
    FocusManager.prototype.isKey = function (key, name) {
        var _a, _b;
        return (_b = (_a = KEYS[name]) === null || _a === void 0 ? void 0 : _a.includes(key)) !== null && _b !== void 0 ? _b : false;
    };
    FocusManager.prototype.pushLayer = function (_a) {
        var groupName = _a.groupName, index = _a.index, isolate = _a.isolate;
        var currentGroup = this.groups.get(this.currentGroup);
        if (currentGroup) {
            currentGroup.savedIndex = this.currentIndex;
        }
        this.layerStack.push({
            groups: this.groups,
            currentGroup: this.currentGroup,
            prevLayerGroupName: this.activeLayerGroupName,
            prevLayerIsolated: this.activeLayerIsolated,
        });
        this.groups = new Map();
        this.activeLayerGroupName = groupName;
        this.activeLayerIsolated = !!isolate;
        this.groupOrderDirty = true;
        this.pendingVerticalFocus = null;
        this.ensureGroupOrder();
        this.currentGroup = groupName;
        this.currentIndex = index;
        this.forceHorizontalRecenter = true;
        this.requestTick();
    };
    FocusManager.prototype.popLayer = function () {
        if (this.layerStack.length > 0) {
            var prev = this.layerStack.pop();
            if (prev) {
                this.groups = prev.groups;
                this.currentGroup = prev.currentGroup;
                this.activeLayerGroupName = prev.prevLayerGroupName;
                this.activeLayerIsolated = prev.prevLayerIsolated;
                this.pendingVerticalFocus = null;
                var oldGroup = prev.groups.get(prev.currentGroup);
                if (oldGroup) {
                    this.currentIndex = oldGroup.savedIndex || 0;
                    var oldItem = oldGroup.items[this.currentIndex] || oldGroup.items[0];
                    this.direction = oldItem
                        ? oldItem.direction
                        : FocusableItemDirectionEnum.Horizontal;
                }
                this.groupOrderDirty = true;
                this.forceHorizontalRecenter = true;
                this.ensureGroupOrder();
                this.requestTick();
            }
        }
    };
    return FocusManager;
}());

var focusManager = new FocusManager();


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouterProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalContext__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExitModalContext__ = __webpack_require__(37);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var RouterContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var RouterProvider = function (_a) {
    var _b = _a.initialRoute, initialRoute = _b === void 0 ? "home" : _b, _c = _a.initialParams, initialParams = _c === void 0 ? {} : _c, children = _a.children;
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        route: initialRoute,
        params: initialParams,
    }), nav = _d[0], setNav = _d[1];
    var historyRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);
    var maxHistory = 30;
    var isSameParams = function (a, b) {
        return Object.keys(a).length === Object.keys(b).length &&
            Object.keys(a).every(function (key) { return a[key] === b[key]; });
    };
    var clearConsoleBox = function () {
        if (window.clearConsoleBox) {
            window.clearConsoleBox();
        }
    };
    var navigate = function (nextRoute, nextParams) {
        if (nextParams === void 0) { nextParams = {}; }
        clearConsoleBox();
        var last = historyRef.current[historyRef.current.length - 1];
        var isDuplicate = last && last.route === nav.route && isSameParams(last.params, nav.params);
        if (!["auth", "profiles", "watch"].includes(nav.route) && !isDuplicate) {
            historyRef.current.push({
                route: nav.route,
                params: __assign({}, nav.params),
            });
            if (historyRef.current.length > maxHistory) {
                historyRef.current.shift();
            }
        }
        setNav({
            route: nextRoute,
            params: nextParams,
        });
    };
    var goBack = function () {
        var prev = historyRef.current.pop();
        if (!prev)
            return;
        clearConsoleBox();
        setNav({
            route: prev.route,
            params: prev.params,
        });
    };
    var value = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return ({
        route: nav.route,
        params: nav.params,
        navigate: navigate,
        goBack: goBack,
    }); }, [nav]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RouterContext.Provider, { value: value },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ModalContext__["a" /* ModalProvider */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ExitModalContext__["a" /* ExitModalProvider */], null, children))));
};
var useRouter = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(RouterContext);
    if (!context) {
        throw new Error("useRouter must be used within a RouterProvider");
    }
    return context;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(51);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var initialAuthState = {
    user: null,
    profiles: [],
    profile: null,
    errorStatus: null,
};
var AuthContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var authReducer = function (state, action) {
    switch (action.type) {
        case "LOGIN":
            return __assign(__assign({}, state), { user: action.user });
        case "LOGOUT":
            return __assign({}, initialAuthState);
        case "SET_PROFILES":
            return __assign(__assign({}, state), { profiles: action.profiles });
        case "SET_PROFILE":
            return __assign(__assign({}, state), { profile: action.profile });
        default:
            return state;
    }
};
var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(authReducer, initialAuthState), state = _b[0], dispatch = _b[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AuthContext.Provider, { value: { state: state, dispatch: dispatch } }, children));
};
var useAuth = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    var state = context.state, dispatch = context.dispatch;
    return {
        user: state.user,
        profiles: state.profiles,
        profile: state.profile,
        dispatch: dispatch,
    };
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18nContext; });
/* unused harmony export setDefaults */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDefaults;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReportNamespaces; });
/* unused harmony export setI18n */
/* harmony export (immutable) */ __webpack_exports__["e"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initReactI18next; });
/* harmony export (immutable) */ __webpack_exports__["c"] = composeInitialProps;
/* unused harmony export getInitialProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__unescape__ = __webpack_require__(95);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: __WEBPACK_IMPORTED_MODULE_4__unescape__["a" /* unescape */]
};
var i18nInstance;
var I18nContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["createContext"])();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useModalContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_modals_InfoModal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Helpers__ = __webpack_require__(2);






var ModalContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);
var ModalProvider = function (_a) {
    var children = _a.children;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), modal = _b[0], setModal = _b[1];
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])().t;
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (type) {
        setModal(function (current) {
            if (current)
                return current;
            __WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "modalView", index: 0 });
            return type;
        });
    }, []);
    var hideModal = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        __WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].popLayer();
        setModal(null);
    }, []);
    var value = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return ({ showModal: showModal, hideModal: hideModal }); }, [showModal, hideModal]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalContext.Provider, { value: value },
        children,
        modal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_views_modals_InfoModal__["a" /* InfoModal */], { text: Object(__WEBPACK_IMPORTED_MODULE_4__utils_Helpers__["e" /* getModalText */])(modal, t), onClose: hideModal })));
};
var useModalContext = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ModalContext);
    if (!context) {
        throw new Error("useModalContext must be used within ModalProvider");
    }
    return context;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(46);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getQuickAuthCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return quickAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return userRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authIdentify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateChosenProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(23);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var getQuickAuthCode = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "quick-auth/create";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var quickAuth = function (code, sid) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "quick-auth/verify";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, {
                        code: code,
                        sid: sid,
                    })];
            case 1:
                data = (_a.sent()).data;
                if (data.id) {
                    return [2 /*return*/, data];
                }
                return [2 /*return*/];
        }
    });
}); };
var userRegister = function (stbId, accountId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "auth/identify/silknet";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, {
                        stbId: stbId,
                        accountId: accountId,
                        firstName: "SilkTV",
                        lastName: "SilkTV",
                    })];
            case 1:
                data = (_a.sent()).data;
                if (data.id) {
                    return [2 /*return*/, data];
                }
                return [2 /*return*/];
        }
    });
}); };
var authIdentify = function (stbId, accountId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "auth/guest/silk";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, {
                        stbId: stbId,
                        accountId: accountId,
                    })];
            case 1:
                data = (_a.sent()).data;
                if (data.id) {
                    return [2 /*return*/, data];
                }
                return [2 /*return*/];
        }
    });
}); };
var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "auth/logout";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url).then(function () {
                        console.log("handle global state reset");
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var fetchUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "auth/fetch";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var updateChosenProfile = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "profiles/" + id + "/chosen";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["d" /* putRequest */])(url, {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buttons_CloseButtonView__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalStyles_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modalStyles_css__);



var InfoModal = function (_a) {
    var text = _a.text, onClose = _a.onClose;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "info-text" }, text),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__buttons_CloseButtonView__["a" /* CloseButtonView */], { onClose: onClose })));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(89);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = warn;
/* harmony export (immutable) */ __webpack_exports__["e"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadNamespaces;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasLoadedNamespace;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_header_HeaderView__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Router__ = __webpack_require__(4);



var Header = function () {
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_2__context_Router__["b" /* useRouter */])().navigate;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__views_header_HeaderView__["a" /* HeaderView */], { navigate: navigate });
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoviePoster; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__);



var LOAD_SETTLE_MS = 200;
var MoviePoster = function (_a) {
    var url = _a.url, _b = _a.className, className = _b === void 0 ? "poster" : _b, activeProp = _a.active;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var windowed = activeProp !== undefined;
    var active = activeProp !== null && activeProp !== void 0 ? activeProp : true;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var el = ref.current;
        if (!el)
            return;
        if (!active || !url) {
            // Release the decoded texture when the poster leaves the active window.
            // On Cobalt the image cache holds every loaded background-image, so
            // clearing off-screen ones is what keeps GPU memory bounded.
            el.style.backgroundImage = "none";
            return;
        }
        if (!windowed) {
            el.style.backgroundImage = "url('" + url + "')";
            return;
        }
        var timer = setTimeout(function () {
            el.style.backgroundImage = "url('" + url + "')";
        }, LOAD_SETTLE_MS);
        return function () { return clearTimeout(timer); };
    }, [url, active, windowed]);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, className: className });
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMovieBlocks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContinueWatchingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMoviesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchMovies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGenres; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBlockMovies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DTOs__ = __webpack_require__(60);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var getMovieBlocks = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "blocks";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, params)];
            case 1:
                data = (_a.sent()).data;
                data.items = data.items.map(function (item) {
                    return __assign(__assign({}, item), { movies: Object(__WEBPACK_IMPORTED_MODULE_1__DTOs__["b" /* fromMoviesDTO */])(item.movies) });
                });
                return [2 /*return*/, data];
        }
    });
}); };
var getContinueWatchingList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "progress/continue_watching";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, {
                        lang: params.lang,
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__DTOs__["a" /* fromContinueWatchingDTO */])(data)];
        }
    });
}); };
var getMoviesList = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var url, queryParams, types, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "movies/list";
                queryParams = __assign({}, options);
                if (options.imdb && options.imdb.length) {
                    queryParams.imdb = options.imdb.toString();
                }
                if (options.rating && options.rating.length) {
                    queryParams.rating = options.rating.toString();
                }
                if (options.year && options.year.length) {
                    queryParams.year = options.year.toString();
                }
                types = [];
                if (options.free) {
                    types.push("avod");
                }
                if (options.premium) {
                    types.push("svod");
                }
                if (options.buy) {
                    types.push("est");
                }
                if (types && types.length) {
                    queryParams.types = types.toString();
                }
                if (options.genres && options.genres.length) {
                    queryParams.genre = options.genres;
                }
                if (options.dubs && options.dubs.length) {
                    queryParams.dub = options.dubs;
                }
                if (options.subs && options.subs.length) {
                    queryParams.sub = options.subs;
                }
                if (options.countries && options.countries.length) {
                    queryParams.country = options.countries;
                }
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, queryParams)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, __assign(__assign({}, data), { items: Object(__WEBPACK_IMPORTED_MODULE_1__DTOs__["b" /* fromMoviesDTO */])(data.items) })];
        }
    });
}); };
var searchMovies = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "search/movies";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, {
                        q: params.q,
                        lang: params.lang,
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, __assign(__assign({}, data), { items: Object(__WEBPACK_IMPORTED_MODULE_1__DTOs__["b" /* fromMoviesDTO */])(data.items) })];
        }
    });
}); };
var getGenres = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "genres";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var getBlockMovies = function (slug, params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "blocks/" + slug;
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, __assign(__assign({}, data), { items: Object(__WEBPACK_IMPORTED_MODULE_1__DTOs__["b" /* fromMoviesDTO */])(data.items) })];
        }
    });
}); };


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return putRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var APP_ORIGIN = "silk";
// The deploy build pins this to "off", which a .env line or a shell export
// cannot override; only start and serve:local/dev/prod set a real key. It is
// what makes a non-Silk host trust this app-origin.
var STB_DEV_KEY = "off";
var STB_DEV_KEY_OFF = "off";
var appHeaders = function () {
    var headers = { "app-origin": APP_ORIGIN };
    if (STB_DEV_KEY && STB_DEV_KEY !== STB_DEV_KEY_OFF) {
        headers["stb-dev-key"] = STB_DEV_KEY;
    }
    return headers;
};
var api = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "/api/v1/",
});
api.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        config.headers = __assign(__assign({}, config.headers), appHeaders());
        config.withCredentials = false;
        return [2 /*return*/, config];
    });
}); }, function (error) { return Promise.reject(error); });
api.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var response, message;
    return __generator(this, function (_a) {
        try {
            response = error.response;
            if (response && response.status === 401) {
                message = response.data.message;
                if (message !== "Required fields are missing") {
                    console.log("handle global state reset");
                }
            }
            if (!(error instanceof Error)) {
                return [2 /*return*/, Promise.reject(new Error(error.response.data.message || error.message))];
            }
            return [2 /*return*/, Promise.reject(error)];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject(new Error(err.message))];
        }
        return [2 /*return*/];
    });
}); });
var getRequest = function (url, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get(url, { params: params })];
            case 1:
                response = _a.sent();
                if (response) {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
var postRequest = function (url, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post(url, body)];
            case 1:
                response = _a.sent();
                if (response) {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
var putRequest = function (url, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.put(url, body)];
            case 1:
                response = _a.sent();
                if (response) {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                console.log(error_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
// export const deleteRequest = async (url, params) => {
//     try {
//         return await api.delete(url, { params });
//     } catch (error) {
//         console.log(error)
//     }
// };
//
// export const patchRequest = async (url, body) => {
//     try {
//         return await api.patch(url, body);
//     } catch (error) {
//         console.log(error)
//     }
// };


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(9);
var utils = __webpack_require__(5);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollToTopButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__);



var ScrollToTopButton = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "scroll-to-top-wrapper" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "scroll-to-top-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "scroll-to-top-icon" }),
            t("layout.scroll_to_top"))));
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACTIVE_ROW_BUFFER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWithinPosterWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useTVScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Focus__ = __webpack_require__(3);


// How many rows above/below the focused row keep their poster images loaded.
// Everything outside this window releases its texture to bound GPU memory.
var ACTIVE_ROW_BUFFER = 2;
var isWithinPosterWindow = function (rowIndex, focusedIndex) { return Math.abs(rowIndex - focusedIndex) <= ACTIVE_ROW_BUFFER; };
var useTVScroll = function (_a) {
    var onEndReached = (_a === void 0 ? {} : _a).onEndReached;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), scrollToTopVisible = _b[0], setScrollToTopVisible = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), focusedGroup = _c[0], setFocusedGroup = _c[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handleFocusChange = function (e) {
            var _a = e.detail, index = _a.index, total = _a.total, group = _a.group;
            setFocusedGroup(group !== null && group !== void 0 ? group : null);
            if (index >= total - 2) {
                if (onEndReached)
                    onEndReached();
            }
            if (index > 1) {
                setScrollToTopVisible(true);
            }
            else {
                setScrollToTopVisible(false);
            }
        };
        var handleEndReached = function () {
            if (onEndReached)
                onEndReached();
        };
        var handleKeyDown = function (e) {
            if (__WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].isKey(e.keyCode, "TOP")) {
                setScrollToTopVisible(false);
                __WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].jumpToTop();
            }
        };
        window.addEventListener("focus-group-change", handleFocusChange);
        window.addEventListener("focus-end-reached", handleEndReached);
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("focus-group-change", handleFocusChange);
            window.removeEventListener("focus-end-reached", handleEndReached);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onEndReached]);
    return { scrollToTopVisible: scrollToTopVisible, focusedGroup: focusedGroup };
};


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCobaltMajor; });
/* unused harmony export getStvVersion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStvVersionNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadShaka; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShaka; });
// Loads Shaka Player on demand instead of bundling it into main.js.
//
// Only the player screen uses Shaka, so bundling it made every other screen pay
// for it — and 2.5.23 is 320 KB, three times the 1.6.5 build the figure behind
// this decision was measured against. A dynamic import() puts it in its own
// webpack chunk, fetched the first time a movie is opened.
//
// Verified on real Cobalt: the chunk loads and the API is present, in 24 ms on
// 11 (the 1.6.5 chunk, on boxes now retired) and 25 ms on 22 (2.5.23, the chunk
// that ships today). Cobalt loads webpack's chunks the same way it loads any
// injected script, which was the open question. Neither number predicts 19: the
// only timing for the shipping chunk came from a box with V8 and JIT, and 19 has
// neither.
//
// One build ships to the whole fleet, shaka-player 2.5.23. There used to be two,
// because the fleet used to be two: 1.6.5 for the Cobalt 11 boxes and 2.5.23 for
// Cobalt 22. Qarva updated the HiSilicon boxes from 11 to 19 (2026-08-20) and
// confirmed 2.5.x runs there, so the 1.x path is gone (CP-2353).
//
// 2.5.23 is not a preference, it is the ceiling: measured on a real Cobalt 22
// box, 3.3.19 cannot resolve a manifest parser, 4.16.42 never resolves attach(),
// and 5.2.2 needs a URL constructor Cobalt does not have.
/**
 * Cobalt's major version, or -1 in a normal browser. Cobalt puts it in the user
 * agent as "Cobalt/<major>.x" — there is no API for it.
 */
var getCobaltMajor = function (userAgent) {
    if (userAgent === void 0) { userAgent = navigator.userAgent || ""; }
    var match = userAgent.match(/Cobalt\/(\d+)/);
    if (!match) {
        return -1;
    }
    return parseInt(match[1], 10);
};
/**
 * What the box reports on window, verbatim. Not always a bare version: some
 * boxes prefix it with a chipset or vendor name. Empty on boxes that predate
 * the attribute and in a desktop browser.
 */
var getStvVersion = function () {
    try {
        return window.STVVersion ? String(window.STVVersion) : "";
    }
    catch (_a) {
        return "";
    }
};
/**
 * Just the version number out of the above, or "" when the field is absent or
 * holds no number at all.
 *
 * Takes the LAST number in the string, not the first: a chipset prefix carries
 * numbers of its own, dotted ones included ("Broadcom 7251.2 19.1.4"), and the
 * version is what trails. A bare major with no dots ("22") still counts — that
 * number is the one thing the loading screen is there to show.
 *
 * `matchAll` would read better and is ES2020; SpiderMonkey 45 does not have it.
 */
var getStvVersionNumber = function () {
    var numbers = getStvVersion().match(/[0-9]+(?:[.][0-9]+)*/g);
    return numbers ? numbers[numbers.length - 1] : "";
};
var pending;
var loaded;
/**
 * Resolves once Shaka is on the page with its polyfills installed. Safe to call
 * repeatedly — the load happens once per session and every later call gets the
 * same promise.
 */
var loadShaka = function () {
    if (loaded) {
        return Promise.resolve(loaded);
    }
    if (pending) {
        return pending;
    }
    // The specifier is a string literal on purpose. webpack builds its chunk list
    // by reading import() calls statically, so a computed specifier would emit no
    // chunk at all and fail at runtime.
    pending = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 204)).then(function (module) {
        var shaka = (module.default ||
            module);
        // Runs once per session, since the cached promise means one load. Doing it
        // here rather than where the player is built keeps it off the episode and
        // quality-change paths.
        shaka.polyfill.installAll();
        loaded = shaka;
        return loaded;
    });
    pending.catch(function () {
        pending = undefined;
    });
    return pending;
};
/**
 * Shaka, for code that already knows it is loaded. Throws rather than returning
 * undefined so a mistake surfaces where it happens instead of as a confusing
 * property access on nothing.
 */
var getShaka = function () {
    if (!loaded) {
        throw new Error("Shaka is not loaded — await loadShaka() first");
    }
    return loaded;
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footerViewStyles_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footerViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footerViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);




var FooterView = function (_a) {
    var _b = _a.simple, simple = _b === void 0 ? false : _b;
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(function () {
        if (simple)
            return;
        if (!ref.current)
            return;
        var defaultMargin = 32;
        ref.current.style.marginTop = defaultMargin + "px";
        void ref.current.offsetHeight;
        var footerBottom = ref.current.offsetTop + ref.current.offsetHeight;
        var container = ref.current.offsetParent;
        var containerTop = container ? container.offsetTop : 0;
        // Layout lives inside the fixed 1080px design stage (App.tsx scales it to
        // the viewport). Measure against the design height, not window.innerHeight,
        // which is device px and would be wrong once the stage is scaled.
        var DESIGN_H = 1080;
        var availableHeight = DESIGN_H - 24 - containerTop;
        if (footerBottom < availableHeight) {
            var extra = availableHeight - footerBottom;
            ref.current.style.marginTop = defaultMargin + extra + "px";
        }
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-container", ref: ref },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "left-container" },
            new Date().getFullYear(),
            " cavea.plus"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "right-container" }, t("footer.rights"))));
};


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SkeletonContentLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movie_MovieItemViewSkeleton__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movie_movieItemViewSkeletonStyles_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movie_movieItemViewSkeletonStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__movie_movieItemViewSkeletonStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter_FilterSkeletons__ = __webpack_require__(150);




var SkeletonContentLayout = function (_a) {
    var _b = _a.showTitle, showTitle = _b === void 0 ? true : _b, _c = _a.skeletonCount, skeletonCount = _c === void 0 ? 6 : _c, _d = _a.isBlockMoviesScreen, isBlockMoviesScreen = _d === void 0 ? false : _d, _e = _a.isMoviesScreen, isMoviesScreen = _e === void 0 ? false : _e;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-container " + (isBlockMoviesScreen && "block-movies-skeleton") },
        isMoviesScreen && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__filter_FilterSkeletons__["a" /* FilterSkeletons */], null),
        showTitle && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "skeleton-header" }),
        Array.from({ length: skeletonCount }).map(function (_, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__movie_MovieItemViewSkeleton__["a" /* MovieItemViewSkeleton */], { key: index })); })));
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(17);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])();
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context__["a" /* I18nContext */]) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || Object(__WEBPACK_IMPORTED_MODULE_3__context__["e" /* getI18n */])();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new __WEBPACK_IMPORTED_MODULE_3__context__["b" /* ReportNamespaces */]();

  if (!i18n) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* warnOnce */])('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* warnOnce */])('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3__context__["d" /* getDefaults */])()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* hasLoadedNamespace */])(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(getT),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(true);
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* loadNamespaces */])(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(true);
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* loadNamespaces */])(i18n, namespaces, function () {
      resolve();
    });
  });
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(96);
var iterableToArrayLimit = __webpack_require__(97);
var unsupportedIterableToArray = __webpack_require__(98);
var nonIterableRest = __webpack_require__(100);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExitModalProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useExitModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_modals_ExitConfirmModal__ = __webpack_require__(105);




var ExitModalContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);
// Any other modal already on screen: InfoModal renders `.modal-container`,
// overlay-based modals render `.modal-overlay`. Don't stack the exit modal
// on top of either.
var otherModalOpen = function () {
    return !!document.querySelector(".modal-container, .modal-overlay");
};
var ExitModalProvider = function (_a) {
    var children = _a.children;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), open = _b[0], setOpen = _b[1];
    // Imperative source of truth so rapid key presses can't double-trigger
    // within the same tick (state updates are async).
    var openRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var openExitModal = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (openRef.current || otherModalOpen())
            return false;
        openRef.current = true;
        __WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "exitModal", index: 0 });
        setOpen(true);
        return true;
    }, []);
    var closeExitModal = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!openRef.current)
            return;
        __WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].popLayer();
        openRef.current = false;
        setOpen(false);
    }, []);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        window.close();
    }, []);
    var isExitModalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () { return openRef.current; }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handleKeyDown = function (e) {
            if (!__WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].isKey(e.keyCode, "EXIT"))
                return;
            if (openExitModal()) {
                e.preventDefault();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
            if (openRef.current) {
                __WEBPACK_IMPORTED_MODULE_1__utils_Focus__["b" /* focusManager */].popLayer();
                openRef.current = false;
            }
        };
    }, [openExitModal]);
    var value = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return ({ openExitModal: openExitModal, isExitModalOpen: isExitModalOpen, otherModalOpen: otherModalOpen }); }, [openExitModal, isExitModalOpen]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExitModalContext.Provider, { value: value },
        children,
        open && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "exit-modal-overlay", tabIndex: 0, className: "modal-overlay", key: "exit-confirm-modal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_views_modals_ExitConfirmModal__["a" /* ExitConfirmModal */], { onClose: closeExitModal, onExit: handleExit })))));
};
var useExitModal = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ExitModalContext);
    if (!context) {
        throw new Error("useExitModal must be used within ExitModalProvider");
    }
    return context;
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var AppContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var appReducer = function (state, action) {
    switch (action.type) {
        case "SET_GENRES":
            localStorage.setItem("genres", JSON.stringify(action.genres));
            return __assign(__assign({}, state), { genres: action.genres });
        case "SET_WELCOME_SHOWN":
            return __assign(__assign({}, state), { welcomeShown: action.welcomeShown });
        default:
            return state;
    }
};
var AppProvider = function (_a) {
    var children = _a.children;
    var genres = localStorage.getItem("genres")
        ? JSON.parse(localStorage.getItem("genres"))
        : [];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(appReducer, {
        genres: genres,
        welcomeShown: false,
    }), state = _b[0], dispatch = _b[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AppContext.Provider, { value: { state: state, dispatch: dispatch } }, children));
};
var useApp = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(AppContext);
    if (!context) {
        throw new Error("useApp must be used within an AppProvider");
    }
    var state = context.state, dispatch = context.dispatch;
    return {
        genres: state.genres,
        welcomeShown: state.welcomeShown,
        dispatch: dispatch,
    };
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguageChangeButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Helpers__ = __webpack_require__(2);



var LanguageChangeButton = function (_a) {
    var focusRaw = _a.focusRaw, _b = _a.authScreen, authScreen = _b === void 0 ? false : _b;
    var _c = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(), t = _c.t, i18n = _c.i18n;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_2__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return i18n.changeLanguage(i18n.language === "ka" ? "en" : "ka"); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { tabIndex: 0, ref: ref, className: "language-change-btn" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, authScreen
            ? t("auth_tv.language-btn")
            : t("layout.languages." + (i18n.language === "ka" ? "en" : "ka")))));
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(5);
var normalizeHeaderName = __webpack_require__(126);
var AxiosError = __webpack_require__(9);
var transitionalDefaults = __webpack_require__(53);
var toFormData = __webpack_require__(54);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(138)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieRowView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MovieItemView__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__block_movieBlockViewStyles_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__block_movieBlockViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__block_movieBlockViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Focus__ = __webpack_require__(3);





var MovieRowView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var index = _a.index, movies = _a.movies, onMoviePress = _a.onMoviePress, onKeyBack = _a.onKeyBack, _b = _a.hasHorizontalScroll, hasHorizontalScroll = _b === void 0 ? true : _b, _c = _a.active, active = _c === void 0 ? true : _c;
    var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (hasHorizontalScroll && containerRef.current) {
            __WEBPACK_IMPORTED_MODULE_3__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "row-" + index,
                horizontalContainer: containerRef.current,
            });
        }
    }, [index, hasHorizontalScroll]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "movie-row-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: containerRef, className: "block-movies-container" }, movies.map(function (m, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__MovieItemView__["a" /* MovieItemView */], { focusRaw: ["row-" + index, i], key: i + "-" + m.id, movie: m, active: active, onMoviePress: onMoviePress, onKeyBack: onKeyBack })); }))));
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProgresStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLastPlayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNextEpisode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_service__ = __webpack_require__(65);

var generateSource = function (mappers, quality) {
    if (quality === void 0) { quality = "SD"; }
    var source = {
        src: "",
        license: "",
    };
    var mapper = mappers.find(function (item) { return item.quality === quality && item.drm === "none"; });
    if (!mapper) {
        console.log("Mapper not found");
        return;
    }
    source.src = "/api/v1/stream/" + mapper.id + "/";
    return source;
};
var getProgresStats = function (videoRef, oldState) {
    if (!videoRef) {
        return;
    }
    var currentTimeSeconds = videoRef.currentTime;
    var durationSeconds = videoRef.duration;
    var currentHours = Math.floor(currentTimeSeconds / 3600);
    var currentMinutes = Math.floor((currentTimeSeconds % 3600) / 60);
    var currentSeconds = Math.floor(currentTimeSeconds % 60);
    var formatTime = function (hours, minutes, seconds) {
        var paddedMinutes = minutes < 10 ? "0" + minutes : minutes;
        var paddedSeconds = seconds < 10 ? "0" + seconds : seconds;
        return hours > 0
            ? hours + ":" + paddedMinutes + ":" + paddedSeconds
            : minutes + ":" + paddedSeconds;
    };
    var timeLeftSeconds = durationSeconds - currentTimeSeconds;
    var leftHours = Math.floor(timeLeftSeconds / 3600);
    var leftMinutes = Math.floor((timeLeftSeconds % 3600) / 60);
    var leftSeconds = Math.floor(timeLeftSeconds % 60);
    var progress = durationSeconds > 0 ? currentTimeSeconds / durationSeconds : 0;
    return {
        timeLeftSide: formatTime(currentHours, currentMinutes, currentSeconds),
        timeRightSide: formatTime(leftHours, leftMinutes, leftSeconds),
        progress: progress,
    };
};
var updateProgress = function (videoRef, playerState) {
    var segments = getPlayedSegments(videoRef, playerState.playedSegments);
    var data = {
        movieId: playerState.movieId,
        episodeId: playerState.episodeId,
        profileId: playerState.profileId,
        progress: playerState.progress,
        language: playerState.language,
        caption: playerState.caption,
        currentTime: videoRef.current.currentTime,
        quality: playerState.quality,
        origin: "silk",
        watchSessionId: playerState.watchSessionId,
        playedSegments: segments,
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__services_player_service__["c" /* saveProgress */])(data);
};
var getPlayedSegments = function (videoRef, playedSegments) {
    var timeRanges = videoRef.current.played;
    var result = [];
    for (var i = 0; i < timeRanges.length; i++) {
        result.push(timeRanges.start(i) + " " + timeRanges.end(i));
    }
    var merged = playedSegments.concat(result);
    var deduplicatedSegments = Array.from(new Set(merged));
    return deduplicatedSegments;
};
var getLastPlayed = function (episodes) {
    if (!episodes || episodes.length === 0) {
        return;
    }
    return episodes
        .map(function (episode) {
        if (episode.watchHistory && episode.watchHistory.updatedAt) {
            episode.watchHistory.updatedAt = new Date(episode.watchHistory.updatedAt);
        }
        return episode;
    })
        .reduce(function (lastWatchedEpisode, currentEpisode) {
        if (currentEpisode.watchHistory &&
            !currentEpisode.watchHistory.updatedAt) {
            return lastWatchedEpisode;
        }
        if (lastWatchedEpisode.watchHistory &&
            !lastWatchedEpisode.watchHistory.updatedAt) {
            return currentEpisode;
        }
        if (currentEpisode.watchHistory && lastWatchedEpisode.watchHistory) {
            if (currentEpisode.watchHistory.updatedAt >
                lastWatchedEpisode.watchHistory.updatedAt) {
                return currentEpisode;
            }
        }
        return lastWatchedEpisode;
    });
};
var getNextEpisode = function (episodes, id) {
    var index = episodes.findIndex(function (episode) { return episode.id === id; });
    var nextEpisode = episodes[index + 1];
    if (nextEpisode && nextEpisode.status !== "CS") {
        return { isLast: false, id: nextEpisode.id };
    }
    return { isLast: true };
};


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerStateProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return usePlayerStateActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return usePlayerStateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var initalState = {
    progress: 0,
    timeLeftSide: "--:--",
    timeRightSide: "--:--",
};
var StateContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(initalState);
var ActionsContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var PlayerStateReducer = function (state, action) {
    switch (action.type) {
        case "UPDATE_PROGRESS":
            return __assign(__assign({}, state), { progress: action.progress, timeLeftSide: action.timeLeftSide, timeRightSide: action.timeRightSide });
        default:
            return state;
    }
};
var PlayerStateProvider = function (_a) {
    var children = _a.children;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(PlayerStateReducer, initalState), state = _b[0], dispatch = _b[1];
    var actions = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return ({
        updateStateProgress: function (progress, timeLeftSide, timeRightSide) {
            return dispatch({
                type: "UPDATE_PROGRESS",
                progress: progress,
                timeLeftSide: timeLeftSide,
                timeRightSide: timeRightSide,
            });
        },
    }); }, [dispatch]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActionsContext.Provider, { value: actions },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StateContext.Provider, { value: state }, children)));
};
var usePlayerStateActions = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ActionsContext);
    if (!context)
        throw new Error("usePlayerStateActions must be used within Provider");
    return context;
};
var usePlayerStateData = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(StateContext);
    if (!context)
        throw new Error("usePlayerStateData must be used within Provider");
    return context;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(75);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RootProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(38);




function RootProvider(_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* AuthProvider */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__App__["a" /* AppProvider */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* RouterProvider */], null, children))));
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(34)["default"];
var toPrimitive = __webpack_require__(90);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSSR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(7);


function useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context__["a" /* I18nContext */]) || {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || Object(__WEBPACK_IMPORTED_MODULE_1__context__["e" /* getI18n */])();
  if (i18n.options && i18n.options.isClone) return;

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MovieLanguageEnum */
/* unused harmony export MPAARating */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieStatusEnum; });
/* unused harmony export MovieTypeEnum */
/* unused harmony export MoviesTypeEnum */
/* unused harmony export MovieDistributorsEnum */
var MovieLanguageEnum;
(function (MovieLanguageEnum) {
    MovieLanguageEnum["Eng"] = "ENG";
    MovieLanguageEnum["Rus"] = "RUS";
    MovieLanguageEnum["Geo"] = "GEO";
})(MovieLanguageEnum || (MovieLanguageEnum = {}));
var MPAARating;
(function (MPAARating) {
    MPAARating["G"] = "G";
    MPAARating["PG"] = "PG";
    MPAARating["PG13"] = "PG-13";
    MPAARating["R"] = "R";
})(MPAARating || (MPAARating = {}));
var MovieStatusEnum;
(function (MovieStatusEnum) {
    MovieStatusEnum["AV"] = "AV";
    MovieStatusEnum["CS"] = "CS";
    MovieStatusEnum["HI"] = "HI";
})(MovieStatusEnum || (MovieStatusEnum = {}));
var MovieTypeEnum;
(function (MovieTypeEnum) {
    MovieTypeEnum["Avod"] = "AVOD";
    MovieTypeEnum["Est"] = "EST";
    MovieTypeEnum["Svod"] = "SVOD";
})(MovieTypeEnum || (MovieTypeEnum = {}));
var MoviesTypeEnum;
(function (MoviesTypeEnum) {
    MoviesTypeEnum["Movie"] = "movie";
    MoviesTypeEnum["Series"] = "series";
})(MoviesTypeEnum || (MoviesTypeEnum = {}));
var MovieDistributorsEnum;
(function (MovieDistributorsEnum) {
    MovieDistributorsEnum["Amedia"] = "amedia";
})(MovieDistributorsEnum || (MovieDistributorsEnum = {}));


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExitButtonView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);




var ExitButtonView = function (_a) {
    var onExit = _a.onExit, onClose = _a.onClose, closeLabel = _a.closeLabel, exitLabel = _a.exitLabel;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    var closeRef = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "exitModal",
        index: 0,
        onKeyDown: onClose,
        onKeyBack: onClose,
    });
    var exitRef = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "exitModal",
        index: 1,
        onKeyDown: onExit,
        onKeyBack: onClose,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "btn-container", id: "exit-confirm-modal" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { tabIndex: 0, ref: closeRef, className: "purple-border-btn" }, closeLabel || t("modal.close")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { tabIndex: 0, ref: exitRef, className: "purple-border-btn" }, exitLabel || t("modal.exit"))));
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MovieTagView__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MoviePoster__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MovieLabelView__ = __webpack_require__(116);







var MovieItemView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var focusRaw = _a.focusRaw, movie = _a.movie, _b = _a.active, active = _b === void 0 ? true : _b, onMoviePress = _a.onMoviePress, onKeyBack = _a.onKeyBack;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_2__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onMoviePress(movie); },
        onKeyBack: onKeyBack,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { tabIndex: 0, ref: ref, className: "movie-card-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MoviePoster__["a" /* MoviePoster */], { url: movie.poster, active: active }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "movie-title" }, movie.name),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "rating" }, movie.mpaaRating),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MovieTagView__["a" /* MovieTagView */], { movie: movie }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__MovieLabelView__["a" /* MovieLabelView */], { movie: movie })));
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(5);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127).Buffer))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var settle = __webpack_require__(131);
var cookies = __webpack_require__(132);
var buildURL = __webpack_require__(52);
var buildFullPath = __webpack_require__(56);
var parseHeaders = __webpack_require__(135);
var isURLSameOrigin = __webpack_require__(136);
var transitionalDefaults = __webpack_require__(53);
var AxiosError = __webpack_require__(9);
var CanceledError = __webpack_require__(24);
var parseProtocol = __webpack_require__(137);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(133);
var combineURLs = __webpack_require__(134);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fromMoviesDTO; });
/* unused harmony export fromMovieDTO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromContinueWatchingDTO; });
var fromMoviesDTO = function (movies) {
    if (movies) {
        return movies.map(function (movie) {
            return fromMovieDTO(movie);
        });
    }
    return [];
};
var fromMovieDTO = function (movie) {
    if (movie.poster && movie.poster.includes("https://")) {
        movie.poster = "" + movie.poster;
    }
    else {
        movie.poster = ("" + "https://devtv.cavea.plus/assets" + movie.poster).replace("..", "");
    }
    if (movie.banner && movie.banner.includes("https://")) {
        movie.banner = "" + movie.banner;
    }
    else {
        movie.banner = ("" + "https://devtv.cavea.plus/assets" + movie.banner).replace("..", "");
    }
    if (movie.movieType === "series" &&
        movie.episodes &&
        movie.episodes.length > 0) {
        movie.episodes = movie.episodes.map(function (episode) {
            if (episode.thumbnail) {
                if (episode.thumbnail.includes("https://")) {
                    episode.thumbnail = "" + episode.thumbnail;
                }
                else {
                    episode.thumbnail =
                        ("" + "https://devtv.cavea.plus/assets" + episode.thumbnail).replace("..", "");
                }
            }
            return episode;
        });
    }
    return movie;
};
var fromContinueWatchingDTO = function (items) {
    return items.map(function (item) {
        if (item && item.movie && item.movie.poster.includes("https://")) {
            item.movie.poster = "" + item.movie.poster;
        }
        else if (item && item.movie && item.movie.poster) {
            item.movie.poster =
                ("" + "https://devtv.cavea.plus/assets" + item.movie.poster).replace("..", "");
        }
        return item;
    });
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMovie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEpisode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DTOs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(66);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var saveProgress = function (watchProgress) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "progress";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* postRequest */])(url, watchProgress)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var getMovie = function (movieSlug) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "movies/" + movieSlug;
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, {
                        lang: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].language,
                    })];
            case 1:
                data = (_a.sent()).data;
                if (data) {
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__DTOs__["b" /* fromMoviesDTO */])([data])[0]];
                }
                return [2 /*return*/];
        }
    });
}); };
var getEpisode = function (episodeId, profileId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "episodes/" + episodeId;
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getRequest */])(url, {
                        profileId: profileId,
                        lang: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].language,
                    })];
            case 1:
                data = (_a.sent()).data;
                if (data) {
                    return [2 /*return*/, data];
                }
                return [2 /*return*/];
        }
    });
}); };


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ka_json__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ka_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ka_json__);




__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* initReactI18next */]).init({
    resources: {
        en: { translation: __WEBPACK_IMPORTED_MODULE_2__en_json___default.a },
        ka: { translation: __WEBPACK_IMPORTED_MODULE_3__ka_json___default.a },
    },
    lng: "ka",
    fallbackLng: "ka",
    interpolation: {
        escapeValue: false,
    },
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPropertyKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(179);


function toPropertyKey(t) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : i + "";
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingSpinnerStyle_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingSpinnerStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LoadingSpinnerStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);



var LoadingSpinner = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "spinner-wrapper" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "spinner-element" }, t("player.loading"))));
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerErrorMessageProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return usePlayerErrorMessageActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return usePlayerErrorMessageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var initialState = {
    message: "",
    type: "",
    returnMessage: "",
    returnRoute: "",
};
var StateContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var ActionsContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var playerErrorMessageReducer = function (state, action) {
    switch (action.type) {
        case "SHOW":
            return __assign(__assign({}, state), { message: action.message, type: action.messageType });
        case "HIDE":
            return __assign(__assign({}, state), { message: "", type: "" });
        case "RETURN_TO":
            return __assign(__assign({}, state), { returnRoute: action.route, returnMessage: action.returnMessage });
        default:
            return state;
    }
};
var PlayerErrorMessageProvider = function (_a) {
    var children = _a.children;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(playerErrorMessageReducer, initialState), state = _b[0], dispatch = _b[1];
    var timeoutRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var actions = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return ({
        show: function (message, type, duration) {
            if (duration === void 0) { duration = 1000; }
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            dispatch({ type: "SHOW", message: message, messageType: type });
            if (duration) {
                timeoutRef.current = setTimeout(function () {
                    dispatch({ type: "HIDE" });
                }, duration);
            }
        },
        hide: function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            dispatch({ type: "HIDE" });
        },
        returnTo: function (route, returnMessage) {
            dispatch({ type: "RETURN_TO", route: route, returnMessage: returnMessage });
        },
        hasMessage: function () { return !!(state.message && state.message.length); },
    }); }, [dispatch, state.message]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActionsContext.Provider, { value: actions },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StateContext.Provider, { value: state }, children)));
};
var usePlayerErrorMessageActions = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ActionsContext);
    if (!context)
        throw new Error("usePlayerErrorMessageActions must be used within Provider");
    return context;
};
var usePlayerErrorMessageData = function () {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(StateContext);
    if (!context)
        throw new Error("usePlayerErrorMessageData must be used within Provider");
    return context;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73);
module.exports = __webpack_require__(78);


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(74).enable();
  window.Promise = __webpack_require__(76);
}

// fetch() polyfill for making API calls.
__webpack_require__(77);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(33);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(44);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(44);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyRenderer_ts__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polyfills_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polyfills_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__polyfills_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_RootProvider__ = __webpack_require__(45);
// eslint-disable-next-line no-unused-vars
__WEBPACK_IMPORTED_MODULE_1__MyRenderer_ts__["a" /* default */].render(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__context_RootProvider__["a" /* RootProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null)),document.getElementById("root"));

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(33),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_reconciler__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_reconciler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_reconciler__);

function applyProps(domElement, props, oldProps) {
    if (oldProps === void 0) { oldProps = {}; }
    Object.keys(oldProps).forEach(function (key) {
        var oldVal = oldProps[key];
        if (key.startsWith("on") && typeof oldVal === "function") {
            var eventType = key.slice(2).toLowerCase();
            domElement.removeEventListener(eventType, oldVal);
        }
    });
    Object.keys(props).forEach(function (key) {
        var value = props[key];
        if (oldProps[key] === value)
            return;
        if (key.startsWith("on") && typeof value === "function") {
            var eventType = key.slice(2).toLowerCase();
            domElement.addEventListener(eventType, value);
            return;
        }
        if (key === "className") {
            domElement.setAttribute("class", value);
            return;
        }
        if (key === "css") {
            if (typeof value === "object") {
                var styleString = Object.entries(value)
                    .map(function (_a) {
                    var styleKey = _a[0], styleVal = _a[1];
                    var cssKey = styleKey.replace(/([A-Z])/g, "-$1").toLowerCase();
                    var cssValue = typeof styleVal === "number" ? styleVal + "px" : styleVal;
                    return cssKey + ": " + cssValue;
                })
                    .join("; ");
                domElement.setAttribute("style", styleString);
            }
            else {
                domElement.setAttribute("style", value);
            }
            return;
        }
        if (key === "children") {
            if (typeof value === "string" || typeof value === "number") {
                domElement.textContent = value + "";
            }
            return;
        }
        domElement.setAttribute(key, value);
    });
}
var hostConfig = {
    now: Date.now,
    supportsMutation: true,
    getRootHostContext: function () { return ({}); },
    getChildHostContext: function () { return ({}); },
    prepareForCommit: function () { },
    resetAfterCommit: function () { },
    shouldSetTextContent: function (type, props) {
        return typeof props.children === "string" || typeof props.children === "number";
    },
    createInstance: function (type, props, rootContainerInstance, _currentHostContext, workInProgress) {
        var domElement = document.createElement(type);
        applyProps(domElement, props);
        return domElement;
    },
    createTextInstance: function (text) { return document.createTextNode(text); },
    appendInitialChild: function (parent, child) { return parent.appendChild(child); },
    appendChild: function (parent, child) { return parent.appendChild(child); },
    appendChildToContainer: function (parent, child) { return parent.appendChild(child); },
    removeChild: function (parent, child) { return parent.removeChild(child); },
    removeChildFromContainer: function (parent, child) { return parent.removeChild(child); },
    commitTextUpdate: function (textInstance, oldText, newText) {
        textInstance.textContent = newText;
    },
    prepareUpdate: function (domElement, oldProps, newProps) { return true; },
    commitUpdate: function (domElement, updatePayload, type, oldProps, newProps) {
        applyProps(domElement, newProps, oldProps);
    },
    finalizeInitialChildren: function () { return false; },
    resetTextContent: function () { },
    getPublicInstance: function (instance) { return instance; },
    insertBefore: function (parent, child, beforeChild) {
        return parent.insertBefore(child, beforeChild);
    },
};
function traceWrap(hostConfig) {
    var wrapped = {};
    Object.keys(hostConfig).forEach(function (key) {
        var func = hostConfig[key];
        wrapped[key] =
            typeof func === "function" ? function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return func.apply(void 0, args);
            } : hostConfig[key];
    });
    return wrapped;
}
var ReactReconcilerInst = __WEBPACK_IMPORTED_MODULE_0_react_reconciler___default()(traceWrap(hostConfig));
/* harmony default export */ __webpack_exports__["a"] = ({
    render: function (reactElement, domElement, callback) {
        // Create a root Container if it doesnt exist
        if (!domElement._rootContainer) {
            domElement._rootContainer = ReactReconcilerInst.createContainer(domElement, false);
        }
        // update the root Container
        return ReactReconcilerInst.updateContainer(reactElement, domElement._rootContainer, null, callback);
    },
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(82);
} else {
  module.exports = require('./cjs/react-reconciler.development.js');
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/** @license React v0.25.1
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
module.exports = function $$$reconciler($$$hostConfig) {
'use strict';var aa=__webpack_require__(33),ba=__webpack_require__(0),m=__webpack_require__(84);function n(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var p=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
p.hasOwnProperty("ReactCurrentDispatcher")||(p.ReactCurrentDispatcher={current:null});p.hasOwnProperty("ReactCurrentBatchConfig")||(p.ReactCurrentBatchConfig={suspense:null});
var u="function"===typeof Symbol&&Symbol.for,ca=u?Symbol.for("react.element"):60103,da=u?Symbol.for("react.portal"):60106,ea=u?Symbol.for("react.fragment"):60107,fa=u?Symbol.for("react.strict_mode"):60108,ha=u?Symbol.for("react.profiler"):60114,ia=u?Symbol.for("react.provider"):60109,ja=u?Symbol.for("react.context"):60110,ka=u?Symbol.for("react.concurrent_mode"):60111,la=u?Symbol.for("react.forward_ref"):60112,ma=u?Symbol.for("react.suspense"):60113,na=u?Symbol.for("react.suspense_list"):60120,oa=
u?Symbol.for("react.memo"):60115,pa=u?Symbol.for("react.lazy"):60116,qa=u?Symbol.for("react.block"):60121,ra="function"===typeof Symbol&&Symbol.iterator;function sa(a){if(null===a||"object"!==typeof a)return null;a=ra&&a[ra]||a["@@iterator"];return"function"===typeof a?a:null}function ta(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function ua(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ea:return"Fragment";case da:return"Portal";case ha:return"Profiler";case fa:return"StrictMode";case ma:return"Suspense";case na:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ja:return"Context.Consumer";case ia:return"Context.Provider";case la:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case oa:return ua(a.type);case qa:return ua(a.render);case pa:if(a=1===a._status?a._result:null)return ua(a)}return null}function va(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function wa(a){if(va(a)!==a)throw Error(n(188));}
function xa(a){var b=a.alternate;if(!b){b=va(a);if(null===b)throw Error(n(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return wa(e),a;if(f===d)return wa(e),b;f=f.sibling}throw Error(n(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(n(189));}}if(c.alternate!==d)throw Error(n(190));}if(3!==c.tag)throw Error(n(188));return c.stateNode.current===c?a:b}function ya(a){a=xa(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function za(a){a=xa(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var Aa=$$$hostConfig.getPublicInstance,Ba=$$$hostConfig.getRootHostContext,Ca=$$$hostConfig.getChildHostContext,Da=$$$hostConfig.prepareForCommit,Ea=$$$hostConfig.resetAfterCommit,Fa=$$$hostConfig.createInstance,Ga=$$$hostConfig.appendInitialChild,Ha=$$$hostConfig.finalizeInitialChildren,Ia=$$$hostConfig.prepareUpdate,Ja=$$$hostConfig.shouldSetTextContent,Ka=$$$hostConfig.shouldDeprioritizeSubtree,La=$$$hostConfig.createTextInstance,Ma=$$$hostConfig.setTimeout,Na=$$$hostConfig.clearTimeout,Oa=$$$hostConfig.noTimeout,
Pa=$$$hostConfig.isPrimaryRenderer,Qa=$$$hostConfig.supportsMutation,Ra=$$$hostConfig.supportsPersistence,Sa=$$$hostConfig.supportsHydration,Ta=$$$hostConfig.appendChild,Ua=$$$hostConfig.appendChildToContainer,Va=$$$hostConfig.commitTextUpdate,Wa=$$$hostConfig.commitMount,Xa=$$$hostConfig.commitUpdate,Ya=$$$hostConfig.insertBefore,Za=$$$hostConfig.insertInContainerBefore,$a=$$$hostConfig.removeChild,ab=$$$hostConfig.removeChildFromContainer,bb=$$$hostConfig.resetTextContent,cb=$$$hostConfig.hideInstance,
db=$$$hostConfig.hideTextInstance,eb=$$$hostConfig.unhideInstance,fb=$$$hostConfig.unhideTextInstance,gb=$$$hostConfig.cloneInstance,hb=$$$hostConfig.createContainerChildSet,ib=$$$hostConfig.appendChildToContainerChildSet,jb=$$$hostConfig.finalizeContainerChildren,kb=$$$hostConfig.replaceContainerChildren,lb=$$$hostConfig.cloneHiddenInstance,mb=$$$hostConfig.cloneHiddenTextInstance,nb=$$$hostConfig.canHydrateInstance,ob=$$$hostConfig.canHydrateTextInstance,pb=$$$hostConfig.isSuspenseInstancePending,
qb=$$$hostConfig.isSuspenseInstanceFallback,rb=$$$hostConfig.getNextHydratableSibling,sb=$$$hostConfig.getFirstHydratableChild,tb=$$$hostConfig.hydrateInstance,ub=$$$hostConfig.hydrateTextInstance,vb=$$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance,wb=$$$hostConfig.commitHydratedContainer,xb=$$$hostConfig.commitHydratedSuspenseInstance,yb=/^(.*)[\\\/]/;
function zb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ua(a.type);c=null;d&&(c=ua(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ab=[],Bb=-1;function B(a){0>Bb||(a.current=Ab[Bb],Ab[Bb]=null,Bb--)}function C(a,b){Bb++;Ab[Bb]=a.current;a.current=b}
var Cb={},D={current:Cb},E={current:!1},Db=Cb;function Eb(a,b){var c=a.type.contextTypes;if(!c)return Cb;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function F(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Fb(){B(E);B(D)}
function Gb(a,b,c){if(D.current!==Cb)throw Error(n(168));C(D,b);C(E,c)}function Hb(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(n(108,ua(b)||"Unknown",e));return aa({},c,{},d)}function Ib(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cb;Db=D.current;C(D,a);C(E,E.current);return!0}
function Jb(a,b,c){var d=a.stateNode;if(!d)throw Error(n(169));c?(a=Hb(a,b,Db),d.__reactInternalMemoizedMergedChildContext=a,B(E),B(D),C(D,a)):B(E);C(E,c)}
var Kb=m.unstable_runWithPriority,Lb=m.unstable_scheduleCallback,Mb=m.unstable_cancelCallback,Nb=m.unstable_requestPaint,Ob=m.unstable_now,Pb=m.unstable_getCurrentPriorityLevel,Qb=m.unstable_ImmediatePriority,Rb=m.unstable_UserBlockingPriority,Sb=m.unstable_NormalPriority,Tb=m.unstable_LowPriority,Ub=m.unstable_IdlePriority,Vb={},Wb=m.unstable_shouldYield,Xb=void 0!==Nb?Nb:function(){},Yb=null,Zb=null,$b=!1,ac=Ob(),G=1E4>ac?Ob:function(){return Ob()-ac};
function bc(){switch(Pb()){case Qb:return 99;case Rb:return 98;case Sb:return 97;case Tb:return 96;case Ub:return 95;default:throw Error(n(332));}}function cc(a){switch(a){case 99:return Qb;case 98:return Rb;case 97:return Sb;case 96:return Tb;case 95:return Ub;default:throw Error(n(332));}}function dc(a,b){a=cc(a);return Kb(a,b)}function ec(a,b,c){a=cc(a);return Lb(a,b,c)}function fc(a){null===Yb?(Yb=[a],Zb=Lb(Qb,gc)):Yb.push(a);return Vb}function H(){if(null!==Zb){var a=Zb;Zb=null;Mb(a)}gc()}
function gc(){if(!$b&&null!==Yb){$b=!0;var a=0;try{var b=Yb;dc(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Yb=null}catch(c){throw null!==Yb&&(Yb=Yb.slice(a+1)),Lb(Qb,H),c;}finally{$b=!1}}}function hc(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ic(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var jc="function"===typeof Object.is?Object.is:ic,kc=Object.prototype.hasOwnProperty;
function lc(a,b){if(jc(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!kc.call(b,c[d])||!jc(a[c[d]],b[c[d]]))return!1;return!0}function mc(a,b){if(a&&a.defaultProps){b=aa({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var nc={current:null},oc=null,pc=null,qc=null;function rc(){qc=pc=oc=null}
function sc(a,b){a=a.type._context;Pa?(C(nc,a._currentValue),a._currentValue=b):(C(nc,a._currentValue2),a._currentValue2=b)}function tc(a){var b=nc.current;B(nc);a=a.type._context;Pa?a._currentValue=b:a._currentValue2=b}function uc(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vc(a,b){oc=a;qc=pc=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wc=!0),a.firstContext=null)}function I(a,b){if(qc!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qc=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pc){if(null===oc)throw Error(n(308));pc=b;oc.dependencies={expirationTime:0,firstContext:b,responders:null}}else pc=pc.next=b}return Pa?a._currentValue:a._currentValue2}var xc=!1;
function yc(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}function zc(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function Ac(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function Bc(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Cc(a,b){var c=a.alternate;null!==c&&zc(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function Dc(a,b,c,d){var e=a.updateQueue;xc=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,q=null,r=null,w=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var Q={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===w?(r=w=Q,
q=k):w=w.next=Q;g>l&&(l=g)}else{null!==w&&(w=w.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ec(g,z.suspenseConfig);a:{var A=a,v=z;g=b;Q=c;switch(v.tag){case 1:A=v.payload;if("function"===typeof A){k=A.call(Q,k,g);break a}k=A;break a;case 3:A.effectTag=A.effectTag&-4097|64;case 0:A=v.payload;g="function"===typeof A?A.call(Q,k,g):A;if(null===g||void 0===g)break a;k=aa({},k,g);break a;case 2:xc=!0}}null!==z.callback&&(a.effectTag|=
32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===w?q=k:w.next=r;e.baseState=q;e.baseQueue=w;Gc(l);a.expirationTime=l;a.memoizedState=k}}function Hc(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(n(191,d));d.call(e)}}}
var Ic=p.ReactCurrentBatchConfig,Jc=(new ba.Component).refs;function Kc(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:aa({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Oc={isMounted:function(a){return(a=a._reactInternalFiber)?va(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Lc(),e=Ic.suspense;d=Mc(d,a,e);e=Ac(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Bc(a,e);Nc(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Lc(),e=Ic.suspense;d=Mc(d,a,e);e=Ac(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Bc(a,e);Nc(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Lc(),d=Ic.suspense;
c=Mc(c,a,d);d=Ac(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Bc(a,d);Nc(a,c)}};function Pc(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!lc(c,d)||!lc(e,f):!0}
function Qc(a,b,c){var d=!1,e=Cb;var f=b.contextType;"object"===typeof f&&null!==f?f=I(f):(e=F(b)?Db:D.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Eb(a,e):Cb);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Oc;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Rc(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Oc.enqueueReplaceState(b,b.state,null)}
function Sc(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Jc;yc(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=I(f):(f=F(b)?Db:D.current,e.context=Eb(a,f));Dc(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Kc(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Oc.enqueueReplaceState(e,e.state,null),Dc(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Tc=Array.isArray;
function Uc(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(n(309));var d=c.stateNode}if(!d)throw Error(n(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Jc&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(n(284));if(!c._owner)throw Error(n(290,a));}return a}
function Vc(a,b){if("textarea"!==a.type)throw Error(n(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Wc(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(b,a){for(b=new Map;null!==a;)null!==a.key?b.set(a.key,a):b.set(a.index,a),a=a.sibling;return b}function e(a,b){a=Xc(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(b,a,c,d){if(null===a||6!==a.tag)return a=Yc(c,b.mode,d),a.return=b,a;a=e(a,c);a.return=b;return a}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Uc(a,b,c),d.return=a,d;d=Zc(c.type,c.key,c.props,null,a.mode,d);d.ref=Uc(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=$c(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function q(b,a,c,d,f){if(null===a||7!==a.tag)return a=ad(c,b.mode,d,f),a.return=b,a;a=e(a,c);a.return=b;return a}function r(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Yc(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ca:return c=Zc(b.type,b.key,b.props,null,a.mode,c),c.ref=Uc(a,null,b),c.return=a,c;case da:return b=$c(b,a.mode,c),b.return=a,b}if(Tc(b)||
sa(b))return b=ad(b,a.mode,c,null),b.return=a,b;Vc(a,b)}return null}function w(b,a,c,d){var e=null!==a?a.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(b,a,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ca:return c.key===e?c.type===ea?q(b,a,c.props.children,d,e):k(b,a,c,d):null;case da:return c.key===e?l(b,a,c,d):null}if(Tc(c)||sa(c))return null!==e?null:q(b,a,c,d,null);Vc(b,c)}return null}function z(b,a,c,d,e){if("string"===typeof d||"number"===typeof d)return b=
b.get(c)||null,h(a,b,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ca:return b=b.get(null===d.key?c:d.key)||null,d.type===ea?q(a,b,d.props.children,e,d.key):k(a,b,d,e);case da:return b=b.get(null===d.key?c:d.key)||null,l(a,b,d,e)}if(Tc(d)||sa(d))return b=b.get(c)||null,q(a,b,d,e,null);Vc(a,d)}return null}function Q(e,g,h,k){for(var l=null,v=null,t=g,x=g=0,q=null;null!==t&&x<h.length;x++){t.index>x?(q=t,t=null):q=t.sibling;var y=w(e,t,h[x],k);if(null===y){null===t&&(t=q);break}a&&
t&&null===y.alternate&&b(e,t);g=f(y,g,x);null===v?l=y:v.sibling=y;v=y;t=q}if(x===h.length)return c(e,t),l;if(null===t){for(;x<h.length;x++)t=r(e,h[x],k),null!==t&&(g=f(t,g,x),null===v?l=t:v.sibling=t,v=t);return l}for(t=d(e,t);x<h.length;x++)q=z(t,e,x,h[x],k),null!==q&&(a&&null!==q.alternate&&t.delete(null===q.key?x:q.key),g=f(q,g,x),null===v?l=q:v.sibling=q,v=q);a&&t.forEach(function(a){return b(e,a)});return l}function A(e,g,h,k){var t=sa(h);if("function"!==typeof t)throw Error(n(150));h=t.call(h);
if(null==h)throw Error(n(151));for(var l=t=null,v=g,x=g=0,q=null,y=h.next();null!==v&&!y.done;x++,y=h.next()){v.index>x?(q=v,v=null):q=v.sibling;var A=w(e,v,y.value,k);if(null===A){null===v&&(v=q);break}a&&v&&null===A.alternate&&b(e,v);g=f(A,g,x);null===l?t=A:l.sibling=A;l=A;v=q}if(y.done)return c(e,v),t;if(null===v){for(;!y.done;x++,y=h.next())y=r(e,y.value,k),null!==y&&(g=f(y,g,x),null===l?t=y:l.sibling=y,l=y);return t}for(v=d(e,v);!y.done;x++,y=h.next())y=z(v,e,x,y.value,k),null!==y&&(a&&null!==
y.alternate&&v.delete(null===y.key?x:y.key),g=f(y,g,x),null===l?t=y:l.sibling=y,l=y);a&&v.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ea&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ca:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ea){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Uc(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ea?(d=ad(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Zc(f.type,f.key,f.props,null,a.mode,h),h.ref=Uc(a,d,f),h.return=a,a=h)}return g(a);case da:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=$c(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Yc(f,a.mode,h),d.return=a,a=d),g(a);if(Tc(f))return Q(a,d,f,h);if(sa(f))return A(a,d,f,h);l&&Vc(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(n(152,a.displayName||a.name||"Component"));}return c(a,d)}}var bd=Wc(!0),cd=Wc(!1),dd={},J={current:dd},ed={current:dd},fd={current:dd};
function gd(a){if(a===dd)throw Error(n(174));return a}function hd(a,b){C(fd,b);C(ed,a);C(J,dd);a=Ba(b);B(J);C(J,a)}function id(){B(J);B(ed);B(fd)}function jd(a){var b=gd(fd.current),c=gd(J.current);b=Ca(c,a.type,b);c!==b&&(C(ed,a),C(J,b))}function kd(a){ed.current===a&&(B(J),B(ed))}var K={current:0};
function ld(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||pb(c)||qb(c)))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function md(a,b){return{responder:a,props:b}}
var nd=p.ReactCurrentDispatcher,L=p.ReactCurrentBatchConfig,od=0,M=null,N=null,O=null,pd=!1;function P(){throw Error(n(321));}function qd(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!jc(a[c],b[c]))return!1;return!0}
function rd(a,b,c,d,e,f){od=f;M=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;nd.current=null===a||null===a.memoizedState?sd:td;a=c(d,e);if(b.expirationTime===od){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(n(301));f+=1;O=N=null;b.updateQueue=null;nd.current=ud;a=c(d,e)}while(b.expirationTime===od)}nd.current=vd;b=null!==N&&null!==N.next;od=0;O=N=M=null;pd=!1;if(b)throw Error(n(300));return a}
function wd(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===O?M.memoizedState=O=a:O=O.next=a;return O}function xd(){if(null===N){var a=M.alternate;a=null!==a?a.memoizedState:null}else a=N.next;var b=null===O?M.memoizedState:O.next;if(null!==b)O=b,N=a;else{if(null===a)throw Error(n(310));N=a;a={memoizedState:N.memoizedState,baseState:N.baseState,baseQueue:N.baseQueue,queue:N.queue,next:null};null===O?M.memoizedState=O=a:O=O.next=a}return O}
function yd(a,b){return"function"===typeof b?b(a):b}
function zd(a){var b=xd(),c=b.queue;if(null===c)throw Error(n(311));c.lastRenderedReducer=a;var d=N,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<od){var q={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=q,f=d):h=h.next=q;l>M.expirationTime&&
(M.expirationTime=l,Gc(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ec(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;jc(d,b.memoizedState)||(wc=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Ad(a){var b=xd(),c=b.queue;if(null===c)throw Error(n(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);jc(f,b.memoizedState)||(wc=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Bd(a){var b=wd();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:yd,lastRenderedState:a};a=a.dispatch=Cd.bind(null,M,a);return[b.memoizedState,a]}function Dd(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=M.updateQueue;null===b?(b={lastEffect:null},M.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Ed(){return xd().memoizedState}function Fd(a,b,c,d){var e=wd();M.effectTag|=a;e.memoizedState=Dd(1|b,c,void 0,void 0===d?null:d)}function Gd(a,b,c,d){var e=xd();d=void 0===d?null:d;var f=void 0;if(null!==N){var g=N.memoizedState;f=g.destroy;if(null!==d&&qd(d,g.deps)){Dd(b,c,f,d);return}}M.effectTag|=a;e.memoizedState=Dd(1|b,c,f,d)}function Hd(a,b){return Fd(516,4,a,b)}function Id(a,b){return Gd(516,4,a,b)}function Jd(a,b){return Gd(4,2,a,b)}
function Kd(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ld(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Gd(4,2,Kd.bind(null,b,a),c)}function Md(){}function Nd(a,b){wd().memoizedState=[a,void 0===b?null:b];return a}function Od(a,b){var c=xd();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&qd(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Pd(a,b){var c=xd();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&qd(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Qd(a,b,c){var d=bc();dc(98>d?98:d,function(){a(!0)});dc(97<d?97:d,function(){var d=L.suspense;L.suspense=void 0===b?null:b;try{a(!1),c()}finally{L.suspense=d}})}
function Cd(a,b,c){var d=Lc(),e=Ic.suspense;d=Mc(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===M||null!==f&&f===M)pd=!0,e.expirationTime=od,M.expirationTime=od;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if(jc(h,g))return}catch(k){}finally{}Nc(a,
d)}}
var vd={readContext:I,useCallback:P,useContext:P,useEffect:P,useImperativeHandle:P,useLayoutEffect:P,useMemo:P,useReducer:P,useRef:P,useState:P,useDebugValue:P,useResponder:P,useDeferredValue:P,useTransition:P},sd={readContext:I,useCallback:Nd,useContext:I,useEffect:Hd,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Fd(4,2,Kd.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Fd(4,2,a,b)},useMemo:function(a,b){var c=wd();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=wd();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Cd.bind(null,M,a);return[d.memoizedState,a]},useRef:function(a){var b=wd();a={current:a};return b.memoizedState=a},useState:Bd,useDebugValue:Md,useResponder:md,useDeferredValue:function(a,b){var c=Bd(a),d=c[0],e=c[1];Hd(function(){var c=L.suspense;L.suspense=void 0===b?null:b;try{e(a)}finally{L.suspense=c}},
[a,b]);return d},useTransition:function(a){var b=Bd(!1),c=b[0];b=b[1];return[Nd(Qd.bind(null,b,a),[b,a]),c]}},td={readContext:I,useCallback:Od,useContext:I,useEffect:Id,useImperativeHandle:Ld,useLayoutEffect:Jd,useMemo:Pd,useReducer:zd,useRef:Ed,useState:function(){return zd(yd)},useDebugValue:Md,useResponder:md,useDeferredValue:function(a,b){var c=zd(yd),d=c[0],e=c[1];Id(function(){var c=L.suspense;L.suspense=void 0===b?null:b;try{e(a)}finally{L.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
zd(yd),c=b[0];b=b[1];return[Od(Qd.bind(null,b,a),[b,a]),c]}},ud={readContext:I,useCallback:Od,useContext:I,useEffect:Id,useImperativeHandle:Ld,useLayoutEffect:Jd,useMemo:Pd,useReducer:Ad,useRef:Ed,useState:function(){return Ad(yd)},useDebugValue:Md,useResponder:md,useDeferredValue:function(a,b){var c=Ad(yd),d=c[0],e=c[1];Id(function(){var c=L.suspense;L.suspense=void 0===b?null:b;try{e(a)}finally{L.suspense=c}},[a,b]);return d},useTransition:function(a){var b=Ad(yd),c=b[0];b=b[1];return[Od(Qd.bind(null,
b,a),[b,a]),c]}},Rd=null,Sd=null,Td=!1;function Ud(a,b){var c=Vd(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Wd(a,b){switch(a.tag){case 5:return b=nb(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=ob(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Xd(a){if(Td){var b=Sd;if(b){var c=b;if(!Wd(a,b)){b=rb(c);if(!b||!Wd(a,b)){a.effectTag=a.effectTag&-1025|2;Td=!1;Rd=a;return}Ud(Rd,c)}Rd=a;Sd=sb(b)}else a.effectTag=a.effectTag&-1025|2,Td=!1,Rd=a}}function Yd(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Rd=a}
function Zd(a){if(!Sa||a!==Rd)return!1;if(!Td)return Yd(a),Td=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ja(b,a.memoizedProps))for(b=Sd;b;)Ud(a,b),b=rb(b);Yd(a);if(13===a.tag){if(!Sa)throw Error(n(316));a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(n(317));Sd=vb(a)}else Sd=Rd?rb(a.stateNode):null;return!0}function $d(){Sa&&(Sd=Rd=null,Td=!1)}var ae=p.ReactCurrentOwner,wc=!1;function R(a,b,c,d){b.child=null===a?cd(b,null,c,d):bd(b,a.child,c,d)}
function be(a,b,c,d,e){c=c.render;var f=b.ref;vc(b,e);d=rd(a,b,c,d,f,e);if(null!==a&&!wc)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),ce(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function de(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ee(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,fe(a,b,g,d,e,f);a=Zc(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:lc,c(e,d)&&a.ref===b.ref))return ce(a,b,f);b.effectTag|=1;a=Xc(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function fe(a,b,c,d,e,f){return null!==a&&lc(a.memoizedProps,d)&&a.ref===b.ref&&(wc=!1,e<f)?(b.expirationTime=a.expirationTime,ce(a,b,f)):ge(a,b,c,d,f)}function he(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function ge(a,b,c,d,e){var f=F(c)?Db:D.current;f=Eb(b,f);vc(b,e);c=rd(a,b,c,d,f,e);if(null!==a&&!wc)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),ce(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ie(a,b,c,d,e){if(F(c)){var f=!0;Ib(b)}else f=!1;vc(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Qc(b,c,d),Sc(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=I(l):(l=F(c)?Db:D.current,l=Eb(b,l));var q=c.getDerivedStateFromProps,r="function"===typeof q||"function"===typeof g.getSnapshotBeforeUpdate;r||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Rc(b,g,d,l);xc=!1;var w=b.memoizedState;g.state=w;Dc(b,d,g,e);k=b.memoizedState;h!==d||w!==k||E.current||xc?("function"===typeof q&&(Kc(b,c,q,d),k=b.memoizedState),(h=xc||Pc(b,c,h,d,w,k,l))?(r||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,zc(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:mc(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=I(l):(l=F(c)?Db:D.current,l=Eb(b,l)),q=c.getDerivedStateFromProps,(r="function"===typeof q||"function"===typeof g.getSnapshotBeforeUpdate)||
"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Rc(b,g,d,l),xc=!1,k=b.memoizedState,g.state=k,Dc(b,d,g,e),w=b.memoizedState,h!==d||k!==w||E.current||xc?("function"===typeof q&&(Kc(b,c,q,d),w=b.memoizedState),(q=xc||Pc(b,c,h,d,k,w,l))?(r||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&
g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=q):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&
k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return je(a,b,c,d,f,e)}
function je(a,b,c,d,e,f){he(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Jb(b,c,!1),ce(a,b,f);d=b.stateNode;ae.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=bd(b,a.child,null,f),b.child=bd(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Jb(b,c,!0);return b.child}function le(a){var b=a.stateNode;b.pendingContext?Gb(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Gb(a,b.context,!1);hd(a,b.containerInfo)}
var me={dehydrated:null,retryTime:0};
function ne(a,b,c){var d=b.mode,e=b.pendingProps,f=K.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);C(K,f&1);if(null===a){void 0!==e.fallback&&Xd(b);if(g){g=e.fallback;e=ad(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=ad(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=me;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=cd(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Xc(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Xc(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=me;b.child=c;return d}c=bd(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=ad(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=ad(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=me;b.child=e;return c}b.memoizedState=null;return b.child=bd(b,a,e.children,c)}
function oe(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);uc(a.return,b)}function pe(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function qe(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=K.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&oe(a,c);else if(19===a.tag)oe(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}C(K,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ld(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);pe(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ld(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}pe(b,!0,c,null,f,b.lastEffect);break;case "together":pe(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function ce(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Gc(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(n(153));if(null!==b.child){a=b.child;c=Xc(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xc(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}function re(a){a.effectTag|=4}var se,te,ue,ve;
if(Qa)se=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)Ga(a,c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}},te=function(){},ue=function(a,b,c,d,e){a=a.memoizedProps;if(a!==d){var f=b.stateNode,g=gd(J.current);c=Ia(f,c,a,d,e,g);(b.updateQueue=c)&&re(b)}},ve=function(a,b,c,d){c!==d&&re(b)};else if(Ra){se=function(a,
b,c,d){for(var e=b.child;null!==e;){if(5===e.tag){var f=e.stateNode;c&&d&&(f=lb(f,e.type,e.memoizedProps,e));Ga(a,f)}else if(6===e.tag)f=e.stateNode,c&&d&&(f=mb(f,e.memoizedProps,e)),Ga(a,f);else if(4!==e.tag){if(13===e.tag&&0!==(e.effectTag&4)&&(f=null!==e.memoizedState)){var g=e.child;if(null!==g&&(null!==g.child&&(g.child.return=g,se(a,g,!0,f)),f=g.sibling,null!==f)){f.return=e;e=f;continue}}if(null!==e.child){e.child.return=e;e=e.child;continue}}if(e===b)break;for(;null===e.sibling;){if(null===
e.return||e.return===b)return;e=e.return}e.sibling.return=e.return;e=e.sibling}};var we=function(a,b,c,d){for(var e=b.child;null!==e;){if(5===e.tag){var f=e.stateNode;c&&d&&(f=lb(f,e.type,e.memoizedProps,e));ib(a,f)}else if(6===e.tag)f=e.stateNode,c&&d&&(f=mb(f,e.memoizedProps,e)),ib(a,f);else if(4!==e.tag){if(13===e.tag&&0!==(e.effectTag&4)&&(f=null!==e.memoizedState)){var g=e.child;if(null!==g&&(null!==g.child&&(g.child.return=g,we(a,g,!0,f)),f=g.sibling,null!==f)){f.return=e;e=f;continue}}if(null!==
e.child){e.child.return=e;e=e.child;continue}}if(e===b)break;for(;null===e.sibling;){if(null===e.return||e.return===b)return;e=e.return}e.sibling.return=e.return;e=e.sibling}};te=function(a){var b=a.stateNode;if(null!==a.firstEffect){var c=b.containerInfo,d=hb(c);we(d,a,!1,!1);b.pendingChildren=d;re(a);jb(c,d)}};ue=function(a,b,c,d,e){var f=a.stateNode,g=a.memoizedProps;if((a=null===b.firstEffect)&&g===d)b.stateNode=f;else{var h=b.stateNode,k=gd(J.current),l=null;g!==d&&(l=Ia(h,c,g,d,e,k));a&&null===
l?b.stateNode=f:(f=gb(f,l,c,g,d,b,a,h),Ha(f,c,d,e,k)&&re(b),b.stateNode=f,a?re(b):se(f,b,!1,!1))}};ve=function(a,b,c,d){c!==d?(a=gd(fd.current),c=gd(J.current),b.stateNode=La(d,a,c,b),re(b)):b.stateNode=a.stateNode}}else te=function(){},ue=function(){},ve=function(){};
function xe(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function ye(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return F(b.type)&&Fb(),null;case 3:return id(),B(E),B(D),d=b.stateNode,d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null),(null===a||null===a.child)&&Zd(b)&&re(b),te(b),null;case 5:kd(b);var e=gd(fd.current);c=b.type;if(null!==a&&null!=b.stateNode)ue(a,b,c,d,e),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(n(166));
return null}a=gd(J.current);if(Zd(b)){if(!Sa)throw Error(n(175));a=tb(b.stateNode,b.type,b.memoizedProps,e,a,b);b.updateQueue=a;null!==a&&re(b)}else{var f=Fa(c,d,e,a,b);se(f,b,!1,!1);b.stateNode=f;Ha(f,c,d,e,a)&&re(b)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)ve(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(n(166));a=gd(fd.current);e=gd(J.current);if(Zd(b)){if(!Sa)throw Error(n(176));ub(b.stateNode,b.memoizedProps,b)&&re(b)}else b.stateNode=
La(d,a,e,b)}return null;case 13:B(K);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;d=null!==d;e=!1;null===a?void 0!==b.memoizedProps.fallback&&Zd(b):(c=a.memoizedState,e=null!==c,d||null===c||(c=a.child.sibling,null!==c&&(f=b.firstEffect,null!==f?(b.firstEffect=c,c.nextEffect=f):(b.firstEffect=b.lastEffect=c,c.nextEffect=null),c.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(K.current&1))S===ze&&(S=Ae);else{if(S===
ze||S===Ae)S=Be;0!==Ce&&null!==T&&(De(T,U),Ee(T,Ce))}Ra&&d&&(b.effectTag|=4);Qa&&(d||e)&&(b.effectTag|=4);return null;case 4:return id(),te(b),null;case 10:return tc(b),null;case 17:return F(b.type)&&Fb(),null;case 19:B(K);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)xe(d,!1);else{if(S!==ze||null!==a&&0!==(a.effectTag&64))for(a=b.child;null!==a;){f=ld(a);if(null!==f){b.effectTag|=64;xe(d,!1);a=f.updateQueue;null!==a&&(b.updateQueue=a,b.effectTag|=
4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;a=c;for(d=b.child;null!==d;)e=d,c=a,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,f=e.alternate,null===f?(e.childExpirationTime=0,e.expirationTime=c,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=f.childExpirationTime,e.expirationTime=f.expirationTime,e.child=f.child,e.memoizedProps=f.memoizedProps,e.memoizedState=f.memoizedState,e.updateQueue=
f.updateQueue,c=f.dependencies,e.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),d=d.sibling;C(K,K.current&1|2);return b.child}a=a.sibling}}else{if(!e)if(a=ld(f),null!==a){if(b.effectTag|=64,e=!0,a=a.updateQueue,null!==a&&(b.updateQueue=a,b.effectTag|=4),xe(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*G()-d.renderingStartTime>d.tailExpiration&&
1<c&&(b.effectTag|=64,e=!0,xe(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(a=d.last,null!==a?a.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=G()+500),a=d.tail,d.rendering=a,d.tail=a.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=G(),a.sibling=null,b=K.current,C(K,e?b&1|2:b&1),a):null}throw Error(n(156,b.tag));}
function Fe(a){switch(a.tag){case 1:F(a.type)&&Fb();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:id();B(E);B(D);b=a.effectTag;if(0!==(b&64))throw Error(n(285));a.effectTag=b&-4097|64;return a;case 5:return kd(a),null;case 13:return B(K),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return B(K),null;case 4:return id(),null;case 10:return tc(a),null;default:return null}}function Ge(a,b){return{value:a,source:b,stack:zb(b)}}
var He="function"===typeof WeakSet?WeakSet:Set;function Ie(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=zb(c));null!==c&&ua(c.type);b=b.value;null!==a&&1===a.tag&&ua(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Je(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ke(a,c)}}function Le(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ke(a,c)}else b.current=null}
function Me(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mc(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(n(163));}
function Ne(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Oe(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Pe(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Oe(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:mc(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Hc(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=Aa(c.child.stateNode);break;case 1:a=c.child.stateNode}Hc(c,b,
a)}return;case 5:a=c.stateNode;null===b&&c.effectTag&4&&Wa(a,c.type,c.memoizedProps,c);return;case 6:return;case 4:return;case 12:return;case 13:Sa&&null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&xb(c))));return;case 19:case 17:case 20:case 21:return}throw Error(n(163));}
function Qe(a,b,c){"function"===typeof Re&&Re(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;dc(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ke(g,h)}}a=a.next}while(a!==d)})}break;case 1:Le(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Je(b,c);break;case 5:Le(b);break;case 4:Qa?Se(a,b,c):Ra&&Te(b)}}
function Ue(a,b,c){for(var d=b;;)if(Qe(a,d,c),null===d.child||Qa&&4===d.tag){if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return}d.sibling.return=d.return;d=d.sibling}else d.child.return=d,d=d.child}function Ve(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ve(b)}
function Te(a){if(Ra){a=a.stateNode.containerInfo;var b=hb(a);kb(a,b)}}function We(a){return 5===a.tag||3===a.tag||4===a.tag}
function Xe(a){if(Qa){a:{for(var b=a.return;null!==b;){if(We(b)){var c=b;break a}b=b.return}throw Error(n(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(n(161));}c.effectTag&16&&(bb(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||We(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Ye(a,c,b):Ze(a,c,b)}}function Ye(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?Za(c,a,b):Ua(c,a);else if(4!==d&&(a=a.child,null!==a))for(Ye(a,b,c),a=a.sibling;null!==a;)Ye(a,b,c),a=a.sibling}
function Ze(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?Ya(c,a,b):Ta(c,a);else if(4!==d&&(a=a.child,null!==a))for(Ze(a,b,c),a=a.sibling;null!==a;)Ze(a,b,c),a=a.sibling}
function Se(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(n(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag)Ue(a,d,c),g?ab(f,d.stateNode):$a(f,d.stateNode);else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Qe(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;
for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function $e(a,b){if(Qa){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Ne(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Xa(c,f,e,a,d,b)}return;case 6:if(null===b.stateNode)throw Error(n(162));c=b.memoizedProps;Va(b.stateNode,null!==a?a.memoizedProps:c,c);return;case 3:Sa&&(b=b.stateNode,b.hydrate&&(b.hydrate=!1,wb(b.containerInfo)));return;case 12:return;case 13:af(b);
bf(b);return;case 19:bf(b);return;case 17:return}throw Error(n(163));}switch(b.tag){case 0:case 11:case 14:case 15:case 22:Ne(3,b);return;case 12:return;case 13:af(b);bf(b);return;case 19:bf(b);return;case 3:Sa&&(c=b.stateNode,c.hydrate&&(c.hydrate=!1,wb(c.containerInfo)))}a:if(Ra){switch(b.tag){case 1:case 5:case 6:case 20:break a;case 3:case 4:b=b.stateNode;kb(b.containerInfo,b.pendingChildren);break a}throw Error(n(163));}}
function af(a){var b=a;if(null===a.memoizedState)var c=!1;else c=!0,b=a.child,cf=G();if(Qa&&null!==b)a:if(a=b,Qa)for(b=a;;){if(5===b.tag){var d=b.stateNode;c?cb(d):eb(b.stateNode,b.memoizedProps)}else if(6===b.tag)d=b.stateNode,c?db(d):fb(d,b.memoizedProps);else if(13===b.tag&&null!==b.memoizedState&&null===b.memoizedState.dehydrated){d=b.child.sibling;d.return=b;b=d;continue}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break a;for(;null===b.sibling;){if(null===b.return||b.return===
a)break a;b=b.return}b.sibling.return=b.return;b=b.sibling}}function bf(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new He);b.forEach(function(b){var d=df.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ef="function"===typeof WeakMap?WeakMap:Map;function ff(a,b,c){c=Ac(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gf||(gf=!0,hf=d);Ie(a,b)};return c}
function jf(a,b,c){c=Ac(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ie(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===kf?kf=new Set([this]):kf.add(this),Ie(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var lf=Math.ceil,mf=p.ReactCurrentDispatcher,nf=p.ReactCurrentOwner,V=0,of=8,pf=16,qf=32,ze=0,rf=1,sf=2,Ae=3,Be=4,tf=5,W=V,T=null,X=null,U=0,S=ze,uf=null,vf=1073741823,wf=1073741823,xf=null,Ce=0,yf=!1,cf=0,zf=500,Y=null,gf=!1,hf=null,kf=null,Af=!1,Bf=null,Cf=90,Df=null,Ef=0,Ff=null,Gf=0;function Lc(){return(W&(pf|qf))!==V?1073741821-(G()/10|0):0!==Gf?Gf:Gf=1073741821-(G()/10|0)}
function Mc(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=bc();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&pf)!==V)return U;if(null!==c)a=hc(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hc(a,150,100);break;case 97:case 96:a=hc(a,5E3,250);break;case 95:a=2;break;default:throw Error(n(326));}null!==T&&a===U&&--a;return a}
function Nc(a,b){if(50<Ef)throw Ef=0,Ff=null,Error(n(185));a=Hf(a,b);if(null!==a){var c=bc();1073741823===b?(W&of)!==V&&(W&(pf|qf))===V?If(a):(Z(a),W===V&&H()):Z(a);(W&4)===V||98!==c&&99!==c||(null===Df?Df=new Map([[a,b]]):(c=Df.get(a),(void 0===c||c>b)&&Df.set(a,b)))}}
function Hf(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Gc(b),S===Be&&De(e,U)),Ee(e,b));return e}
function Jf(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Kf(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=fc(If.bind(null,a));else{var b=Jf(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Lc();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Vb&&Mb(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?fc(If.bind(null,a)):ec(d,Lf.bind(null,a),{timeout:10*(1073741821-b)-G()});a.callbackNode=b}}}
function Lf(a,b){Gf=0;if(b)return b=Lc(),Mf(a,b),Z(a),null;var c=Jf(a);if(0!==c){b=a.callbackNode;if((W&(pf|qf))!==V)throw Error(n(327));Nf();a===T&&c===U||Of(a,c);if(null!==X){var d=W;W|=pf;var e=Pf();do try{Qf();break}catch(h){Rf(a,h)}while(1);rc();W=d;mf.current=e;if(S===rf)throw b=uf,Of(a,c),De(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ze:case rf:throw Error(n(345));case sf:Mf(a,2<c?2:c);break;case Ae:De(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Sf(e));if(1073741823===vf&&(e=cf+zf-G(),10<e)){if(yf){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Of(a,c);break}}f=Jf(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Ma(Tf.bind(null,a),e);break}Tf(a);break;case Be:De(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Sf(e));if(yf&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Of(a,c);break}e=Jf(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==wf?d=10*(1073741821-wf)-G():1073741823===vf?d=0:(d=10*(1073741821-vf)-5E3,e=G(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*lf(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Ma(Tf.bind(null,a),d);break}Tf(a);break;case tf:if(1073741823!==vf&&null!==xf){f=vf;var g=xf;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=G()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){De(a,c);a.timeoutHandle=
Ma(Tf.bind(null,a),d);break}}Tf(a);break;default:throw Error(n(329));}Z(a);if(a.callbackNode===b)return Lf.bind(null,a)}}return null}
function If(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(pf|qf))!==V)throw Error(n(327));Nf();a===T&&b===U||Of(a,b);if(null!==X){var c=W;W|=pf;var d=Pf();do try{Uf();break}catch(e){Rf(a,e)}while(1);rc();W=c;mf.current=d;if(S===rf)throw c=uf,Of(a,b),De(a,b),Z(a),c;if(null!==X)throw Error(n(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Tf(a);Z(a)}return null}function Vf(a,b){Mf(a,b);Z(a);(W&(pf|qf))===V&&H()}
function Wf(){if(null!==Df){var a=Df;Df=null;a.forEach(function(a,c){Mf(c,a);Z(c)});H()}}function Xf(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&H()}}function Yf(a,b){if((W&(pf|qf))!==V)throw Error(n(187));var c=W;W|=1;try{return dc(99,a.bind(null,b))}finally{W=c,H()}}
function Of(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;c!==Oa&&(a.timeoutHandle=Oa,Na(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Fb();break;case 3:id();B(E);B(D);break;case 5:kd(d);break;case 4:id();break;case 13:B(K);break;case 19:B(K);break;case 10:tc(d)}c=c.return}T=a;X=Xc(a.current,null);U=b;S=ze;uf=null;wf=vf=1073741823;xf=null;Ce=0;yf=!1}
function Rf(a,b){do{try{rc();nd.current=vd;if(pd)for(var c=M.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}od=0;O=N=M=null;pd=!1;if(null===X||null===X.return)return S=rf,uf=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var q=0!==(K.current&1),r=f;do{var w;if(w=13===r.tag){var z=r.memoizedState;if(null!==z)w=null!==z.dehydrated?!0:!1;else{var Q=r.memoizedProps;w=void 0===Q.fallback?!1:!0!==Q.unstable_avoidThisFallback?!0:q?!1:!0}}if(w){var A=r.updateQueue;if(null===A){var v=new Set;v.add(k);r.updateQueue=v}else A.add(k);if(0===(r.mode&2)){r.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var t=Ac(1073741823,null);t.tag=2;Bc(g,t)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var x=e.pingCache;null===x?(x=e.pingCache=new ef,h=new Set,x.set(k,h)):(h=x.get(k),void 0===h&&(h=new Set,x.set(k,h)));if(!h.has(g)){h.add(g);var ke=cg.bind(null,e,k,g);k.then(ke,ke)}r.effectTag|=4096;r.expirationTime=b;break a}r=r.return}while(null!==r);h=Error((ua(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
zb(g))}S!==tf&&(S=sf);h=Ge(h,g);r=f;do{switch(r.tag){case 3:k=h;r.effectTag|=4096;r.expirationTime=b;var Zf=ff(r,k,b);Cc(r,Zf);break a;case 1:k=h;var $f=r.type,Fc=r.stateNode;if(0===(r.effectTag&64)&&("function"===typeof $f.getDerivedStateFromError||null!==Fc&&"function"===typeof Fc.componentDidCatch&&(null===kf||!kf.has(Fc)))){r.effectTag|=4096;r.expirationTime=b;var ag=jf(r,k,b);Cc(r,ag);break a}}r=r.return}while(null!==r)}X=dg(X)}catch(bg){b=bg;continue}break}while(1)}
function Pf(){var a=mf.current;mf.current=vd;return null===a?vd:a}function Ec(a,b){a<vf&&2<a&&(vf=a);null!==b&&a<wf&&2<a&&(wf=a,xf=b)}function Gc(a){a>Ce&&(Ce=a)}function Uf(){for(;null!==X;)X=eg(X)}function Qf(){for(;null!==X&&!Wb();)X=eg(X)}function eg(a){var b=fg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=dg(a));nf.current=null;return b}
function dg(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=ye(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=Fe(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ze&&(S=tf);return null}function Sf(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Tf(a){var b=bc();dc(99,gg.bind(null,a,b));return null}
function gg(a,b){do Nf();while(null!==Bf);if((W&(pf|qf))!==V)throw Error(n(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(n(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Sf(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=qf;nf.current=null;Da(a.containerInfo);Y=e;do try{hg()}catch(t){if(null===Y)throw Error(n(330));Ke(Y,t);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(var g=a,h=b;null!==Y;){var k=Y.effectTag;k&16&&Qa&&bb(Y.stateNode);if(k&128){var l=Y.alternate;if(null!==l){var q=l.ref;
null!==q&&("function"===typeof q?q(null):q.current=null)}}switch(k&1038){case 2:Xe(Y);Y.effectTag&=-3;break;case 6:Xe(Y);Y.effectTag&=-3;$e(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;$e(Y.alternate,Y);break;case 4:$e(Y.alternate,Y);break;case 8:var r=g,w=Y,z=h;Qa?Se(r,w,z):Ue(r,w,z);Ve(w)}Y=Y.nextEffect}}catch(t){if(null===Y)throw Error(n(330));Ke(Y,t);Y=Y.nextEffect}while(null!==Y);Ea(a.containerInfo);a.current=c;Y=e;do try{for(k=a;null!==Y;){var Q=Y.effectTag;
Q&36&&Pe(k,Y.alternate,Y);if(Q&128){l=void 0;var A=Y.ref;if(null!==A){var v=Y.stateNode;switch(Y.tag){case 5:l=Aa(v);break;default:l=v}"function"===typeof A?A(l):A.current=l}}Y=Y.nextEffect}}catch(t){if(null===Y)throw Error(n(330));Ke(Y,t);Y=Y.nextEffect}while(null!==Y);Y=null;Xb();W=f}else a.current=c;if(Af)Af=!1,Bf=a,Cf=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(kf=null);1073741823===b?a===Ff?Ef++:(Ef=0,Ff=a):Ef=0;"function"===typeof ig&&ig(c.stateNode,
d);Z(a);if(gf)throw gf=!1,a=hf,hf=null,a;if((W&of)!==V)return null;H();return null}function hg(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Me(Y.alternate,Y);0===(a&512)||Af||(Af=!0,ec(97,function(){Nf();return null}));Y=Y.nextEffect}}function Nf(){if(90!==Cf){var a=97<Cf?97:Cf;Cf=90;return dc(a,jg)}}
function jg(){if(null===Bf)return!1;var a=Bf;Bf=null;if((W&(pf|qf))!==V)throw Error(n(331));var b=W;W|=qf;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Ne(5,c),Oe(5,c)}}catch(d){if(null===a)throw Error(n(330));Ke(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;H();return!0}function kg(a,b,c){b=Ge(c,b);b=ff(a,b,1073741823);Bc(a,b);a=Hf(a,1073741823);null!==a&&Z(a)}
function Ke(a,b){if(3===a.tag)kg(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){kg(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===kf||!kf.has(d))){a=Ge(b,a);a=jf(c,a,1073741823);Bc(c,a);c=Hf(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function cg(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===Be||S===Ae&&1073741823===vf&&G()-cf<zf?Of(a,U):yf=!0:Kf(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function df(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Lc(),b=Mc(b,a,null));a=Hf(a,b);null!==a&&Z(a)}var fg;
fg=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||E.current)wc=!0;else{if(d<c){wc=!1;switch(b.tag){case 3:le(b);$d();break;case 5:jd(b);if(b.mode&4&&1!==c&&Ka(b.type,e))return b.expirationTime=b.childExpirationTime=1,null;break;case 1:F(b.type)&&Ib(b);break;case 4:hd(b,b.stateNode.containerInfo);break;case 10:sc(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return ne(a,b,c);C(K,K.current&
1);b=ce(a,b,c);return null!==b?b.sibling:null}C(K,K.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return qe(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);C(K,K.current);if(!d)return null}return ce(a,b,c)}wc=!1}}else wc=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Eb(b,D.current);vc(b,c);e=rd(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(F(d)){var f=!0;Ib(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;yc(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Kc(b,d,g,a);e.updater=Oc;b.stateNode=e;e._reactInternalFiber=b;Sc(b,d,a,c);b=je(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;
ta(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=lg(e);a=mc(e,a);switch(f){case 0:b=ge(null,b,e,a,c);break a;case 1:b=ie(null,b,e,a,c);break a;case 11:b=be(null,b,e,a,c);break a;case 14:b=de(null,b,e,mc(e.type,a),d,c);break a}throw Error(n(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),ge(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),ie(a,b,d,e,c);case 3:le(b);d=b.updateQueue;if(null===a||null===d)throw Error(n(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;zc(a,b);Dc(b,d,null,c);d=b.memoizedState.element;if(d===e)$d(),b=ce(a,b,c);else{if(e=b.stateNode.hydrate)Sa?(Sd=sb(b.stateNode.containerInfo),Rd=b,e=Td=!0):e=!1;if(e)for(c=cd(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),$d();b=b.child}return b;case 5:return jd(b),null===a&&Xd(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ja(d,e)?g=null:null!==f&&Ja(d,f)&&(b.effectTag|=16),
he(a,b),b.mode&4&&1!==c&&Ka(d,e)?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Xd(b),null;case 13:return ne(a,b,c);case 4:return hd(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=bd(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),be(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;sc(b,f);if(null!==g){var h=g.value;f=jc(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!E.current){b=ce(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Ac(c,null),l.tag=2,Bc(h,
l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);uc(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vc(b,c),e=I(e,f.unstable_observedBits),
d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=mc(e,b.pendingProps),f=mc(e.type,f),de(a,b,e,f,d,c);case 15:return fe(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,F(d)?(a=!0,Ib(b)):a=!1,vc(b,c),Qc(b,d,e),Sc(b,d,e,c),je(null,b,d,!0,a,c);case 19:return qe(a,b,c)}throw Error(n(156,b.tag));};var mg={current:!1},ig=null,Re=null;
function ng(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ig=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Re=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function og(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Vd(a,b,c,d){return new og(a,b,c,d)}
function ee(a){a=a.prototype;return!(!a||!a.isReactComponent)}function lg(a){if("function"===typeof a)return ee(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===la)return 11;if(a===oa)return 14}return 2}
function Xc(a,b){var c=a.alternate;null===c?(c=Vd(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Zc(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ee(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ea:return ad(c.children,e,f,b);case ka:g=8;e|=7;break;case fa:g=8;e|=1;break;case ha:return a=Vd(12,c,b,e|8),a.elementType=ha,a.type=ha,a.expirationTime=f,a;case ma:return a=Vd(13,c,b,e),a.type=ma,a.elementType=ma,a.expirationTime=f,a;case na:return a=Vd(19,c,b,e),a.elementType=na,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case ia:g=
10;break a;case ja:g=9;break a;case la:g=11;break a;case oa:g=14;break a;case pa:g=16;d=null;break a;case qa:g=22;break a}throw Error(n(130,null==a?a:typeof a,""));}b=Vd(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function ad(a,b,c,d){a=Vd(7,a,d,b);a.expirationTime=c;return a}function Yc(a,b,c){a=Vd(6,a,null,b);a.expirationTime=c;return a}
function $c(a,b,c){b=Vd(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function pg(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=Oa;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Kf(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function De(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Ee(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Mf(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}var qg=null;
function rg(a){if(null===qg)try{var b=("require"+Math.random()).slice(0,7);qg=(module&&module[b])("timers").setImmediate}catch(c){qg=function(a){var b=new MessageChannel;b.port1.onmessage=a;b.port2.postMessage(void 0)}}return qg(a)}function sg(a){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(n(188));throw Error(n(268,Object.keys(a)));}a=ya(b);return null===a?null:a.stateNode}
function tg(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ug(a,b){tg(a,b);(a=a.alternate)&&tg(a,b)}var vg=p.IsSomeRendererActing,wg="function"===typeof m.unstable_flushAllWithoutAsserting,xg=m.unstable_flushAllWithoutAsserting||function(){for(var a=!1;Nf();)a=!0;return a};function yg(a){try{xg(),rg(function(){xg()?yg(a):a()})}catch(b){a(b)}}
var zg=0,Ag=!1,Bg={__proto__:null,createContainer:function(a,b,c){a=new pg(a,b,c);b=Vd(3,null,null,2===b?7:1===b?3:0);a.current=b;b.stateNode=a;yc(b);return a},updateContainer:function(a,b,c,d){var e=b.current,f=Lc(),g=Ic.suspense;f=Mc(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(va(c)!==c||1!==c.tag)throw Error(n(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(F(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(n(171));
}if(1===c.tag){var k=c.type;if(F(k)){c=Hb(c,k,h);break a}}c=h}else c=Cb;null===b.context?b.context=c:b.pendingContext=c;b=Ac(f,g);b.payload={element:a};d=void 0===d?null:d;null!==d&&(b.callback=d);Bc(e,b);Nc(e,f);return f},batchedEventUpdates:function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&H()}},batchedUpdates:Xf,unbatchedUpdates:function(a,b){var c=W;W&=-2;W|=of;try{return a(b)}finally{W=c,W===V&&H()}},deferredUpdates:function(a){return dc(97,a)},syncUpdates:function(a,b,c,d){return dc(99,
a.bind(null,b,c,d))},discreteUpdates:function(a,b,c,d,e){var f=W;W|=4;try{return dc(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&H()}},flushDiscreteUpdates:function(){(W&(1|pf|qf))===V&&(Wf(),Nf())},flushControlled:function(a){var b=W;W|=1;try{dc(99,a)}finally{W=b,W===V&&H()}},flushSync:Yf,flushPassiveEffects:Nf,IsThisRendererActing:mg,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return Aa(a.child.stateNode);default:return a.child.stateNode}},attemptSynchronousHydration:function(a){switch(a.tag){case 3:var b=
a.stateNode;b.hydrate&&Vf(b,b.firstPendingTime);break;case 13:Yf(function(){return Nc(a,1073741823)}),b=hc(Lc(),150,100),ug(a,b)}},attemptUserBlockingHydration:function(a){if(13===a.tag){var b=hc(Lc(),150,100);Nc(a,b);ug(a,b)}},attemptContinuousHydration:function(a){13===a.tag&&(Nc(a,3),ug(a,3))},attemptHydrationAtCurrentPriority:function(a){if(13===a.tag){var b=Lc();b=Mc(b,a,null);Nc(a,b);ug(a,b)}},findHostInstance:sg,findHostInstanceWithWarning:function(a){return sg(a)},findHostInstanceWithNoPortals:function(a){a=
za(a);return null===a?null:20===a.tag?a.stateNode.instance:a.stateNode},shouldSuspend:function(){return!1},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return ng(aa({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:p.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ya(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,
scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))},act:function(a){function b(){zg--;vg.current=c;mg.current=d}!1===Ag&&(Ag=!0,console.error("act(...) is not supported in production builds of React, and might not behave as expected."));zg++;var c=vg.current;var d=mg.current;vg.current=!0;mg.current=!0;try{var e=Xf(a)}catch(f){throw b(),f;}if(null!==e&&"object"===typeof e&&"function"===typeof e.then)return{then:function(a,d){e.then(function(){1<zg||!0===wg&&!0===c?(b(),a()):yg(function(c){b();
c?d(c):a()})},function(a){b();d(a)})}};try{1!==zg||!1!==wg&&!1!==c||xg(),b()}catch(f){throw b(),f;}return{then:function(a){a()}}}},Cg=Bg&&Bg["default"]||Bg;module.exports=Cg.default||Cg;

    var $$$renderer = module.exports;
    module.exports = $$$reconciler;
    return $$$renderer;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(85);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = App;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_RootProvider__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Routes__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_general_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_general_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_general_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_RenderResolution__ = __webpack_require__(202);







var DESIGN_W = 1920;
var DESIGN_H = 1080;
var SAFE_INSET = 0.03;
// Player must be true full screen: no safe-area inset, so the video fills the
// panel edge-to-edge (scale === 1 on a 1080p screen). Every other route keeps
// the 3% overscan-safe inset.
var PLAYER_SAFE_INSET = 0;
var PLAYER_ROUTES = ["watch"];
// Derive the safe box + scale from CSS pixels (innerWidth/Height), not
// DPR-scaled px, so DPR>1 panels still downscale correctly.
var computeDims = function (inset) {
    var res = Object(__WEBPACK_IMPORTED_MODULE_5__utils_RenderResolution__["a" /* getRenderResolution */])();
    var insetX = Math.round(res.innerWidth * inset);
    var insetY = Math.round(res.innerHeight * inset);
    var safeW = res.innerWidth - insetX * 2;
    var safeH = res.innerHeight - insetY * 2;
    var scale = Math.min(safeW / DESIGN_W, safeH / DESIGN_H, 1);
    var tier = res.innerWidth * res.innerHeight < 1.5e6 ? "720p" : "1080p";
    return { insetX: insetX, insetY: insetY, safeW: safeW, safeH: safeH, scale: scale, tier: tier };
};
function SafeFrame() {
    var route = Object(__WEBPACK_IMPORTED_MODULE_3__context_Router__["b" /* useRouter */])().route;
    var isPlayer = PLAYER_ROUTES.includes(route);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("1080p"), tier = _a[0], setTier = _a[1];
    var frameRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var stageRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(function () {
        var apply = function () {
            var d = computeDims(isPlayer ? PLAYER_SAFE_INSET : SAFE_INSET);
            setTier(d.tier);
            var frame = frameRef.current;
            if (frame) {
                frame.style.left = d.insetX + "px";
                frame.style.top = d.insetY + "px";
                frame.style.width = d.safeW + "px";
                frame.style.height = d.safeH + "px";
            }
            var stage = stageRef.current;
            if (stage) {
                stage.style.transform = "scale(" + d.scale + ")";
            }
        };
        apply();
        var timeout;
        var handleResize = function () {
            clearTimeout(timeout);
            timeout = window.setTimeout(apply, 50);
        };
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
            clearTimeout(timeout);
        };
    }, [isPlayer]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: frameRef, className: "safe-frame" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: stageRef, className: "fullscreen-container " + (tier === "720p" ? "compact" : "full") },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Routes__["a" /* Routes */], null))));
}
function App() {
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var loader = document.getElementById("app-loader");
        if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader);
        }
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__context_RootProvider__["a" /* RootProvider */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SafeFrame, null)));
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseButtonView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Focus__ = __webpack_require__(3);





var CloseButtonView = function (_a) {
    var onClose = _a.onClose;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "modalView",
        index: 0,
        onKeyDown: onClose,
        onKeyBack: onClose,
    });
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */].manualFocus("modalView", 0);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "btn-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { id: "modal-close", tabIndex: 0, ref: ref, className: "purple-border-btn" }, t("modal.close"))));
};


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nodesToString */
/* unused harmony export Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(17);



var _excluded = ["format"],
    _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = _objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      Object(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */])("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object') {
      var format = child.format,
          clone = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */])("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */])("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object' && !Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify__["a" /* default */].parse("<0>".concat(targetString, "</0>"));

  var opts = _objectSpread(_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push(Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded2);

  var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context__["a" /* I18nContext */]) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || Object(__WEBPACK_IMPORTED_MODULE_5__context__["e" /* getI18n */])();

  if (!i18n) {
    Object(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* warnOnce */])('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5__context__["d" /* getDefaults */])()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread(_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(useAsParent, additionalProps, content) : content;
}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(34)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_void_elements__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_void_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_void_elements__);
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],(__WEBPACK_IMPORTED_MODULE_0_void_elements___default.a[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ __webpack_exports__["a"] = (c);
//# sourceMappingURL=html-parse-stringify.module.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(46);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unescape; });
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(99);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withTranslation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTranslation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(17);



var _excluded = ["forwardedRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

      var _useTranslation = Object(__WEBPACK_IMPORTED_MODULE_4__useTranslation__["a" /* useTranslation */])(ns, _objectSpread(_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = _objectSpread(_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getDisplayName */])(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? Object(__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"])(forwardRef) : I18nextWithTranslation;
  };
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Translation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useTranslation__ = __webpack_require__(35);


var _excluded = ["ns", "children"];

function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(props, _excluded);

  var _useTranslation = Object(__WEBPACK_IMPORTED_MODULE_2__useTranslation__["a" /* useTranslation */])(ns, options),
      _useTranslation2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(7);


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1__context__["a" /* I18nContext */].Provider, {
    value: value
  }, children);
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useSSR__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(17);


var _excluded = ["initialI18nStore", "initialLanguage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

      Object(__WEBPACK_IMPORTED_MODULE_3__useSSR__["a" /* useSSR */])(initialI18nStore, initialLanguage);
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, _objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = Object(__WEBPACK_IMPORTED_MODULE_4__context__["c" /* composeInitialProps */])(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getDisplayName */])(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExitConfirmModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttons_ExitButtonView__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalStyles_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modalStyles_css__);




var ExitConfirmModal = function (_a) {
    var onClose = _a.onClose, onExit = _a.onExit;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "large-modal" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "info-text" }, t("exit.text")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__buttons_ExitButtonView__["a" /* ExitButtonView */], { onExit: onExit, onClose: onClose }))));
};


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_AuthScreen_AuthScreen__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__screens_HomeScreen_HomeScreen__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ProfilesScreen_ProfilesScreen__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_MoviesScreen_MoviesScreen__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_SearchScreen_SearchScreen__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_AuthScreen_CaveaAuth_CaveaAuthScreen__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__screens_AuthScreen_SilkAuth_SilkAuthScreen__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_user_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_Player_WatchScreen__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__screens_BlockMoviesScreen_BlockMoviesScreen__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_modals_InfoModal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_Helpers__ = __webpack_require__(2);


















var STALE_LOGOUT_WAIT_MS = 5000;
var Routes = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_2__context_Router__["b" /* useRouter */])(), route = _a.route, params = _a.params, navigate = _a.navigate;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_4__context_Auth__["b" /* useAuth */])(), user = _b.user, dispatch = _b.dispatch, profile = _b.profile;
    var _c = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(), t = _c.t, i18n = _c.i18n;
    var userFetched = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var isSessionStale = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_16__utils_Helpers__["h" /* isSTBSessionStale */])[0];
    var staleLogoutRequest = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    // Stored IDs are cleared only after a successful logout, so a failed
    // request leaves the mismatch in place for the next launch to retry.
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!isSessionStale) {
            return;
        }
        staleLogoutRequest.current = Object(__WEBPACK_IMPORTED_MODULE_12__services_user_service__["d" /* logout */])()
            .then(function () {
            Object(__WEBPACK_IMPORTED_MODULE_16__utils_Helpers__["b" /* clearIdsForSTB */])();
            dispatch({ type: "LOGOUT" });
        })
            .catch(function (error) { return console.log("Stale session logout failed", error); });
    }, []);
    var handleSessionEndedClose = function () {
        var closeApp = function () { return window.close(); };
        if (!staleLogoutRequest.current) {
            closeApp();
            return;
        }
        var logoutWaitLimit = new Promise(function (resolve) {
            return setTimeout(resolve, STALE_LOGOUT_WAIT_MS);
        });
        Promise.race([staleLogoutRequest.current, logoutWaitLimit]).then(closeApp);
    };
    // Release the per-container scroll/layout caches when navigating. focusManager
    // keeps each screen's scroll container in its offsets/parentRects maps and
    // never prunes them, so a left screen's detached container stays pinned —
    // keeping its whole poster subtree (and textures) alive. Focus groups
    // themselves self-clean via useFocusable's unregister, so we must NOT touch
    // them here (doing so breaks focus on the incoming screen).
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        return function () {
            __WEBPACK_IMPORTED_MODULE_3__utils_Focus__["b" /* focusManager */].clearScrollCaches();
        };
    }, [route]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (isSessionStale) {
            return;
        }
        if (!user && route !== "auth" && userFetched.current) {
            navigate("auth");
            return;
        }
        if (user && profile) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_12__services_user_service__["b" /* fetchUser */])().then(function (data) {
            dispatch({ type: "SET_PROFILES", profiles: data.profiles });
            var profiles = data.profiles;
            var profileId = data.chosenProfileId;
            var profile;
            if (!profileId) {
                if (profiles.length === 1) {
                    profile = profiles[0];
                    Object(__WEBPACK_IMPORTED_MODULE_12__services_user_service__["f" /* updateChosenProfile */])(profile.id).then(function () {
                        dispatch({ type: "SET_PROFILE", profile: profile });
                        navigate("home");
                    });
                }
                else {
                    navigate("profiles");
                }
            }
            else {
                profile = profiles.find(function (p) { return p.id === profileId; });
                dispatch({ type: "SET_PROFILE", profile: profile });
                navigate("home");
            }
            userFetched.current = true;
            if (!user) {
                dispatch({ type: "LOGIN", user: data.user });
            }
        }, function () {
            dispatch({ type: "LOGOUT" });
            navigate("auth");
        });
    }, [user]);
    // No focusManager.pushLayer here: it runs after CloseButtonView has
    // registered and swaps in empty groups, leaving Close unfocusable.
    if (isSessionStale) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "modal-overlay", tabIndex: 0, className: "modal-overlay" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__views_modals_InfoModal__["a" /* InfoModal */], { text: t("session_ended.text"), onClose: handleSessionEndedClose })));
    }
    switch (route) {
        case "home":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__screens_HomeScreen_HomeScreen__["a" /* HomeScreen */], null);
        case "movies":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__screens_MoviesScreen_MoviesScreen__["a" /* MoviesScreen */], { key: "movies" });
        case "tv-shows":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__screens_MoviesScreen_MoviesScreen__["a" /* MoviesScreen */], { key: "tv-shows" });
        case "watch":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__screens_Player_WatchScreen__["a" /* WatchScreen */], null);
        case "auth":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__screens_AuthScreen_AuthScreen__["a" /* AuthScreen */], null);
        case "auth-silk":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__screens_AuthScreen_SilkAuth_SilkAuthScreen__["a" /* SilkAuthScreen */], null);
        case "auth-cavea":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__screens_AuthScreen_CaveaAuth_CaveaAuthScreen__["a" /* CaveaAuthScreen */], null);
        case "profiles":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__screens_ProfilesScreen_ProfilesScreen__["a" /* ProfilesScreen */], null);
        case "search":
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__screens_SearchScreen_SearchScreen__["a" /* SearchScreen */], null);
        case "see-more":
            // Remount on slug/language change so the fetch starts from a clean state.
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__screens_BlockMoviesScreen_BlockMoviesScreen__["a" /* BlockMoviesScreen */], { key: params.slug + "-" + i18n.language });
        default:
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__screens_HomeScreen_HomeScreen__["a" /* HomeScreen */], null);
    }
};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LanguageChangeButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_buttons_AuthButtonView__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Focus__ = __webpack_require__(3);








var AuthScreen = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_2__context_Router__["b" /* useRouter */])().navigate;
    var accountId = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["d" /* getIdForSTB */])("accountId", "user_id");
    var stbId = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["d" /* getIdForSTB */])("stbId", "stb_id");
    var silkRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["k" /* useFocusable */])({
        group: "auth",
        index: 0,
        onKeyDown: function () { return navigate("auth-silk"); },
    });
    var caveaRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["k" /* useFocusable */])({
        group: "auth",
        index: 1,
        onKeyDown: function () { return navigate("auth-cavea", { silkUserExists: true }); },
    });
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_6__utils_Focus__["b" /* focusManager */].manualFocus("auth", 0);
        __WEBPACK_IMPORTED_MODULE_6__utils_Focus__["b" /* focusManager */].registerGroup({ name: "languageChange", position: 10 });
        if (!accountId || !stbId) {
            navigate("auth-cavea");
            return;
        }
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title" }, t("welcome.log_in")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-container", style: "margin: 1rem 0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_views_buttons_AuthButtonView__["a" /* AuthButtonView */], { focusRef: silkRef, buttonText: t("auth_tv.silk-btn") }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_views_buttons_AuthButtonView__["a" /* AuthButtonView */], { focusRef: caveaRef, buttonText: t("auth_tv.cavea-btn") }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: "display: block; margin: 3rem 0", id: "language-change" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_LanguageChangeButton__["a" /* LanguageChangeButton */], { focusRaw: ["languageChange", 0], authScreen: true }))))));
};


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthButtonView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var AuthButtonView = function (_a) {
    var buttonText = _a.buttonText, focusRef = _a.focusRef;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { ref: focusRef, tabIndex: 0, className: "auth-btn" }, buttonText));
};


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HomeScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_block_MovieBlockView__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_movie_service__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__homeScreenStyles_css__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__homeScreenStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__homeScreenStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_general_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_general_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_general_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_block_ContinueWatchingBlockView__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_buttons_ScrollToTopButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks_useTVScroll__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_welcome_overlay_WelcomeOverlay__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__context_App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_footer_FooterView__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_SkeletonContentLayout__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__context_ModalContext__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__context_ExitModalContext__ = __webpack_require__(37);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};





















var DOUBLE_BACK_WINDOW_MS = 1500;
var HomeScreen = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(), t = _a.t, i18n = _a.i18n;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_8__context_Router__["b" /* useRouter */])().navigate;
    var profile = Object(__WEBPACK_IMPORTED_MODULE_5__context_Auth__["b" /* useAuth */])().profile;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), continueWatchingBlock = _b[0], setContinueWatchingBlock = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), movieBlocks = _c[0], setMovieBlocks = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0), totalBlocksCount = _e[0], setTotalBlocksCount = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), loadedBlocks = _f[0], setLoadedBlocks = _f[1];
    var loadedBlocksRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(loadedBlocks);
    loadedBlocksRef.current = loadedBlocks;
    var verticalRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _g = Object(__WEBPACK_IMPORTED_MODULE_15__context_App__["b" /* useApp */])(), welcomeShown = _g.welcomeShown, dispatch = _g.dispatch;
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!welcomeShown), showWelcome = _h[0], setShowWelcome = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0), offset = _j[0], setOffset = _j[1];
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_18__context_ModalContext__["b" /* useModalContext */])().showModal;
    var _k = Object(__WEBPACK_IMPORTED_MODULE_19__context_ExitModalContext__["b" /* useExitModal */])(), openExitModal = _k.openExitModal, isExitModalOpen = _k.isExitModalOpen, otherModalOpen = _k.otherModalOpen;
    var lastBackAtRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handleKeyDown = function (e) {
            if (!__WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].isKey(e.keyCode, "BACK"))
                return;
            if (isExitModalOpen())
                return;
            if (otherModalOpen()) {
                lastBackAtRef.current = 0;
                return;
            }
            var now = Date.now();
            if (now - lastBackAtRef.current <= DOUBLE_BACK_WINDOW_MS) {
                e.preventDefault();
                e.stopPropagation();
                lastBackAtRef.current = 0;
                openExitModal();
            }
            else {
                lastBackAtRef.current = now;
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [openExitModal, isExitModalOpen]);
    var blocksPerCall = 3;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].manualFocus("main-navbar", 0);
    }, []);
    var loadNextBlock = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setLoadedBlocks(function (prevLoaded) {
            if (prevLoaded.length < movieBlocks.length) {
                var nextBlock = movieBlocks[prevLoaded.length];
                var rowIndex = continueWatchingBlock.length > 0
                    ? prevLoaded.length + 3
                    : prevLoaded.length + 2;
                __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].registerGroup({
                    name: nextBlock.slug,
                    position: rowIndex + 10,
                    itemHeight: 530,
                    verticalContainer: verticalRef.current,
                });
                return __spreadArrays(prevLoaded, [nextBlock]);
            }
            return prevLoaded;
        });
    }, [movieBlocks, continueWatchingBlock.length]);
    var fetchBlocks = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (overrideOffset) { return __awaiter(void 0, void 0, void 0, function () {
        var currentOffset, res, newItems_1, registerBlock_1, baseIndex_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    currentOffset = overrideOffset !== null && overrideOffset !== void 0 ? overrideOffset : offset;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4__services_movie_service__["d" /* getMovieBlocks */])({
                            lang: i18n.language,
                            limit: blocksPerCall,
                            offset: currentOffset,
                        })];
                case 2:
                    res = _a.sent();
                    setTotalBlocksCount(res.count);
                    newItems_1 = res.items || [];
                    if (newItems_1.length) {
                        setMovieBlocks(function (prev) { return __spreadArrays(prev, newItems_1); });
                        setOffset(function (prev) { return prev + blocksPerCall; });
                        if (currentOffset === 0 && !welcomeShown) {
                            setTimeout(function () {
                                setShowWelcome(false);
                                dispatch({
                                    type: "SET_WELCOME_SHOWN",
                                    welcomeShown: true,
                                });
                            }, 3000);
                        }
                        registerBlock_1 = function (block, rowIndex) {
                            __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].registerGroup({
                                name: block.slug,
                                position: rowIndex + 10,
                                itemHeight: 530,
                                verticalContainer: verticalRef.current,
                                resetIndexOnVerticalMove: true,
                            });
                        };
                        if (currentOffset === 0) {
                            newItems_1.forEach(function (block, i) {
                                var rowIndex = continueWatchingBlock.length > 0 ? i + 3 : i + 2;
                                registerBlock_1(block, rowIndex);
                            });
                            setLoadedBlocks(newItems_1);
                        }
                        else {
                            baseIndex_1 = loadedBlocksRef.current.length;
                            newItems_1.forEach(function (block, i) {
                                var rowIndex = continueWatchingBlock.length > 0
                                    ? baseIndex_1 + i + 3
                                    : baseIndex_1 + i + 2;
                                registerBlock_1(block, rowIndex);
                            });
                            setLoadedBlocks(function (prev) { return __spreadArrays(prev, newItems_1); });
                        }
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        blocksPerCall,
        i18n.language,
        continueWatchingBlock.length,
        isLoading,
        welcomeShown,
        dispatch,
        offset,
    ]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        // Reset on language change
        setMovieBlocks([]);
        setLoadedBlocks([]);
        setOffset(0);
        fetchBlocks(0);
    }, [i18n.language]);
    var onEndReached = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (loadedBlocks.length < movieBlocks.length) {
            loadNextBlock();
        }
        else if (!isLoading && movieBlocks.length < totalBlocksCount) {
            fetchBlocks();
        }
    }, [
        loadedBlocks.length,
        movieBlocks.length,
        totalBlocksCount,
        isLoading,
        loadNextBlock,
        fetchBlocks,
    ]);
    var _l = Object(__WEBPACK_IMPORTED_MODULE_13__hooks_useTVScroll__["b" /* useTVScroll */])({ onEndReached: onEndReached }), scrollToTopVisible = _l.scrollToTopVisible, focusedGroup = _l.focusedGroup;
    var focusedBlockIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        if (!focusedGroup)
            return 0;
        var idx = loadedBlocks.findIndex(function (b) { return b.slug === focusedGroup; });
        return idx >= 0 ? idx : 0;
    }, [focusedGroup, loadedBlocks]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!(profile === null || profile === void 0 ? void 0 : profile.id) || !i18n.language)
            return;
        Object(__WEBPACK_IMPORTED_MODULE_4__services_movie_service__["b" /* getContinueWatchingList */])({ lang: i18n.language }).then(function (res) {
            setContinueWatchingBlock(res);
            if (res.length > 0) {
                __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].registerGroup({
                    name: "continueWatchingBlock",
                    position: 2,
                    itemHeight: 330,
                    verticalContainer: verticalRef.current,
                });
            }
        });
    }, [i18n.language, profile === null || profile === void 0 ? void 0 : profile.id]);
    var handleMoviePress = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (movie) {
        var result = Object(__WEBPACK_IMPORTED_MODULE_10__utils_Helpers__["j" /* onMoviePress */])(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    var renderedBlocks = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        var hasContinueWatching = continueWatchingBlock.length > 0;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            hasContinueWatching && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_views_block_ContinueWatchingBlockView__["a" /* ContinueWatchingBlockView */], { title: t("layout.continue_watching"), continueWatchingBlock: continueWatchingBlock, onMoviePress: handleMoviePress })),
            loadedBlocks.map(function (block, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_views_block_MovieBlockView__["a" /* MovieBlockView */], { key: block.id, slug: block.slug, title: block.title, movies: block.movies, block: block, active: Object(__WEBPACK_IMPORTED_MODULE_13__hooks_useTVScroll__["a" /* isWithinPosterWindow */])(index, focusedBlockIndex), onMoviePress: handleMoviePress })); })));
    }, [
        loadedBlocks,
        continueWatchingBlock,
        t,
        handleMoviePress,
        focusedBlockIndex,
    ]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        showWelcome && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_views_welcome_overlay_WelcomeOverlay__["a" /* WelcomeOverlay */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* Header */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "screen-container", ref: verticalRef },
            isLoading && movieBlocks.length === 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_views_SkeletonContentLayout__["a" /* SkeletonContentLayout */], { showTitle: true, skeletonCount: 6 })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, renderedBlocks)),
            loadedBlocks.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_views_footer_FooterView__["a" /* FooterView */], { simple: true })),
        scrollToTopVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_views_buttons_ScrollToTopButton__["a" /* ScrollToTopButton */], null)));
};


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__headerViewStyles_css__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__headerViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__headerViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LanguageChangeButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_beta_PublicBeta__ = __webpack_require__(112);








var HeaderView = function (_a) {
    var navigate = _a.navigate;
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])().t;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].registerGroup({ name: "main-navbar", position: 1 });
    }, [navigate, __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */]]);
    var homeRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_Helpers__["k" /* useFocusable */])({
        group: "main-navbar",
        index: 0,
        onKeyDown: function () { return navigate("home"); },
    });
    var movieRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_Helpers__["k" /* useFocusable */])({
        group: "main-navbar",
        index: 1,
        onKeyDown: function () { return navigate("movies", { movieType: "movie" }); },
    });
    var seriesRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_Helpers__["k" /* useFocusable */])({
        group: "main-navbar",
        index: 2,
        onKeyDown: function () { return navigate("tv-shows", { movieType: "series" }); },
    });
    var searchButtonRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_Helpers__["k" /* useFocusable */])({
        group: "main-navbar",
        index: 3,
        onKeyDown: function () { return navigate("search"); },
    });
    // LanguageChangeButton 4
    var profileButtonRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_Helpers__["k" /* useFocusable */])({
        group: "main-navbar",
        index: 5,
        onKeyDown: function () { return navigate("profiles"); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-container header", id: "main-navbar" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gradient" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "caveaplus-logo" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-menu-left" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { ref: homeRef, tabIndex: 0, className: "menu-item" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, t("header.home"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { tabIndex: 0, ref: movieRef, className: "menu-item" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, t("header.movies"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { tabIndex: 0, ref: seriesRef, className: "menu-item tv-shows-menu-item" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, t("header.tv_shows")))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-menu-right" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { tabIndex: 0, ref: searchButtonRef, className: "search-icon" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__LanguageChangeButton__["a" /* LanguageChangeButton */], { focusRaw: ["main-navbar", 4] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { tabIndex: 0, ref: profileButtonRef, className: "manage-profile" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, t("header.manage_profile"))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__public_beta_PublicBeta__["a" /* PublicBeta */], null)));
};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublicBeta; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__publicBetaStyles_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__publicBetaStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__publicBetaStyles_css__);



var PublicBeta = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(), t = _a.t, i18n = _a.i18n;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "public-beta" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, t("layout.public_beta")))));
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieBlockView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movie_MovieItemView__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movieBlockViewStyles_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movieBlockViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__movieBlockViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__movie_SeeMoreItemView__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BlockItemCard__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Focus__ = __webpack_require__(3);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};








var MovieBlockView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var slug = _a.slug, title = _a.title, movies = _a.movies, onMoviePress = _a.onMoviePress, block = _a.block, _b = _a.active, active = _b === void 0 ? true : _b;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_3__context_Router__["b" /* useRouter */])().navigate;
    var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (containerRef.current) {
            __WEBPACK_IMPORTED_MODULE_6__utils_Focus__["b" /* focusManager */].registerGroup({
                name: slug,
                horizontalContainer: containerRef.current,
            });
        }
    }, [slug]);
    var items = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        var _a;
        var blockItems = (_a = block === null || block === void 0 ? void 0 : block.blockItems) !== null && _a !== void 0 ? _a : [];
        var blockItemPositions = new Set(blockItems.map(function (b) { return b.position; }));
        var merged = [];
        for (var _i = 0, blockItems_1 = blockItems; _i < blockItems_1.length; _i++) {
            var blockItem = blockItems_1[_i];
            merged.push({
                position: blockItem.position,
                item: __assign(__assign({}, blockItem), { isBlock: true }),
            });
        }
        var movieIndex = 0;
        for (var position = 0; movieIndex < movies.length; position++) {
            if (blockItemPositions.has(position))
                continue;
            merged.push({
                position: position,
                item: movies[movieIndex],
            });
            movieIndex++;
        }
        var sorted = merged
            .sort(function (a, b) { return a.position - b.position; })
            .map(function (m) { return m.item; });
        var result = sorted.slice(0, 10);
        var finalItems = result.slice(0, 10);
        var isBlocksType = (block === null || block === void 0 ? void 0 : block.blockType) === "blocks";
        if (isBlocksType) {
            return finalItems;
        }
        return __spreadArrays(finalItems, [{ id: "see_more-" + slug, seeMore: true }]);
    }, [movies, block, slug]);
    var renderItem = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (item, i) {
        if ("seeMore" in item && item.seeMore) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__movie_SeeMoreItemView__["a" /* SeeMoreItemView */], { key: item.id, onPress: function () { return navigate("see-more", { slug: slug }); }, focusRaw: [slug, i] }));
        }
        if ("isBlock" in item && item.isBlock) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__BlockItemCard__["a" /* BlockItemCard */], { key: "block-" + item.targetSlug + "-" + i, item: item, focusRaw: [slug, i], active: active }));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__movie_MovieItemView__["a" /* MovieItemView */], { key: item.id, movie: item, focusRaw: [slug, i], active: active, onMoviePress: onMoviePress }));
    }, [slug, onMoviePress, active]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, title),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: containerRef, id: slug, className: "block-movies-container" }, items.length > 0
            ? items.map(function (block, index) { return renderItem(block, index); })
            : null)));
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieTagView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movieItemViewStyles_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movieItemViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__movieItemViewStyles_css__);



var MovieTagView = function (_a) {
    var movie = _a.movie;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    var isComingSoon = movie.status === "CS" ||
        (movie.episodes && movie.episodes[0].status === "CS");
    var isEST = movie.type === "EST" && !movie.bought;
    return isComingSoon ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "tag" }, t("movie.coming_soon"))) : isEST ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "tag" }, t("card.movie.buy"))) : null;
};


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieLabelView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__);


var MovieLabelView = function (_a) {
    var movie = _a.movie;
    if (!movie.label) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "movie-label movie-label--" + movie.label.color }, movie.label.name));
};


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeeMoreItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);





var SeeMoreItemView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var onPress = _a.onPress, focusRaw = _a.focusRaw;
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])().t;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_2__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: onPress,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, tabIndex: 0, className: "movie-card-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "movie-card-btn" }, t("movie.blocks.see_more"))));
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockItemCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__movieBlockViewStyles_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__movieBlockViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__movieBlockViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__movie_MoviePoster__ = __webpack_require__(20);






var BlockItemCard = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var item = _a.item, focusRaw = _a.focusRaw, _b = _a.active, active = _b === void 0 ? true : _b;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_2__context_Router__["b" /* useRouter */])().navigate;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () {
            if (!item.targetSlug)
                return;
            navigate("see-more", { slug: item.targetSlug });
        },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { tabIndex: 0, ref: ref, className: "movie-card-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__movie_MoviePoster__["a" /* MoviePoster */], { url: item.image || "", active: active }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "movie-title" }, item.title)));
});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(120);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var bind = __webpack_require__(51);
var Axios = __webpack_require__(121);
var mergeConfig = __webpack_require__(58);
var defaults = __webpack_require__(40);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(24);
axios.CancelToken = __webpack_require__(140);
axios.isCancel = __webpack_require__(57);
axios.VERSION = __webpack_require__(59).version;
axios.toFormData = __webpack_require__(54);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(9);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(141);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(142);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var buildURL = __webpack_require__(52);
var InterceptorManager = __webpack_require__(122);
var dispatchRequest = __webpack_require__(123);
var mergeConfig = __webpack_require__(58);
var buildFullPath = __webpack_require__(56);
var validator = __webpack_require__(139);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var transformData = __webpack_require__(124);
var isCancel = __webpack_require__(57);
var defaults = __webpack_require__(40);
var CanceledError = __webpack_require__(24);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var defaults = __webpack_require__(40);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(128)
var ieee754 = __webpack_require__(129)
var isArray = __webpack_require__(130)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 129 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 130 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(9);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(59).version;
var AxiosError = __webpack_require__(9);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(24);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContinueWatchingBlockView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieBlockViewStyles_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieBlockViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieBlockViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__movie_ContinueWatchingItemView__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Focus__ = __webpack_require__(3);





var ContinueWatchingBlockView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var title = _a.title, continueWatchingBlock = _a.continueWatchingBlock, onMoviePress = _a.onMoviePress;
    var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (containerRef.current) {
            __WEBPACK_IMPORTED_MODULE_3__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "continueWatchingBlock",
                horizontalContainer: containerRef.current,
            });
        }
    }, []);
    var renderItem = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (c, i) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__movie_ContinueWatchingItemView__["a" /* ContinueWatchingItemView */], { focusRaw: ["continueWatchingBlock", i], key: c.movie.id, movie: c.movie, watchHistory: c.watchHistory, onMoviePress: onMoviePress }));
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, title),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: containerRef, className: "block-movies-container" }, continueWatchingBlock.length > 0
            ? continueWatchingBlock.map(function (block, index) {
                return renderItem(block, index);
            })
            : null)));
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContinueWatchingItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieItemViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MoviePoster__ = __webpack_require__(20);




var ContinueWatchingItemView = function (_a) {
    var watchHistory = _a.watchHistory, movie = _a.movie, onMoviePress = _a.onMoviePress, focusRaw = _a.focusRaw;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_2__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onMoviePress(movie); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, tabIndex: 0, className: "movie-card-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MoviePoster__["a" /* MoviePoster */], { url: movie.poster }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "rating" }, movie.mpaaRating),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "movie-progress-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "continue-watching-movie-title" }, movie.name),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "progress-box" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "bar", style: "width: " + (watchHistory.progress > 0.05 ? watchHistory.progress * 100 : 5) + "%" })))));
};


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WelcomeOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__welcomeOverlayStyles_css__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__welcomeOverlayStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__welcomeOverlayStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_LoadShaka__ = __webpack_require__(27);



var WelcomeOverlay = function () {
    var engineVersion = Object(__WEBPACK_IMPORTED_MODULE_2__utils_LoadShaka__["c" /* getStvVersionNumber */])();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "app-loader", className: "app-loader" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "app-loader-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "app-loader-logo" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "loading-text" }, "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0, \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10D3\u10D0\u10D4\u10DA\u10DD\u10D3\u10DD\u10D7"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "version" },
                "Version: ",
                window.CAVEA_PLUS_STB_VERSION || ""),
            engineVersion ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "engine-version" },
                "Engine: ",
                engineVersion)) : null)));
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieItemViewSkeleton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewSkeletonStyles_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movieItemViewSkeletonStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movieItemViewSkeletonStyles_css__);



var MovieItemViewSkeleton = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "movie-card-skeleton" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-poster" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-rating" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-title" })));
});


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterSkeletons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filterSkeletonStyles_css__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filterSkeletonStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filterSkeletonStyles_css__);



var FilterSkeletons = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-filter-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-filter" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-filter" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skeleton-filter" })));
});


/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilesScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_profiles_profilesViewStyles_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_profiles_profilesViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_profiles_profilesViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_profiles_ProfilesView__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_modals_LogoutConfirmModal__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Focus__ = __webpack_require__(3);









var ProfilesScreen = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_4__context_Auth__["b" /* useAuth */])(), user = _a.user, profile = _a.profile, profiles = _a.profiles;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), logoutModal = _b[0], setLogoutModal = _b[1];
    var handleOnLogout = function () {
        Object(__WEBPACK_IMPORTED_MODULE_5__services_user_service__["d" /* logout */])().then(function () {
            window.close();
        });
    };
    var handleOnClose = function () {
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].popLayer();
        setLogoutModal(false);
    };
    var handleLogOut = function () {
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "logoutModal", index: 0 });
        setLogoutModal(true);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        user && profiles ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_views_profiles_ProfilesView__["a" /* ProfilesView */], { key: "profiles-view", t: t, profiles: profiles, userName: user.firstName, userMail: user.email, handleLogOut: handleLogOut, selectedProfile: profile })) : null,
        logoutModal && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "modal-overlay", tabIndex: 0, className: "modal-overlay", key: "logout-confirm-modal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_views_modals_LogoutConfirmModal__["a" /* default */], { onClose: handleOnClose, onLogout: handleOnLogout })))));
};


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilesView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_ProfilesHeaderView__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profilesViewStyles_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profilesViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__profilesViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_Router__ = __webpack_require__(4);









var ProfilesView = function (_a) {
    var t = _a.t, profiles = _a.profiles, userName = _a.userName, userMail = _a.userMail, handleLogOut = _a.handleLogOut, selectedProfile = _a.selectedProfile;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */].registerGroup({ name: "logout", position: 10 });
        __WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */].registerGroup({ name: "profile", position: 20 });
        __WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */].manualFocus("profile", 0);
    }, [__WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */]]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "screen-container profiles-screen" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__header_ProfilesHeaderView__["a" /* ProfilesHeaderView */], { t: t, userName: userName, userMail: userMail, handleLogOut: handleLogOut }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "section-title" }, t("profile.choose_title")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "profiles", className: "profile-items" }, profiles &&
                    profiles.map(function (profile, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProfileItemView, { key: i, profile: profile, index: i, selectedProfile: selectedProfile })); }))))));
};
var ProfileItemView = function (_a) {
    var profile = _a.profile, index = _a.index, selectedProfile = _a.selectedProfile;
    var dispatch = Object(__WEBPACK_IMPORTED_MODULE_6__context_Auth__["b" /* useAuth */])().dispatch;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_7__context_Router__["b" /* useRouter */])().navigate;
    var selectProfile = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (profile && profile.id) {
            Object(__WEBPACK_IMPORTED_MODULE_5__services_user_service__["f" /* updateChosenProfile */])(profile.id).then(function () {
                dispatch({ type: "SET_PROFILE", profile: profile });
                navigate("home");
            });
        }
    }, []);
    var ref = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "profile",
        index: index,
        onKeyDown: selectProfile,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "profile-item-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, tabIndex: 0, className: "profile-item " + (selectedProfile && selectedProfile.id === profile.id
                ? "selected-profile"
                : "") }, profile.forKids ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "kids-icon" }) : null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "profile-name" }, profile.name)));
};


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilesHeaderView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profilesHeaderViewStyles_css__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profilesHeaderViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__profilesHeaderViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sprite_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sprite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sprite_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);




var ProfilesHeaderView = function (_a) {
    var t = _a.t, userName = _a.userName, userMail = _a.userMail, handleLogOut = _a.handleLogOut;
    var isSilkUser = userMail.indexOf("@silk-tv.internal") > -1;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "logout",
        index: 0,
        onKeyDown: handleLogOut,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "caveaplus-logo" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "sign-in-info" },
                t("profile.signed_in_as"),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    userName,
                    " ",
                    !isSilkUser && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        ", ",
                        userMail))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { id: "log-out-btn", tabIndex: 0, ref: ref, className: "logout-btn" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "log-out-icon" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, t("header.logout"))))));
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttons_LogoutButtonView__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalStyles_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modalStyles_css__);




var LogoutConfirmModal = function (_a) {
    var onClose = _a.onClose, onLogout = _a.onLogout;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "modal-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "info-text" }, t("logout.text")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__buttons_LogoutButtonView__["a" /* LogoutButtonView */], { onLogout: onLogout, onClose: onClose }))));
};
/* harmony default export */ __webpack_exports__["a"] = (LogoutConfirmModal);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogoutButtonView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__buttonViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);




var LogoutButtonView = function (_a) {
    var onLogout = _a.onLogout, onClose = _a.onClose;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    var closeRef = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "logoutModal",
        index: 0,
        onKeyDown: onClose,
    });
    var exitRef = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "logoutModal",
        index: 1,
        onKeyDown: onLogout,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "btn-container", id: "exit-confirm-modal" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { tabIndex: 0, ref: closeRef, className: "purple-border-btn" }, t("modal.close")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { tabIndex: 0, ref: exitRef, className: "purple-border-btn" }, t("modal.exit"))));
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoviesScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_movie_service__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MoviesScreenStyles_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MoviesScreenStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MoviesScreenStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_general_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_general_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_general_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_movie_MovieRowView__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_filter_MovieFiltersView__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_footer_FooterView__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_buttons_ScrollToTopButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useTVScroll__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_SkeletonContentLayout__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__context_ModalContext__ = __webpack_require__(11);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};



















var MoviesScreen = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_7__context_Router__["b" /* useRouter */])(), route = _a.route, params = _a.params, navigate = _a.navigate;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(), t = _b.t, i18n = _b.i18n;
    var profile = Object(__WEBPACK_IMPORTED_MODULE_4__context_Auth__["b" /* useAuth */])().profile;
    var _c = Object(__WEBPACK_IMPORTED_MODULE_8__context_App__["b" /* useApp */])(), dispatch = _c.dispatch, genres = _c.genres;
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), movies = _d[0], setMovies = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), hasMore = _f[0], setHasMore = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), cleared = _g[0], setCleared = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ genres: [], dubbing: [] }), filters = _h[0], setFilters = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(8), loadedRowsCount = _j[0], setLoadedRowsCount = _j[1]; // Start with 8 rows
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_17__context_ModalContext__["b" /* useModalContext */])().showModal;
    var prevRowsLengthRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
    var hasLoadedOnceRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var requestIdRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
    var verticalRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var movieTypeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(params.movieType
        ? params.movieType
        : route === "movies"
            ? "movie"
            : "series");
    var mappedGenres = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return genres.map(function (g) { return ({ id: g.id, name: g.name }); }); }, [genres]);
    var languageKeys = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return Object.keys(t("dub_languages", { returnObjects: true })); }, [t]);
    var languages = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return languageKeys.map(function (key) { return ({
            id: key,
            name: t("dub_languages." + key),
        }); });
    }, [languageKeys, t]);
    var handleChosenGenre = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (genre) {
        setFilters(function (prev) {
            var genreId = genre.id;
            var isChosen = prev.genres.some(function (g) { return g.id === genreId; });
            if (isChosen) {
                return __assign(__assign({}, prev), { genres: prev.genres.filter(function (g) { return g.id !== genreId; }) });
            }
            return __assign(__assign({}, prev), { genres: __spreadArrays(prev.genres, [genre]) });
        });
    }, []);
    var handleChosenDubb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (dubb) {
        setFilters(function (prev) {
            var dubbId = dubb.id;
            var isChosen = prev.dubbing.some(function (d) { return d.id === dubbId; });
            if (isChosen) {
                return __assign(__assign({}, prev), { dubbing: prev.dubbing.filter(function (d) { return d.id !== dubbId; }) });
            }
            return __assign(__assign({}, prev), { dubbing: __spreadArrays(prev.dubbing, [dubb]) });
        });
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__services_movie_service__["c" /* getGenres */])({ lang: i18n.language }).then(function (res) {
            dispatch({ type: "SET_GENRES", genres: res });
        });
    }, [i18n.language, dispatch]);
    var fetchMovies = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (isInitial) {
        if (isInitial === void 0) { isInitial = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var requestId, limit, offset, genreIds, dubs, movieType, res, newItems_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isInitial && (isLoading || !hasMore))
                            return [2 /*return*/];
                        setIsLoading(true);
                        requestId = ++requestIdRef.current;
                        limit = 45;
                        offset = isInitial ? 0 : movies.length;
                        genreIds = filters.genres.map(function (g) { return g.id; });
                        dubs = filters.dubbing.map(function (d) { return d.id; });
                        movieType = params.movieType
                            ? params.movieType
                            : route === "movies"
                                ? "movie"
                                : "series";
                        if (movieTypeRef.current !== movieType) {
                            setFilters({ genres: [], dubbing: [] });
                            movieTypeRef.current = movieType;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3__services_movie_service__["e" /* getMoviesList */])({
                                lang: i18n.language,
                                limit: limit,
                                offset: offset,
                                movieType: movieType,
                                order: "newest",
                                genres: genreIds,
                                dubs: dubs,
                            })];
                    case 2:
                        res = _a.sent();
                        if (requestId !== requestIdRef.current)
                            return [2 /*return*/];
                        newItems_1 = res.items || [];
                        setMovies(function (prev) { return (isInitial ? newItems_1 : __spreadArrays(prev, newItems_1)); });
                        setHasMore(offset + newItems_1.length < res.count);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        if (requestId === requestIdRef.current) {
                            setIsLoading(false);
                            hasLoadedOnceRef.current = true;
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [
        filters,
        movies.length,
        isLoading,
        hasMore,
        params.movieType,
        route,
        i18n.language,
    ]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_14__utils_Focus__["b" /* focusManager */].manualFocus("main-navbar", movieTypeRef.current === "movie" ? 1 : 2);
    }, [__WEBPACK_IMPORTED_MODULE_14__utils_Focus__["b" /* focusManager */]]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setMovies([]);
        setHasMore(true);
        setLoadedRowsCount(8);
        setCleared(true);
    }, [
        profile,
        params.movieType,
        filters.genres,
        filters.dubbing,
        i18n.language,
    ]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cleared) {
            setCleared(false);
            fetchMovies(true);
        }
    }, [cleared]);
    var rows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_9__utils_Helpers__["a" /* chunkArray */])(movies, 6); }, [movies]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        for (var i = rows.length; i < prevRowsLengthRef.current; i++) {
            __WEBPACK_IMPORTED_MODULE_14__utils_Focus__["b" /* focusManager */].removeGroup("row-" + i);
        }
        prevRowsLengthRef.current = rows.length;
        rows.slice(0, loadedRowsCount).forEach(function (_, index) {
            __WEBPACK_IMPORTED_MODULE_14__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "row-" + index,
                position: index + 100,
                itemHeight: 530,
                verticalContainer: verticalRef.current,
            });
        });
    }, [rows, loadedRowsCount]);
    var onEndReached = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (loadedRowsCount < rows.length) {
            setLoadedRowsCount(function (prev) { return prev + 4; });
        }
        else {
            fetchMovies();
        }
    }, [loadedRowsCount, rows.length, fetchMovies]);
    var handleMoviePress = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (movie) {
        var result = Object(__WEBPACK_IMPORTED_MODULE_9__utils_Helpers__["j" /* onMoviePress */])(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    var showInitialSkeleton = isLoading && movies.length === 0 && !hasLoadedOnceRef.current;
    var _k = Object(__WEBPACK_IMPORTED_MODULE_15__hooks_useTVScroll__["b" /* useTVScroll */])({ onEndReached: onEndReached }), scrollToTopVisible = _k.scrollToTopVisible, focusedGroup = _k.focusedGroup;
    var focusedRowIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        if (focusedGroup && focusedGroup.indexOf("row-") === 0) {
            var parsed = parseInt(focusedGroup.slice(4), 10);
            if (!Number.isNaN(parsed))
                return parsed;
        }
        return 0;
    }, [focusedGroup]);
    var renderedRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return rows
            .slice(0, loadedRowsCount)
            .map(function (row, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_views_movie_MovieRowView__["a" /* MovieRowView */], { key: index, index: index, movies: row, hasHorizontalScroll: false, active: Object(__WEBPACK_IMPORTED_MODULE_15__hooks_useTVScroll__["a" /* isWithinPosterWindow */])(index, focusedRowIndex), onMoviePress: handleMoviePress })); });
    }, [rows, loadedRowsCount, handleMoviePress, focusedRowIndex]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* Header */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: verticalRef, className: "screen-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "movies-container" }, showInitialSkeleton ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_views_SkeletonContentLayout__["a" /* SkeletonContentLayout */], { skeletonCount: 6, showTitle: false, isMoviesScreen: true })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_views_filter_MovieFiltersView__["a" /* MovieFiltersView */], { genres: mappedGenres, languages: languages, filters: filters, handleChosenGenre: handleChosenGenre, handleChosenDubb: handleChosenDubb, handleClearFilters: function () {
                        return setFilters({ genres: [], dubbing: [] });
                    }, verticalContainer: verticalRef.current }),
                movies.length === 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "not-found" }, isLoading ? t("player.loading") : t("filters.not_found")))) : (renderedRows),
                (!hasMore || rows.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_views_footer_FooterView__["a" /* FooterView */], null))))),
        scrollToTopVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_views_buttons_ScrollToTopButton__["a" /* ScrollToTopButton */], null)));
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieFiltersView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtersViewStyles_css__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtersViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filtersViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectFilterView__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Helpers__ = __webpack_require__(2);







var MovieFiltersView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_a) {
    var genres = _a.genres, languages = _a.languages, filters = _a.filters, handleChosenGenre = _a.handleChosenGenre, handleChosenDubb = _a.handleChosenDubb, handleClearFilters = _a.handleClearFilters, verticalContainer = _a.verticalContainer;
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])().t;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */].registerGroup({
            name: "filters",
            position: 2,
            itemHeight: 120,
            verticalContainer: verticalContainer,
        });
    }, [verticalContainer]);
    var clearFilterRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["k" /* useFocusable */])({
        group: "filters",
        index: 2,
        onKeyDown: handleClearFilters,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "filters", className: "filters-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__SelectFilterView__["a" /* SelectFilterView */], { focusRaw: ["filters", 0], options: genres, filter: "genres", onSelect: handleChosenGenre, selected: filters.genres, filterName: t("filters.genres") }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__SelectFilterView__["a" /* SelectFilterView */], { focusRaw: ["filters", 1], options: languages, filter: "dubbing", onSelect: handleChosenDubb, selected: filters.dubbing, filterName: t("filters.dubbing") }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { ref: clearFilterRef, tabIndex: 0, className: "clear-filters-btn" }, t("filters.clear"))));
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectFilterView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtersViewStyles_css__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtersViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filtersViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sprite_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sprite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sprite_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectFilterItemView__ = __webpack_require__(162);








var SelectFilterView = function (_a) {
    var options = _a.options, selected = _a.selected, filter = _a.filter, filterName = _a.filterName, onSelect = _a.onSelect, focusRaw = _a.focusRaw;
    var t = Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* useTranslation */])().t;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), popup = _b[0], setPopup = _b[1];
    var handleOpenFilter = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: filter, index: 0, isolate: true });
        setPopup(true);
    }, [filter]);
    var handleCloseFilter = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setPopup(false);
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].popLayer();
    }, []);
    var ref = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: handleOpenFilter,
        onKeyBack: handleCloseFilter,
    });
    var popupRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (popup && popupRef.current) {
            __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].registerGroup({
                name: filter,
                verticalContainer: popupRef.current,
            });
        }
    }, [popup, filter]);
    var handleOnSelect = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (item) {
        // Apply immediately (grid refetches) but keep the popup open; closes on Back.
        onSelect(item);
    }, [onSelect]);
    var renderItem = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SelectFilterItemView__["a" /* SelectFilterItemView */], { key: index + "-" + item.id, index: index, item: item, filter: filter, selected: selected, handleOnSelect: handleOnSelect, onClose: handleCloseFilter })); }, [selected, filter, handleOnSelect, handleCloseFilter]);
    var singleSelectedName = selected.length === 1
        ? (options.find(function (option) { return option.id === selected[0].id; }) || selected[0])
            .name
        : "";
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, className: "select-filter", tabIndex: 0 },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: selected.length + "-" + filterName },
            selected.length === 1
                ? singleSelectedName
                : selected.length > 1
                    ? selected.length + " " + filterName + " " + t("filters.selected")
                    : filterName,
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "select-icon " + (popup ? "arrow-up" : "arrow-down") })),
        popup ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "popup" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { ref: popupRef, id: filter + "-list", className: "select-options" }, options.map(function (item, index) { return renderItem(item, index); })))) : null));
};


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectFilterItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Focus__ = __webpack_require__(3);



var SelectFilterItemView = function (_a) {
    var item = _a.item, index = _a.index, filter = _a.filter, selected = _a.selected, handleOnSelect = _a.handleOnSelect, onClose = _a.onClose;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: filter,
        index: index,
        direction: __WEBPACK_IMPORTED_MODULE_2__utils_Focus__["a" /* FocusableItemDirectionEnum */].Vertical,
        onKeyDown: function () { return handleOnSelect(item); },
        onKeyBack: onClose,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { key: index + "-" + item.id, ref: ref, tabIndex: 0 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "checkbox-box" }, selected.findIndex(function (s) { return s.id === item.id; }) > -1 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "checkbox" })) : null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, item.name)));
};


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_search_SearchInputView__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__searchScreenStyles_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__searchScreenStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__searchScreenStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_search_SearchKeyboardView__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_movie_service__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_general_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_general_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_general_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_movie_MovieRowView__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useTVScroll__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_buttons_ScrollToTopButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_footer_FooterView__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_SkeletonContentLayout__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__context_ModalContext__ = __webpack_require__(11);


















var SearchScreen = function () {
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_8__context_Router__["b" /* useRouter */])().navigate;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])(), t = _a.t, i18n = _a.i18n;
    var verticalRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), phrase = _b[0], setPhrase = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), movies = _c[0], setMovies = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("ka"), keyboardLang = _d[0], setKeyboardLang = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(10), loadedRowsCount = _f[0], setLoadedRowsCount = _f[1];
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_16__context_ModalContext__["b" /* useModalContext */])().showModal;
    var scrollToTopVisible = Object(__WEBPACK_IMPORTED_MODULE_12__hooks_useTVScroll__["b" /* useTVScroll */])({
        onEndReached: function () {
            if (loadedRowsCount < rows.length) {
                setLoadedRowsCount(function (prev) { return prev + 5; });
            }
        },
    }).scrollToTopVisible;
    var englishKeyboard = {
        firstRow: ["1", "2", "3", "0", "a", "b", "c", "d", "e", "f", "g", "h", "⌫"],
        secondRow: [
            "4",
            "5",
            "6",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
        ],
        thirdRow: ["7", "8", "9", "t", "u", "v", "w", "x", "y", "z", " ", "🌐"],
    };
    var rows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_7__utils_Helpers__["a" /* chunkArray */])(movies, 6); }, [movies]);
    var georgianKeyboard = {
        firstRow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "⌫"],
        secondRow: ["ა", "ბ", "გ", "დ", "ე", "ვ", "ზ", "თ", "ი", "კ", "ლ", "მ"],
        thirdRow: ["ნ", "ო", "პ", "ჟ", "რ", "ს", "ტ", "უ", "ფ", "ქ", "ღ", "ყ"],
        fourthRow: ["შ", "ჩ", "ც", "ძ", "წ", "ჭ", "ხ", "ჯ", "ჰ", " ", "🌐"],
    };
    var keyboard = keyboardLang === "en" ? englishKeyboard : georgianKeyboard;
    var onKeyPress = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (key) {
        if (key === "🌐") {
            return setKeyboardLang(function (prev) {
                var newLang = prev === "en" ? "ka" : "en";
                __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].updateGroupOrder();
                __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].registerGroup({ name: "main-navbar", position: 1 });
                __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].manualFocus("key-" + newLang + "-" + (newLang === "en" ? 2 : 3), newLang === "en" ? 11 : 10, true);
                return newLang;
            });
        }
        if (key === "⌫") {
            return setPhrase(function (prevState) { return prevState.slice(0, -1); });
        }
        setPhrase(function (prevState) { return prevState + key; });
    }, [phrase]);
    var handleSearch = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (q, lang) {
        setIsLoading(true);
        return Object(__WEBPACK_IMPORTED_MODULE_6__services_movie_service__["f" /* searchMovies */])({ q: q, lang: lang }).then(function (res) {
            setMovies(res.items);
            setIsLoading(false);
        });
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (phrase.length > 0) {
            handleSearch(phrase, i18n.language);
        }
        else {
            setMovies([]);
        }
    }, [i18n.language, phrase, handleSearch]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].manualFocus("main-navbar", 3);
    }, [__WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */]]);
    var handleMoviePress = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (movie) {
        var result = Object(__WEBPACK_IMPORTED_MODULE_7__utils_Helpers__["j" /* onMoviePress */])(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        rows.slice(0, loadedRowsCount).forEach(function (_, index) {
            __WEBPACK_IMPORTED_MODULE_11__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "row-" + index,
                position: index + 100,
                itemHeight: 530,
                verticalContainer: verticalRef.current,
            });
        });
    }, [rows, loadedRowsCount]);
    var renderedRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return rows
            .slice(0, loadedRowsCount)
            .map(function (row, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_views_movie_MovieRowView__["a" /* MovieRowView */], { key: index, index: index, hasHorizontalScroll: false, movies: row, onMoviePress: handleMoviePress })); });
    }, [rows, loadedRowsCount, handleMoviePress]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* Header */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: verticalRef, className: "screen-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_views_search_SearchInputView__["a" /* SearchInputView */], { phrase: phrase, setPhrase: setPhrase, verticalContainer: verticalRef.current }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_views_search_SearchKeyboardView__["a" /* SearchKeyboardView */], { keyboard: keyboard, onKeyPress: onKeyPress, keyboardLang: keyboardLang, verticalContainer: verticalRef.current }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: movies.length, className: "search-movies-container" }, isLoading && movies.length === 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__components_views_SkeletonContentLayout__["a" /* SkeletonContentLayout */], { showTitle: false, skeletonCount: 6 })) : (renderedRows)),
            !isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_views_footer_FooterView__["a" /* FooterView */], null),
            scrollToTopVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_views_buttons_ScrollToTopButton__["a" /* ScrollToTopButton */], null))));
};


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchInputView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchViewStyles_css__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__searchViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Focus__ = __webpack_require__(3);






var SearchInputView = function (_a) {
    var phrase = _a.phrase, setPhrase = _a.setPhrase, verticalContainer = _a.verticalContainer;
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    var clearButtonRef = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: "searchClear",
        index: 0,
        onKeyDown: function () { return setPhrase(""); },
    });
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_Focus__["b" /* focusManager */].registerGroup({
            name: "searchClear",
            position: 5,
            itemHeight: 240,
            verticalContainer: verticalContainer,
        });
    }, [verticalContainer]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "search-input-container", id: "search-input-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "search-text" },
            t("search.search"),
            " |"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "search-input" }, phrase),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { tabIndex: 0, className: "clear-btn", ref: clearButtonRef }, t("search.clear"))));
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchKeyboardView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchViewStyles_css__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__searchViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchKeyboardKeyView__ = __webpack_require__(167);





var SearchKeyboardView = function (_a) {
    var keyboard = _a.keyboard, onKeyPress = _a.onKeyPress, keyboardLang = _a.keyboardLang, verticalContainer = _a.verticalContainer;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object.values(keyboard).map(function (row, i) {
            __WEBPACK_IMPORTED_MODULE_2__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "key-" + keyboardLang + "-" + i,
                position: 10,
                verticalContainer: verticalContainer,
            });
        });
    }, [__WEBPACK_IMPORTED_MODULE_2__utils_Focus__["b" /* focusManager */], keyboard, keyboardLang, verticalContainer]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "keyboard" }, Object.values(keyboard).map(function (row, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: i, id: "keyboard-row-" + i, className: "keyboard-row" }, row.map(function (key, index) {
        var className = "key";
        if (key === "⌫")
            className += " key-clear";
        if (key === " ")
            className += " key-space-" + keyboardLang;
        if (key === "🌐")
            className += " key-globe";
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__SearchKeyboardKeyView__["a" /* SearchKeyboardKeyView */], { key: index, focusRaw: ["key-" + keyboardLang + "-" + i, index], keyText: key, onKeyPressHandle: onKeyPress, className: className }));
    }))); })));
};


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchKeyboardKeyView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Helpers__ = __webpack_require__(2);


var SearchKeyboardKeyView = function (_a) {
    var focusRaw = _a.focusRaw, className = _a.className, keyText = _a.keyText, onKeyPressHandle = _a.onKeyPressHandle;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onKeyPressHandle(keyText); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { key: keyText, ref: ref, tabIndex: 0, className: className }, keyText === "🌐" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "globe-icon" }) : keyText));
};


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaveaAuthScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_auth_AuthView__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_modals_InfoModal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Focus__ = __webpack_require__(3);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var CaveaAuthScreen = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* useTranslation */])().t;
    var dispatch = Object(__WEBPACK_IMPORTED_MODULE_2__context_Auth__["b" /* useAuth */])().dispatch;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(), code = _a[0], setCode = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), sid = _b[0], setSid = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0), countDown = _c[0], setCountDown = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), runTimer = _d[0], setRunTimer = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isModalVisible = _e[0], setIsModalVisible = _e[1];
    var onClose = function () {
        setCountDown(0);
        setIsModalVisible(false);
        __WEBPACK_IMPORTED_MODULE_6__utils_Focus__["b" /* focusManager */].popLayer();
    };
    var padZero = function (num) {
        return num < 10 ? "0" + num : "" + num;
    };
    var seconds = padZero(String(countDown % 60));
    var minutes = padZero(String(Math.floor(countDown / 60)));
    var codeStart = String(code).slice(0, 3);
    var codeEnd = String(code).slice(3, 7);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var timerId;
        if (runTimer) {
            Object(__WEBPACK_IMPORTED_MODULE_1__services_user_service__["c" /* getQuickAuthCode */])().then(function (res) {
                setCode(res.code);
                if (res.sid) {
                    setSid(res.sid);
                }
            }, function () {
                __WEBPACK_IMPORTED_MODULE_6__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "modalView", index: 0 });
                setIsModalVisible(true);
            });
            setCountDown(60 * 5);
            timerId = setInterval(function () {
                setCountDown(function (prevState) {
                    return prevState - 1;
                });
            }, 1000);
        }
        return function () {
            clearInterval(timerId);
        };
    }, [runTimer]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (countDown < 0 && runTimer) {
            setRunTimer(false);
            setCountDown(0);
        }
        else if (countDown >= 0 && !runTimer) {
            setRunTimer(true);
        }
    }, [countDown, runTimer]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (code && sid) {
            var interval_1 = setInterval(function () {
                Object(__WEBPACK_IMPORTED_MODULE_1__services_user_service__["e" /* quickAuth */])(code, sid).then(function (user) {
                    if (user && user.id) {
                        dispatch({ type: "LOGIN", user: __assign({}, user) });
                    }
                });
            }, 5000);
            return function () {
                clearInterval(interval_1);
            };
        }
    }, [code, sid]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_views_auth_AuthView__["a" /* AuthView */], { codeStart: codeStart, codeEnd: codeEnd, minutes: minutes, seconds: seconds }),
        isModalVisible && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "modal-overlay", tabIndex: 0, className: "modal-overlay" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_views_modals_InfoModal__["a" /* InfoModal */], { text: t("auth.error"), onClose: onClose })))));
};


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Text__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authViewStyles_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sprite_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_sprite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_sprite_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageChangeButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AuthBackButtonView__ = __webpack_require__(172);










var AuthView = function (_a) {
    var codeStart = _a.codeStart, codeEnd = _a.codeEnd, minutes = _a.minutes, seconds = _a.seconds;
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    var params = Object(__WEBPACK_IMPORTED_MODULE_6__context_Router__["b" /* useRouter */])().params;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].registerGroup({ name: "caveaAuth", position: 1 });
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].manualFocus("caveaAuth", 1);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container", id: "cavea-auth" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title" }, t("quick-auth.title")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "auth-section-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "qr-code-container" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "url-text" }, "cavea.plus/tv")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "code-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "code-title" }, t("quick-auth.enter-code")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Text__["a" /* Text */], { className: "code" },
                    codeStart,
                    " ",
                    codeEnd),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "timer-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "clock-icon" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "time-circle" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Text__["a" /* Text */], { className: "timer" },
                        minutes,
                        ":",
                        seconds))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "button-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__LanguageChangeButton__["a" /* LanguageChangeButton */], { focusRaw: ["caveaAuth", 0], authScreen: true }),
                params.silkUserExists && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__AuthBackButtonView__["a" /* AuthBackButtonView */], { focusRaw: ["caveaAuth", 1] }))))));
};


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Text; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Text = function (_a) {
    var children = _a.children, className = _a.className;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (ref.current) {
            var text = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children).join("");
            ref.current.textContent = text;
        }
    }, [children]);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, className: className });
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthBackButtonView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);




var AuthBackButtonView = function (_a) {
    var focusRaw = _a.focusRaw;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_1__context_Router__["b" /* useRouter */])().navigate;
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return navigate("auth"); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { ref: ref, tabIndex: 0, className: "auth-back-btn" }, t("login.back")));
};


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilkAuthScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__silkAuthScreenStyles_css__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__silkAuthScreenStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__silkAuthScreenStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_Auth__ = __webpack_require__(6);








var SilkAuthScreen = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])().t;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_2__context_Router__["b" /* useRouter */])().navigate;
    var dispatch = Object(__WEBPACK_IMPORTED_MODULE_6__context_Auth__["b" /* useAuth */])().dispatch;
    var accountId = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["d" /* getIdForSTB */])("accountId", "user_id");
    var stbId = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["d" /* getIdForSTB */])("stbId", "stb_id");
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!accountId || !stbId) {
            navigate("auth-cavea");
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__services_user_service__["g" /* userRegister */])(stbId, accountId)
            .then(function () {
            Object(__WEBPACK_IMPORTED_MODULE_1__services_user_service__["a" /* authIdentify */])(stbId, accountId)
                .then(function (data) {
                dispatch({ type: "LOGIN", user: data });
            })
                .catch(function (e) {
                navigate("auth");
            });
        })
            .catch(function (e) {
            navigate("auth");
        });
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "auth-loading-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "logo-container" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "loading" }, t("auth_tv.loading"))));
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WatchScreenInner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WatchScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_Movie__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_player_service__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlayerService__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Player__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_PlayerStateContext__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_loading_spinner_LoadingSpinner__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_PlayerErrorMessageContext__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_modals_InfoModal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_LoadShaka__ = __webpack_require__(27);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
















var WatchScreenInner = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["b" /* useTranslation */])().t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__context_Router__["b" /* useRouter */])(), params = _a.params, navigate = _a.navigate, goBack = _a.goBack;
    var profile = Object(__WEBPACK_IMPORTED_MODULE_2__context_Auth__["b" /* useAuth */])().profile;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), watchData = _b[0], setWatchData = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), loading = _c[0], setLoading = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), shakaReady = _d[0], setShakaReady = _d[1];
    var lastInputAtRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(Date.now());
    var errorActions = Object(__WEBPACK_IMPORTED_MODULE_10__context_PlayerErrorMessageContext__["b" /* usePlayerErrorMessageActions */])();
    var errorState = Object(__WEBPACK_IMPORTED_MODULE_10__context_PlayerErrorMessageContext__["c" /* usePlayerErrorMessageData */])();
    var showError = function (message, route, routeLabel) {
        setLoading(false);
        __WEBPACK_IMPORTED_MODULE_9__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "modalView", index: 0 });
        errorActions.show(message, "text-danger", null);
        errorActions.returnTo(route, routeLabel);
    };
    // Shaka is fetched at runtime rather than bundled, so it has to arrive before
    // Player mounts. Starting it here runs it alongside the movie and episode
    // requests, which take far longer, so the whole cost hides behind the spinner
    // that is already on screen.
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var cancelled = false;
        Object(__WEBPACK_IMPORTED_MODULE_14__utils_LoadShaka__["d" /* loadShaka */])()
            .then(function () {
            if (!cancelled) {
                setShakaReady(true);
            }
        })
            .catch(function (error) {
            console.error("Failed to load the video player:", error);
            if (!cancelled) {
                showError(t("player.playback_failed"), "/home", t("layout.back_home"));
            }
        });
        return function () {
            cancelled = true;
        };
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handleKeyDown = function () {
            lastInputAtRef.current = Date.now();
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () { return window.removeEventListener("keydown", handleKeyDown); };
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!params.slug) {
            return;
        }
        setLoading(true);
        var watchHistory = {
            language: null,
            audio: null,
            caption: null,
            progress: 0,
            quality: "HD",
            currentTime: 0,
        };
        var currentEpisode;
        if (params.episode) {
            currentEpisode = params.episode;
        }
        var currentQuality;
        if (params.quality) {
            currentQuality = params.quality;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__services_player_service__["b" /* getMovie */])(params.slug)
            .then(function (movie) {
            var _a;
            if (!movie) {
                showError(t("player.episode_not_found"), "/home", t("layout.back_home"));
                return;
            }
            var episodeId = currentEpisode;
            var lastWatchedSeason = null;
            var lastWatchedEpisode = Object(__WEBPACK_IMPORTED_MODULE_5__PlayerService__["b" /* getLastPlayed */])(movie.episodes);
            if (lastWatchedEpisode) {
                if (lastWatchedEpisode.watchHistory) {
                    watchHistory = __assign(__assign({}, watchHistory), { language: lastWatchedEpisode.watchHistory.language, caption: lastWatchedEpisode.watchHistory.caption, quality: lastWatchedEpisode.watchHistory.quality });
                }
            }
            if (!episodeId) {
                if (lastWatchedEpisode && Object(__WEBPACK_IMPORTED_MODULE_13__utils_Helpers__["g" /* isEpisodePlayable */])(lastWatchedEpisode)) {
                    episodeId = lastWatchedEpisode.id;
                    lastWatchedSeason = lastWatchedEpisode.seasonNumber;
                }
                else {
                    var firstPlayable = Object(__WEBPACK_IMPORTED_MODULE_13__utils_Helpers__["c" /* getFirstPlayableEpisode */])(movie.episodes);
                    if (firstPlayable) {
                        episodeId = firstPlayable.id;
                        lastWatchedSeason = firstPlayable.seasonNumber;
                    }
                }
            }
            if (movie.status === __WEBPACK_IMPORTED_MODULE_3__types_Movie__["a" /* MovieStatusEnum */].CS ||
                !((_a = movie.episodes) === null || _a === void 0 ? void 0 : _a.length) ||
                !Object(__WEBPACK_IMPORTED_MODULE_13__utils_Helpers__["f" /* hasPlayableEpisodes */])(movie.episodes)) {
                showError(movie.movieType === "series"
                    ? t("coming_soon_modal.series")
                    : t("coming_soon_modal.movie"), "/home", t("layout.back_home"));
                return;
            }
            if (!episodeId) {
                showError(t("player.episode_not_found"), "/home", t("layout.back_home"));
                return;
            }
            if (movie.type === "EST" && !movie.bought) {
                showError(t("buy_movie_modal.title"), "/home", t("layout.back_home"));
                return;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_4__services_player_service__["a" /* getEpisode */])(episodeId, profile.id).then(function (data) {
                if (!data) {
                    showError(t("player.episode_not_found"), "/home", t("layout.back_home"));
                    return;
                }
                if (data.episode.watchHistory) {
                    watchHistory = __assign(__assign({}, watchHistory), data.episode.watchHistory);
                }
                // The stored quality is a single row shared across every platform
                // (web, mobile, AndroidTV) and is not validated server-side, so it can
                // arrive null or as a label Silk has no mapper for (e.g. "1080p").
                // Instead of blocking playback, fall back to whichever quality Silk
                // can actually play — losing the saved quality beats not watching.
                var resolvedQuality = (watchHistory.quality || "HD").toUpperCase();
                var source = Object(__WEBPACK_IMPORTED_MODULE_5__PlayerService__["a" /* generateSource */])(data.episode.mappers, resolvedQuality);
                if (!source) {
                    for (var _i = 0, _a = ["HD", "SD"]; _i < _a.length; _i++) {
                        var fallbackQuality = _a[_i];
                        source = Object(__WEBPACK_IMPORTED_MODULE_5__PlayerService__["a" /* generateSource */])(data.episode.mappers, fallbackQuality);
                        if (source) {
                            resolvedQuality = fallbackQuality;
                            break;
                        }
                    }
                }
                if (!source) {
                    showError(t("player.episode_not_found"), "/home", t("layout.back_home"));
                    return;
                }
                watchHistory.quality = resolvedQuality;
                var seasons = [];
                var episodeDetails = null;
                if (movie.movieType === "series") {
                    seasons = movie.episodes
                        ? movie.episodes
                            .map(function (e) { return e.seasonNumber; })
                            .filter(function (v, i, a) { return a.indexOf(v) === i; })
                        : [];
                    episodeDetails = getEpisodeDetails(movie, episodeId);
                }
                var newWatchData = {
                    quality: currentQuality || watchHistory.quality || "HD",
                    language: watchHistory.language || "ka",
                    caption: watchHistory.caption || "off",
                    progress: watchHistory.progress || 0,
                    currentTime: watchHistory.currentTime || 0,
                    movieId: movie.id,
                    movie: movie,
                    episodeId: data.episode.id,
                    episodeDetails: episodeDetails,
                    source: source,
                    watchSessionId: data.watchSessionId,
                    seasons: seasons,
                    lastWatchedSeason: lastWatchedSeason,
                    profileId: profile.id,
                    mappers: data.episode.mappers,
                };
                setWatchData(newWatchData);
                setLoading(false);
            });
        })
            .catch(function (error) {
            console.error("Failed to load movie/episode:", error);
            showError(t("player.episode_not_found"), "/home", t("layout.back_home"));
        });
    }, [params.slug, params.episode, params.quality, profile.id]);
    var getEpisodeDetails = function (movie, episodeId) {
        if (!movie || !episodeId || !movie.episodes)
            return null;
        var episode = movie.episodes.filter(function (e) { return e.id === episodeId; })[0];
        return episode
            ? {
                episodeNumber: "S" + episode.seasonNumber + ":E" + episode.episodeNumber,
                episodeName: episode.name,
            }
            : null;
    };
    var handleBackToHome = function () {
        if (errorState.returnRoute === "back" || !errorState.returnRoute) {
            __WEBPACK_IMPORTED_MODULE_9__utils_Focus__["b" /* focusManager */].popLayer();
            goBack();
        }
        else {
            navigate(errorState.returnRoute);
        }
    };
    if (errorActions.hasMessage()) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_views_modals_InfoModal__["a" /* InfoModal */], { onClose: handleBackToHome, text: errorState.message });
    }
    if (loading || !shakaReady) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_views_loading_spinner_LoadingSpinner__["a" /* LoadingSpinner */], null);
    }
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Player__["a" /* Player */], { watchData: watchData, lastInputAtRef: lastInputAtRef });
};
var WatchScreen = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__context_PlayerStateContext__["a" /* PlayerStateProvider */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__context_PlayerErrorMessageContext__["a" /* PlayerErrorMessageProvider */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WatchScreenInner, null))));
};


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(184);









var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Logger);

    this.init(concreteLogger, options);
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EventEmitter);

    this.observers = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore = function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ResourceStore);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Translator);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
          interpolation: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Connector);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[2]) === 'object' || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n = function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, I18n);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(_this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ __webpack_exports__["a"] = (i18next);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(178);

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? Object(arguments[r]) : {},
      o = Object.keys(t);
    "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), o.forEach(function (r) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    });
  }
  return e;
}


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(67);

function _defineProperty(e, r, t) {
  return (r = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPrimitive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(31);

function toPrimitive(t, r) {
  if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(67);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(68);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(t);
}


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(185);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, e);
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = {"header":{"login":"Login","register":"Register","welcome":"Welcome","profile":"Profile","account":"Account","manage_profile":"Manage profile","change_profile":"Change profile","logout":"Log out","start_trial":"Start a trial","share":"Share","seasons":"Seasons","empty_notification":"No new notifications","contact_us":"Contact us","public_beta":"Public Beta","season_ready_to_watch":"New season ready to watch","recently_added":"Recently added","home":"Home","movies":"Movies","tv_shows":"TV Shows"},"layout":{"choose_profile":"Choose profile","profiles":"Profiles","for_kids":"For kids:","back_home":"Back to home","back_movie":"Back to movie","movies":"Movies","genres":"Genres","cancel_subscription":"Cancel subscription","continue_watching":"Continue Watching","prev":"Previous","next":"Next","go_back_to_homepage":"Homepage","start_watching":"Start watching","coming_soon":"Coming soon","languages":{"ka":"GEO","en":"ENG"},"using_global":"Enter CAVEA.PLUS to watch from Georgia.","using_local":"Enter GLOBAL.CAVEA.PLUS to watch from your country","teleport":"JOIN","show_more":"Show more","scroll_to_top":"Scroll to top","public_beta":"Public beta"},"login":{"title":"Continue watching <br> your favorites","login_using":"Log in using","back":"Back","cancel":"Cancel","email":"Email","password":"Password","help":"Forgot password?","login":"Log in","incorrect":"These credentials do not match our records.","too_many_attempts":"Too many attempts. Try in 10 minutes","reset_password":"reset your password","still_no_account":"Still no account?","register":"Register here","go_back_to_homepage":"Go back to Homepage","loading":"Please wait"},"quick-auth":{"title":"Scan QR-code OR visit website on your computer/mobile device:","visit":"Visit","enter-code":"Enter one time code:","close":"Close"},"password_reset":{"wrong_email":"Wrong email or email format","title":"Password recovery","email":"Email","email_sent":"Please check your email.","go_back_to_homepage":"Go back to Homepage","next":"next"},"password_update":{"password":"Password","repeat_password":"Repeat password","save":"Save","invalid":"Please fill fields correctly","match":"The new password must be different from your current password","log_out_from_all_devices":"Log out from all devices"},"register":{"title":"Join the cinematic world","first_name":"* First name","last_name":"* Last name","gender":"* Gender","female":"Female","male":"Male","gender_choose":"Choose","birthday":"* Birthday","dd_mm_yyyy":"DD-MM-YYYY","day":"Day","month":"Month","year":"Year","email":"* Email","phone":"* Phone","password":"* Password","re_password":"* Re-Enter Password","i_agree_with":"I agree to the","terms_and_conditions":"Terms & Conditions and Privacy Policy","cavea_plus":"of Cavea+","sign_up":"Sign up","log_in":"Log in","already_have_account":"Already have an account?","required":"Field is required","wrong_date":"Wrong date","wrong_email":"Wrong email or email format","wrong_phone":"Wrong phone or phone format","exists":"This email is already in use","phone_exists":"This phone is already in use","min_digit":"Minimum 1 digit","max_length":"Max length is 50","min_length":"Minimum length 6 characters","min_alphabet":"Minimum 1 Latin alphabet","password_error":"Password must be 6 characters, 1 number","password_no_match":"Passwords dont match","go_back":"Go Back","private_beta":"Registration is currently unavailable","check_form":"Please check form fields","loading":"Please wait","future":"Future date not allowed","incorrect":"Old password is incorrect","back_to_home_page":"Go back to Homepage","agree_on_news_desc":"Notify me about my favorite films and TV-series"},"verify":{"verification_code":"Verification code","verify":"Verify","error":"Wrong code","check_email":"Code has been sent to the email. Please check promotion and spam folders as well","not_received":"Didn't get the code?","resend_code":"Resend code","code_sent_successfully":"Code has been sent successfully","try_again":"Resend was not successfull. Please wait one minute and try again"},"bookmark":{"title":"Watchlist","add":"Add to Watchlist","remove":"Remove from Watchlist","create_playlist":"Create new playlist"},"rating":{"rating":"Rating"},"card":{"movie":{"watch_in_cinema":"Watch in cinema","buy":"Buy","subscribe_and_play":"Subscribe","play":"Play","trailer":"Trailer","continue":"Continue","free":"Free","free_amedia":"Free","free_with_subscription":"Subscribe","try_for_free":"Try for free","notify":"Notify me","will_be_notified":"You will be notified"}},"currency":{"gel":"₾"},"profile":{"name":"Name","for_kid":"Kid?","new":{"title":"Add profile","description":"Share with 4 friends","name":"Name","kid":"Kid","add_profile":"Add Profile"},"edit":{"title":"Edit profile","description":"Create your profile","name":"Name","kid":"Kid","remove":"Remove profile"},"choose_title":"Who's watching?","manage":"Manage profiles","create":"Add","edit.title":"Edit profiles","back_to_profiles":"Back to profiles","signed_in_as":"Signed in as"},"errors":{"404":{"code":"404","text":"Page not found"}},"account":{"title":"Account Settings","personal_info":"Personal information","payment_info":"Payment information","payment_method":{"add":"Add payment method","expired":"Expired","delete":"Delete","default":"Set default","primary":"Primary","not_found":"Payment method not found","disabled":"Not available for this plan","expiry_date":"Exp.","unable_to_delete_title":"Unable to delete card","unable_to_delete_body":"To delete primary card, you need to cancel the subscription first."},"notifications":"Notifications","gifts_and_offers":"Gifts and special offers","gifts_and_offers_desc":"Free movies for subscribers, gifts, promotions and other pleasant bonuses for your favorite users","new_items":"New items","new_items_desc":"Only the best premieres, which we carefully select especially for you","service_news":"Service news","service_news_desc":"Briefly but proudly we talk about our functionality and technical innovations","password":"Password","change_password":"Change password","update_personal_info":"Update personal info","marketing_consent":{"title":"Get notified about your favorite films and TV-series.","agree":"Notify me","do_not_agree":"I don't want","news":"News","offer1":"Best movies and series premieres","offer2":"Gifts, promotions and other pleasant bonuses","offer3":"Platform news and technical updates"}},"personal_info":{"email":"Email","gender":"Gender","birthday":"Birthday","phone":"Phone","male":"Male","female":"female","null":""},"change_password":{"title":"Change password","old":"Old password","new":"New password","repeat_new":"Repeat new password"},"update_personal_info":{"title":"Update personal information","firstName":"Firstname","lastName":"Lastname","birthday":"Birthday","gender":"Gender","choose":"Choose","phone":"Phone","required":"Required","max_length":"The max number of characters is 50"},"movie":{"buy":"Buy","purchase":{"buy":"Buy","modal_title":"Choose purchase period and quality","rent":"Rent","hour":"H","required":"Required","price":"Price","pay":"Confirm & pay","merchant.page":"You will be redirected to a secure merchant page to proceed with the payment","existing_card":"Payment will be made automatically after clicking the “Confirm & Pay“ button.","non_refundable":"Please note, payment is non-refundable","HD":"High quality","SD":"Standard quality","no_card":"No existing cards found. You will proceed with a new card.","note":"You will  review your choice before confirming the  purchase","continue":"Continue","payment_info":"Payment information"},"expiration":{"forever":"Forever","day":"day","days":"days","hour":"hour","hours":"hours","quality":"in {{ quality }}"},"subscribe_and_play":"Subscribe & Play","play":"Play","report_problem":"Report a problem","overview":"Overview","similar":"Similar movies","cast_and_crew":"Cast & crew","share":"Share","demand_dubbing":{"button":"Demand dubbing","message":"Confirm If you want see Georgian dubbed version of this movie","success":"Your request successfully received","fail":"Something went wrong while requesting, please try again."},"creators":"Creators:","cast":"Cast:","genres":"Genres:","writer":"Screenwriter:","animator":"Animator:","season":"Season","seasons":"Seasons","episode":"Episode","season_and_episode":"S{{season}}:E{{episode}}","episode-number":"Episode {{episode}}","hbo.rights":"HBO ® and related service marks are the property of Home Box Office, Inc.","you_might_also_like":"You might also like","actors":"Actors","producers":"Producers","screen_writers":"Screen writers","compositors":"Compositors","episodes":"Episodes","details":"Details","more":"More","show_more":"show more","search_text":"So, what do you want to watch?","search.show_all":"See all of the results","search.not_found":"{{searchString}} not found","currently_playing":"Currently Playing","coming_soon":"coming soon!","coming_on":"Coming on","blocks":{"see_more":"See more"}},"filters":{"genres":"Genres","year_released":"Year released","dubbing":"Dubbing","subtitles":"Subtitles","subtitle":"Subtitles","rating":"Rating","imdb":"IMDB","country":"Country","sort_by":"Sort by","free":"Free","premium":"Premium","buy":"Buy","sorted":"Sorted","newest":"Newest","selected":"Selected","filter":"Filters","all_movies":"All Movies","georgian_movies":"Georgian","all_tv_shows":"All TV Shows","georgian_tv_shows":"Georgian","show":"Show filters","hide":"Hide filters","clear":"Clear filters","not_found":"Not found"},"user":{"profile":{"purchases":"Purchases","sort_by":"Sort By","watch_history":"Watch history","watchlist":"Watchlist","account_settings":"Account Settings","payment_history":"Payment History","logout":"Log out","no_payments":"No payments have been made from this account."},"payment_history":{"card":"Card","type":"Type","amount":"Amount","date":"Date","refund":"Refunded Amount","payment":"Payment","period":"Period","refunded":"Refunded","page":"Page","buy":"Buy","rent":"Rent"},"notifications":"Notifications","session":{"last_login":"Last Login","platform":"Platform","os":"OS","browser":"Browser","ip":"IP Address","remove":"Remove session"}},"watchlist":{"title":"Watchlist","create_watchlist":"Create a watchlist","sort_by":"Sort By","sorted":"Sorted","movies":"movies","tv_shows":"TV show","view_watchlist":"View Watchlist","create":{"title":"Create a new list","description":"Add your favorite movies, tv shows and much more","list_title":"List title","list_description":"Add description"},"details":{"title":"Watchlist","create_watchlist":"Create a watchlist","sort_by":"Sort By","movies":"movies","tv_shows":"TV show","edit":"Edit","share":"Share"},"edit":{"title":"Edit watchlist","list_title":"List title","delete":"Delete watchlist"}},"episode":{"season":"Season","episodes":"Episodes","length":"m"},"subscription":{"choose":{"premium":"PREMIUM PLAN","premium-horizon":"PREMIUM PLAN","amediateka":"AMEDIATEKA"},"subscription_retry_wait_message":"Please wait up to 15 minutes between subscription attempts. Try again later.","title":"Subscription","cavea":"Cavea","plus":"Plus","membership_cost":"Membership cost","free":"Free Plan","select":"Choose","your_plan":"Your plan","your_plan_pros":"Your plan pros","month":"a month","month_promo":"month","renew":"Your membership will renew next month on {{month}} Enjoy!","select_plan":{"free":"Free","premium":"Premium plan","premium-horizon":"Premium plan","amediateka":"AMEDIATEKA"},"no_ads":"No ads in streaming library","five_user_profiles":"Up to 5 user profiles","multi_device":"Watch on your TV, laptop, phone, or tablet","price_after_free_trial":"Price after free trial","forth_gen_product":"Function-based 4th generation product","movie_sound_and_image":"Movie quality sound and image","every_georgian_movie":"Every Georgian movie that has ever been taken.","worldwide_movie_studios":"Worldwide popular movie studio films and series.","popular_from_amediateka":"AMEDIATEKA: Popular series and movies","amediateka":"AMEDIATEKA","current_plan":"Current Plan","ad_free_plan":"Ad free plan","end_subscription":"End subscription","back_to_profile":"Back to profile","free_trial_message":"You will be charged after trial period is over","membership_description":"Text about membership idea of denouncing pleasure and praising pain was born and I will give you a complete account of the.","required":"Required","no_subscription":"Continue without subscribing","join":{"premium":"Subscribe to Premium Plan","premium-horizon":"Subscribe to Premium Plan","amediateka":"Subscribe to AMEDIATEKA"},"join_cavea":"Join Cavea","become_member":"Become a member","become_cavea_plus_member":"Become a CaveaPlus member","first_n_days_are_free":"First {{duration}} days are free","redirection_security_message":"You will be redirected to a secure merchant page to proceed with the authorization.","payment_payment_warning_text":"Payment will be processed automatically after clicking the button “Become a member“.","explain_idea_of_denouncing":"But I must explain to you how all this mistaken idea of denouncing.","plan_card":{"instant_premieres":"+Instant premieres","cinema_quality":"+Cinema quality","dubbed_movies":"+Dubbed movies","no_ads":"+No ads","five_user_profiles":"+ 5 Profiles"},"for":"for","why_leaving_title":"why are you leaving?","checkbox":{"first":"Couldn't find my favorite movies and TV series","second":"Couldn't understand anything on the website","third":"Watching movies took too much of my time","forth":"Expected more movies dubbed in Georgian","fifth":"Subscription cost is too high","other":"Other"},"write_why_leaving":"Tell us why you're leaving :(","cancel.comment.required":"Required to select at least one","loading":{"wait":"Please wait","canceled":"Subscription has been cancelled","canceled_premium":"Subscription has been successfully canceled. The premium account is valid until the end of your ongoing billing cycle"},"after_free_trial_price":"/month after trial","free_trial_title1":"Get first","free_trial_title2":"days","free_trial_title3":"for","visa_digital_title1":"Membership cost","visa_digital_title2":"Get <span>{{duration}} Days*</span> for","after_visa_digital_price":" / month after ","visa_double_description":"*In case you pay with VISA card, your trial period will double. This plan applies only to VISA card owners","will_be_canceled":"Your paid subscription will expire on {{date}}. After that,  it will revert to free subscription. no additional charge will be applied","promo_code_expires":"There are {{day}} days left in the free period. Then your paid subscription will be activated automatically","paid_promo_code_expires":"There are {{day}} days left until promo period expires. Then your paid subscription will be activated automatically","must_have_premium_message":"To subscribe to a premium plan, visit our platform's website or use our mobile app","active.card":{"join_premium":"Join Premium","sub_details":"Subscription Details","your_package":"Your package includes:","forever":"Forever","premium_plan":"Premium Plan","free_trial":"Start a Trial"},"visa":{"note":"* After 30-day promotional period paid premium subscription will be automatically activated","double_free_trial":"FIRST 30 DAYS FOR FREE","activate":"Activate","deactivate":"Deactivate","tbc":"TBC","plan_for":"CARD USERS","terms_title":"Campaign Terms","get_card":"GET TBC VISA CARD","term1":"Use your TBC VISA card or get a new one to participate in Cavea.Plus campaign","term2":"Activate TBC VISA CARD campaign on Cavea.Plus payment page","term3":"After activating the campaign pay with TBC VISA CARD, get a one-time premium subscription with a 1-month/30-day free period","term4":"After the 1-month/30-day promotional period paid premium subscription will be automatically activated","term5":"Each subscriber can enjoy the 1-month/30-day promotional period only once, and it is valid only for the first 1 month/30 days after activation"},"feature":{"line0":{"premium":"Worldwide popular movie studio films and series.","premium-horizon":"Worldwide popular movie studio films and series.","amediateka":"AMEDIATEKA: Popular series and movies"},"line1":{"premium":"No ads in streaming library","premium-horizon":"No ads in streaming library","amediateka":"No ads in streaming library"},"line2":{"premium":"Up to 5 user profiles","premium-horizon":"Up to 5 user profiles","amediateka":"Up to 5 user profiles"},"line3":{"premium":"Watch on your TV, laptop, phone, or tablet","premium-horizon":"Watch on your TV, laptop, phone, or tablet","amediateka":"Watch on your TV, laptop, phone, or tablet"},"line4":{"premium":"Every Georgian movie that has ever been taken.","premium-horizon":"Every Georgian movie that has ever been taken.","amediateka":"Every Georgian movie that has ever been taken."}},"promo_code":{"code":"Promo Code","activate":"Apply","label":"Enter Code","not_available":"Not available","campaign_note":"* Cannot be used with TBC campaign.","note":"* After  promotional period regular paid  subscription will be automatically activated","code_applied":"Promo code applied: ","remove":"Remove","error":{"invalid":"Promo code is wrong ","not_usable":"Promo code is not valid","inactive":"Promo code is not active","too_many_attempts":"Too many attempts. Try in an hour","cant_use":"You can't use this promo code"},"card":{"title":"Membership cost","duration":"Get <span>{{duration}} Days*</span> for","after_price":"/ month after {{duration}} days"}}},"main":{"popular":"Popular","trendy":"Trendy","premiering":"Premiering","tv_shows":"TV Shows","freaky_fridays":"Freaky Fridays","genres":"Genres","boring_mondays":"Boring Monday's Watchlist"},"subscription_modal":{"select_plan":"Select plan","upgrade_plan":"Upgrade plan","ad_free":"no ads","profile_limit":"profile limit","device_limit":"device limit"},"auth":{"forget_password":"Forget password ?","error":"An unexpected error occurred, please try again"},"payment":{"result":{"success":{"movie":"You successfully bought the movie","subscription":"You're part of the gang!","bought_movie":"You successfully bought the movie!","text":"The payment has been processed successfully.","start_exploring":"Start exploring","hours":"Hours","available_until":"Available until","date":"{{ date }}"},"fail":"The problem has been occurred while processing your payment","homepage":"Homepage","save_payment_info":"Save payment info"}},"modal":{"cancel":"Cancel","save":"Save","continue":"Continue","close":"Close","yes":"Yes","confirm":"confirm","exit":"Exit"},"pages":{"suffix":"| CaveaPlus - კავეა პლუსი","home":{"title":"CaveaPlus - კავეა პლუსი","description":""},"movie":{"title":"Movies","description":"","not_found":"Not found"},"series":{"title":"Series","description":"","not_found":"Not found"},"profile":{"select":{"title":"Who's watching?"},"manage":{"title":"Manage"}},"user":{"account":{"title":"Account Settings"},"watchlist":{"title":"Collection","not_found":"Saved movies in Watchlist will appear here"},"history":{"title":"History","not_found":"Watched movies will appear here","remove":"Remove from history","detail":"Episodes details"},"purchases":{"title":"Purchases"}}},"button":{"continue":"Continue","cancel":"Cancel"},"report.problem":{"text":{"placeholder":"Problem","required":"Pleas fill textarea"},"close":"Close","send":"Send","modal":{"title":"Report Problem"},"success":"Successfully send","failed":"Something went wrong"},"player":{"loading":"Loading...","ad":{"countdown":"Ad in {{second}} second","skip":"Skip ad in {{second}} second"},"end.watching":"End Watching","skip.intro":"Skip Intro","watch":{"credits":"Watch Credits","again":"Watch Again","intro":"Watch Intro"},"mapper_not_found":"Mapper not found","source_not_found":"Source not found","episode_not_found":"Episode not found","playback_failed":"Playback failed, please try again","dub_language":"Dubbing Language","captions":"Captions","languages":{"off":"Off","en":"English","ru":"Russian","ka":"Georgian","ge":"Georgian","fr":"French","es":"Spanish","it":"Italian","no":"Norwegian","in":"Indian","ja":"Japanese","ua":"Ukrainian","da":"Danish","georgian":"Georgian","english":"English","ukrainian":"Ukrainian","russian":"Russian","french":"French","русские":"Russian","ara":"Arabic","swd":"Swedish","ser":"Serbian","tr":"Turkish","irn":"Iranian","heb":"Hebrew","he":"Hebrew","pl":"Polish","pt":"Portuguese","ned":"Dutch","nl":"Dutch","is":"Icelandic","hy":"Armenian","az":"Azerbaijani","ko":"Korean","el":"Greek","chn":"Chinese","zh":"Chinese","cs":"Czech","uk":"Ukrainian","de":"German"},"quality":"Quality","ad_blocker":"To play the video disable AdBlocker","try_again":"Try again","not_allowed":"Cavea+ is currently unavailable in your country of residence","watch_session_token_not_found":"Session initialization token not found","watch_session_token_expired":"Session initialization token expired","user_not_subscribed":"User does not have a subscription","something_went_wrong":"Something went wrong","coming_soon":"Episode coming soon!","movie_not_available_in_region":"This movie is not available in your region","TV_serie_not_available_in_region":"This TV show is not available in your region."},"footer":{"copyright":"2024 cavea.plus","rights":"All rights reserved","terms_of_use":"Terms of Use","support":"Support"},"terms_of_use":{"title":"Cavea+ Terms of Use"},"search":{"search":"Search","placeholder":"So, what do you want to watch?","not_found":"{{searchString}} not found","clear":"Clear","movie":"Movie","tv-shows":"TV shows"},"dub_languages":{"ENG":"English","GEO":"Georgian","UA":"Ukrainian","RUS":"Russian","FRA":"French","NLD":"Dutch","DEU":"German","DAN":"Danish","CZE":"Czech","PER":"Persian","IND":"Indian","CHN":"Chinese","ISL":"Icelandic","ARA":"Arabic","SWD":"Swedish","SER":"Serbian","IRN":"Iranian","HEB":"Hebrew","TR":"Turkish","PL":"Polish","PT":"Portuguese","ARM":"Armenian","AZ":"Azerbaijani","KO":"Korean","EL":"Greek","ZH":"Chinese"},"support":{"modal":{"title":"Contact us:","email":"Via Email:","phone":"Via Phone:"}},"auth_tv":{"title":"Signed in as","code":"Enter the code displayed on your TV","success":"Now you can close the window.","required":"Field is required","wrong_code":"Wrong code","silk-btn":"As Silknet","cavea-btn":"As CaveaPlus","loading":"Loading, Please wait","language-btn":"ქართული მენიუ"},"welcome":{"title":"The First Georgian Streaming Platform","log_in":"Log in"},"coming_soon_modal":{"movie":"Movie coming soon","series":"TV Show coming soon","episode":"Episode coming soon"},"buy_movie_modal":{"title":"Buy movie on Cavea.plus website, sign in to Silknet with Cavea.plus account, and enjoy watching!"},"months":{"January":"January","February":"February","March":"March","April":"April","May":"May","June":"June","July":"July","August":"August","September":"September","October":"October","November":"November","December":"December"},"popup":{"mobile_app":"MOBILE APP","download":"Download","availability":"Available on android and iOS"},"exit":{"text":"Are you sure you want to exit?"},"idle":{"text":"Are you still watching?","no":"No"},"logout":{"text":"Do you want to Log out? To log in again re-open CaveaPlus"},"session_ended":{"text":"An error occurred, please log in again."}}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = {"header":{"login":"შესვლა","register":"რეგისტრაცია","welcome":"კეთილი იყოს შენი თვალი!","profile":"პროფილი","account":"ანგარიში","manage_profile":"პროფილის მართვა","change_profile":"პროფილის შეცვლა","logout":"გამოსვლა","start_trial":"სცადე უფასოდ","share":"გაზიარება","seasons":"სეზონები","empty_notification":"არ არის შეტყობინება","contact_us":"დაგვიკავშირდით","public_beta":"საცდელი მაუწყებლობა","season_ready_to_watch":"ახალი სეზონი მზადაა საყურებლად","recently_added":"ახლახან დაემატა","home":"მთავარი","movies":"ფილმები","tv_shows":"სერიალები"},"layout":{"choose_profile":"აირჩიეთ პროფილი","profiles":"პროფილები","for_kids":"საბავშვო: ","back_home":"მთავარზე დაბრუნება","back_movie":"დეტალურ გვერდზე დაბრუნება","movies":"ფილმები","genres":"ჟანრები","cancel_subscription":"გამოწერის გაუქმება","continue_watching":"გააგრძელე ყურება","prev":"წინა","next":"შემდეგი","go_back_to_homepage":"მთავარი","start_watching":"დაიწყე ყურება","coming_soon":"მალე...","languages":{"ka":"GEO","en":"ENG"},"using_local":"უცხოეთიდან სანახავად გადადი GLOBAL.CAVEA.PLUS -ზე","using_global":"საქართველოში სანახავად გადადი CAVEA.PLUS -ზე.","teleport":"გადასვლა","show_more":"მეტის ნახვა","scroll_to_top":"ზემოთ ასვლა","public_beta":"საცდელი მაუწყებლობა"},"login":{"title":"განაგრძე ყურება","login_using":"Log in using","back":"უკან დაბრუნება","cancel":"გაუქმება","email":"ელ-ფოსტა","password":"პაროლი","help":"დაგავიწყდა პაროლი?","login":"ავტორიზაცია","incorrect":"პაროლი, ან ელ-ფოსტა არასწორია","too_many_attempts":"ძალიან ბევრი ცდა, გთხოვთ გაიმეოროთ 10 წუთში","reset_password":"განაახლე პაროლი","still_no_account":"არ გაქვს ანგარიში? გაიარე","register":"რეგისტრაცია","go_back_to_homepage":"მთავარ გვერდზე დაბრუნება","loading":"გთხოვთ დაელოდოთ"},"password_reset":{"title":"პაროლის აღდგენა","email":"ელ-ფოსტა","email_sent":"შეამოწმეთ თქვენი ელ-ფოსტა.","go_back_to_homepage":"მთავარ გვერდზე დაბრუნება","next":"გაგზავნა"},"password_update":{"title":"ახალი პაროლის დაყენება","updated":"ახალი პაროლი შენახულია","return_page":"ავტორიზაცია","password":"პაროლი","repeat_password":"გაიმეორე პაროლი","save":"შენახვა","invalid":"გთხოვთ შეავსოთ ველები სწორად","match":"ახალი პაროლი უნდა განსხვავდებოდეს მიმდინარე პაროლისგან","log_out_from_all_devices":"ყველა მოწყობილობიდან გამოსვლა"},"register":{"title":"შემოუერთდი კინოსამყაროს","first_name":"* სახელი","last_name":"* გვარი","gender":"* სქესი","female":"მდედრობითი","male":"მამრობითი","gender_choose":"აირჩიე","birthday":"* დაბადების თარიღი","dd_mm_yyyy":"დღე-თვე-წელი","day":"დღე","month":"თვე","year":"წელი","email":"* ელ-ფოსტა","phone":"* მობ. ნომერი","password":"* პაროლი","re_password":"* გაიმეორეთ პაროლი","i_agree_with":"ვეთანხმები Cavea+ის ","terms_and_conditions":"პირობებსა და კონფიდენციალურობის პოლიტიკას","cavea_plus":"","sign_up":"რეგისტრაცია","log_in":"ავტორიზაცია","already_have_account":"უკვე გაქვს ანგარიში?","required":"შევსება სავალდებულოა","wrong_date":"გადაამოწმე თარიღი","wrong_email":"უი! აბა, ელ-ფოსტა გადაამოწმე","phone_pattern":"უი! აბა, მობილურის ნომერი გადაამოწმე","exists":"ელფოსტა უკვე გამოყენებულია","phone_exists":"მობილურის ნომერი უკვე გამოყენებულია","min_digit":"მინიმუმ 1 ციფრი","max_length":"სიმბოლოების მაქსიმალური რაოდენობაა 50","min_length":"სიმბოლოების მინიმალური რაოდენობაა 6","min_alphabet":"მინიმუმ 1 ლათინური ასო","password_error":"პაროლი უნდა შეიცავდეს 6 ასოს და 1 ციფრს","password_no_match":"პაროლები ერთმანეთს არ ემთხვევა","go_back":"უკან დაბრუნება","private_beta":"რეგისტრაცია დროებით შეუძლებელია","check_form":"გთხოვთ გადაამოწმოთ ველები","loading":"გთხოვთ დაელოდოთ","future":"თარიღი არ შეიძლება იყოს მომავალში","incorrect":"ძველი პაროლი არასწორია","back_to_home_page":"მთავარ გვერდზე დაბრუნება","agree_on_news_desc":"მსურს გამოვიწერო სიახლეები, რომ არ გამომრჩეს  საყვარელი ფილმები და სერიალები"},"verify":{"verification_code":"ვერიფიკაციის კოდი","verify":"ვერიფიკაცია","error":"ჰიუსტონ! პრობლემა გვაქვს! კოდი არასწორია","check_email":"კოდი გამოიგზავნა თქვენს ელ-ფოსტაზე. გთხოვთ შეამოწმოთ promotion და spam საქაღალდეებიც","not_received":"არ მიგიღიათ კოდი?","resend_code":"კოდის ხელახლა გაგზავნა","code_sent_successfully":"კოდი წარმატებით გაიგზავნა","try_again":"კოდის ხელახლა გაგზავნა წარუმატებლად დასრულდა, გთხოვთ ერთი წუთი დაელოდოთ და თავიდან სცადოთ"},"bookmark":{"title":"კოლექცია","add":"კოლექციაში დამატება","remove":"კოლექციიდან ამოღება","create_playlist":"ახალი სია"},"rating":{"rating":"რეიტ."},"card":{"movie":{"watch_in_cinema":"ნახე კინოში","buy":"ყიდვა","subscribe_and_play":"გამოიწერე","play":"Play","trailer":"თრეილერი","continue":"continue","free":"უფასო","free_amedia":"უფასო","free_with_subscription":"გამოიწერე","try_for_free":"სცადე უფასოდ","notify":"შემატყობინეთ","will_be_notified":"შეგატყობინებთ"}},"currency":{"gel":"₾"},"profile":{"name":"სახელი","for_kid":"საბავშვო","new":{"title":"პროფილის დამატება","description":"გაუზიარე 4 ახლო ადამიანს","name":"სახელი","kid":"ბავშვი","add_profile":"დაამატე პროფილი"},"edit":{"title":"პროფილის კორექტირება","description":"შექმენი შენი პროფილი","name":"სახელი","kid":"საბავშვო","remove":"პროფილის წაშლა"},"choose_title":"რომელი ხარ?","manage":"პროფილების მართვა","create":"დამატება","edit.title":"პროფილის კორექტირება","back_to_profiles":"უკან დაბრუნება","signed_in_as":"შესული ხართ, როგორც"},"errors":{"404":{"code":"404","text":"გვერდი ვერ მოიძებნა"}},"account":{"title":"ანგარიშის პარამეტრები","personal_info":"პერსონალური მონაცემები","payment_info":"გამოწერის დეტალები","payment_method":{"add":"გადახდის მეთოდის დამატება","expired":"ვადაგასული","delete":"წაშლა","default":"გახადე მთავარი","primary":"მთავარი","not_found":"გადახდის მეთოდი ვერ მოიძებნა","disabled":"მიუწვდომელია ამ გეგმისთვის","expiry_date":"Exp.","unable_to_delete_title":"ბარათი არ წაიშალა","unable_to_delete_body":"მთავარი ბარათის წასაშლელად საჭიროა ჯერ გამოწერის გაუქმება."},"notifications":"შეტყობინებები","gifts_and_offers":"საჩუქრები და შემოთავაზებები","gifts_and_offers_desc":"უფასო ფილმები გამომწერებისთვის, საჩუქრები, შეთავაზებები და სხვა მხიარული ბონუსები.","new_items":"ახალი ფილმები და სერიალები","new_items_desc":"საუკეთესო ფილმების პრემიერები, მხოლოდ შენ ერთს!","service_news":"ტექნიკური სიახლეები","service_news_desc":"გაგაცნობთ ტექნიკურ სიახლეებს","password":"პაროლი","change_password":"პაროლის შეცვლა","update_personal_info":"მონაცემების შეცვლა","marketing_consent":{"title":"გამოიწერე სიახლეები, რომ არ გამოგრჩეს შენი საყვარელი ფილმები და სერიალები.","agree":"გამოწერა","do_not_agree":"Არ მსურს","news":"სიახლეები","offer1":"საუკეთესო ფილმების და სერიალების პრემიერები","offer2":"საჩუქრები და მხიარული ბონუსები","offer3":"ტექნიკური სიახლეები"}},"personal_info":{"email":"ელ.ფოსტა","gender":"სქესი","birthday":"დაბ. თარ.","phone":"მობილური","male":"მამრობითი","female":"მდედრობითი","null":""},"change_password":{"title":"პაროლის შეცვლა","old":"ძველი პაროლი","new":"ახალი პაროლი","repeat_new":"გაიმეორე ახალი პაროლი"},"update_personal_info":{"title":"განაახლე პერსონალური მონაცემები","firstName":"სახელი","lastName":"გვარი","birthday":"დაბადების თარიღი","gender":"სქესი","choose":"აირჩიე","phone":"მობილური","required":"შევსება სავალდებულოა","max_length":"სიმბოლოების მაქსიმალური რაოდენობაა 50"},"movie":{"buy":"იყიდე","purchase":{"buy":"ყიდვა","modal_title":"შეარჩიე ყიდვის პერიოდი და ხარისხი","rent":"ქირაობა","hour":"სთ","required":"სავალდებულო","price":"ფასი","pay":"გადახდა","merchant.page":"თქვენ გადამისამართდებით უსაფრთხო გვერდზე, გადახდის ოპერაციის შესასრულებლად","existing_card":"გადახდა განხორციელდება ავტომატურად “გადახდა“ ღილაკის დაჭერის შემდეგ","non_refundable":"გაითვალისწინე, გადახდილი თანხის უკან დაბრუნება არ ხდება.","no_existing_card":"არსებული ბარათები ვერ მოიძებნა. შენ გააგრძელებ ახალი ბარათით.","HD":"მაღალი ხარისხი","SD":"სტანდ. ხარისხი","no_card":"არსებული ბარათები ვერ მოიძებნა. შენ გააგრძელებ ახალი ბარათით.","note":"ყიდვის დადასტურებამდე შეძლებ არჩევანის გადახედვას","continue":"გაგრძელება","payment_info":"გადახდის ინფორმაცია"},"expiration":{"forever":"სამუდამოდ","day":"დღე","days":"დღე","hour":"საათი","hours":"საათი","quality":"{{ quality }}"},"subscribe_and_play":"Subscribe & Play","play":"Play","report_problem":"ჰიუსტონ! პრობლემა მაქვს!","overview":"მიმოხილვა","similar":"დამიჯერე, მოგეწონება","cast_and_crew":"მსახიობები & გუნდი","share":"გააზიარე","demand_dubbing":{"button":"გამიხმოვანეთ","message":"გთხოვთ დაადასტუროთ, რომ გსურთ ამ ფილმის ქართულად გახმოვანება.","success":"მოთხოვნა მიღებულია","fail":"მოთხოვნისას ხარვეზია, გთხოვთ ცადოთ ხელახლა"},"creators":"რეჟისორი:","cast":"მსახიობები:","genres":"ჟანრები:","writer":"სცენარისტი:","animator":"ანიმატორი:","season":"სეზონი","seasons":"სეზონები","episode":"ეპიზოდი","season_and_episode":"S{{season}}:E{{episode}}","episode-number":"ეპიზოდი {{episode}}","hbo.rights":"HBO ® და მასთან დაკავშირებული სერვისი წარმოადგენს Home Box Office, Inc-ის საკუთრებას","you_might_also_like":"დამიჯერე, მოგეწონება","actors":"მსახიობები","producers":"პროდიუსერი","screen_writers":"სცენარის ავტორი","compositors":"კომპოზიტორი","episodes":"ეპიზოდი","details":"დაწვრილებით","more":"მეტი","show_more":"მეტის ნახვა","search_text":"აბა, რას ვეძებთ?","search.show_all":"ძიების შედეგები","search.not_found":"{{searchString}} არ მოიძებნა","currently_playing":"მიმდინარე","coming_soon":"მალე!","coming_on":"პრემიერა","blocks":{"see_more":"მეტის ნახვა"}},"filters":{"genres":"ჟანრი","year_released":"წელი","dubbing":"ენა","subtitles":"სუბტიტრები","subtitle":"სუბტიტრი","rating":"რეიტინგი","imdb":"IMDB","country":"ქვეყანა","sort_by":"დაახარისხე","free":"უფასო","premium":"პრემიუმი","buy":"ყიდვა","sorted":"დალაგება","newest":"უახლესი","selected":"არჩეულია","filter":"ფილტრები","all_movies":"ყველა ფილმი","georgian_movies":"ქართული","all_tv_shows":"ყველა სერიალი","georgian_tv_shows":"ქართული","show":"ფილტრების გამოჩენა","hide":"ფილტრების დამალვა","clear":"ფილტრების გასუფთავება","not_found":"არ მოიძებნა"},"user":{"profile":{"purchases":"შენაძენები","sort_by":"დახარისხება","watch_history":"ყურების ისტორია","watchlist":"სანახავია","account_settings":"ანგარიშის პარამეტრები","payment_history":"გადახდის ისტორია","logout":"გამოსვლა","no_payments":"ამ ანგარიშიდან გადახდები არ განხორციელებულა."},"payment_history":{"card":"ბარათი","type":"ტიპი","amount":"თანხა","date":"თარიღი","refund":"დაბრუნებული თანხა","payment":"გადახდა","period":"პერიოდი","refunded":"დაბრუნებული თანხა","page":"გვერდი","buy":"ყიდვა","rent":"ქირაობა"},"session":{"last_login":"ბოლო შესვლა","platform":"პლათფორმა","os":"ოპერაციული სისტემა","browser":"ბრაუზერი","ip":"IP მისამართი","remove":"სესიის წაშლა"}},"watchlist":{"title":"ვაპირებ ყურებას","create_watchlist":"სიის შექმნა","sort_by":"დახარისხება","sorted":"Sorted","movies":"ფილმები","tv_shows":"სერიალები","view_watchlist":"სიის ნახვა","create":{"title":"ახალი სიის შექმნა","description":"დაიმახსოვრე შენი საყვარელი ფილმები, სერიალები და მრავალი სხვა","list_title":"სიის სახელი","list_description":"დაამატე აღწერა"},"details":{"title":"ვაპირებ ყურებას","create_watchlist":"სიის შექმნა","sort_by":"დახარისხება","movies":"ფილმები","tv_shows":"სერიალი","edit":"კორექტირება","share":"გაზიარება"},"edit":{"title":"Edit watchlist","list_title":"სიის სახელი","delete":"სიის წაშლა"}},"episode":{"season":"სეზონი","episodes":"ეპიზოდი","length":"წთ"},"subscription":{"choose":{"premium":"პრემიუმი","premium-horizon":"პრემიუმი","amediateka":"AMEDIATEKA"},"subscription_retry_wait_message":"გთხოვთ, გამოწერის მცდელობებს შორის დაიცადოთ 15 წუთამდე. სცადეთ მოგვიანებით.","title":"გამოწერა","cavea":"Cavea","plus":"Plus","membership_cost":"გამოწერის საფასური","free":"უფასო","your_plan":"ჩემი გეგმა","your_plan_pros":"Your plan pros","month":"თვეში","month_promo":"თვეში","renew":"თქვენი წევრობა განახლდება {{month}} ისიამოვნეთ!","select":"შეარჩიე","select_plan":{"free":"უფასო","amediateka":"AMEDIATEKA","premium":"პრემიუმი","premium-horizon":"პრემიუმი"},"no_ads":"უყურე რეკლამების გარეშე","five_user_profiles":"5 პროფილი 5 ადამიანისთვის","multi_device":"უყურე ლეპტოპზე, ტელეფონზე ან ტაბლეტზე","price_after_free_trial":"ღირებულება უფასო საცდელი პერიოდის შემდეგ","forth_gen_product":"ფუნქციებზე დაფუძნებული მე-4 თაობის პროდუქტი","movie_sound_and_image":"კინოს ხარისხის ხმა და გამოსახულება","every_georgian_movie":"ყველა ქართული ფილმი, რაც ოდესმე გადაგვიღია","worldwide_movie_studios":"მსოფლიოს საუკეთესო სტუდიების ფილმები და სერიალები ქართულად","popular_from_amediateka":"AMEDIATEKA: პოპულარული ფილმები და სერიალები","amediateka":"AMEDIATEKA","current_plan":"რეკლამებს ავიტან","ad_free_plan":"უყურე რეკლამების გარეშე","end_subscription":"გამოწერის გაუქმება","back_to_profile":"პროფილზე დაბრუნება","membership_description":"Text about membership idea of denouncing pleasure and praising pain was born and I will give you a complete account of the.","no_subscription":"განაგრძე გამოწერის გარეშე","join":{"amediateka":"გამოიწერე AMEDIATEKA","premium":"გამოიწერე პრემიუმი","premium-horizon":"გამოიწერე პრემიუმი"},"join_cavea":"შეუერთდი Cavea+","become_member":"გამოიწერე","become_cavea_plus_member":"გამოიწერე პრემიუმი","first_n_days_are_free":"პირველი {{duration}} დღე უფასოა","redirection_security_message":"თქვენ გადამისამართდებით უსაფრთხო გვერდზე, ავტორიზაციის გასაგრძელებლად.","payment_payment_warning_text":"გადახდა განხორციელდება ავტომატურად “გამოიწერე“ ღილაკის დაჭერის შემდეგ.","free_trial_message":"ჯერ არაფრის გადახდა არ მოგიწევს! პირველი {{duration}} დღე უფასოა","explain_idea_of_denouncing":"მაგრამ უნდა აგიხსნათ, თუ როგორ ხდება ამ მცდარი აზრის დაგმობა.","required":"სავალდებულოა","plan_card":{"instant_premieres":"+პრემიერები","cinema_quality":"+კინოს ხარისხი","dubbed_movies":"+გახმოვანება","no_ads":"+რეკლამის გარეშე","five_user_profiles":"+ერთი გამოწერა 5 მაყურებლისთვის"},"for":"for","why_leaving_title":"თუ კაი საქმეზე მიდიხარ, ჩვენც წაგვიყვანე","checkbox":{"first":"არ დამხვდა ჩემი საყვარელი ფილმები და სერიალები","second":"ვებსაიტს ვერაფერი ვერ გავუგე","third":"ფილმების ყურებას გადავყევი","forth":"მეტ ქართულად გახმოვანებულ ფილმს ველოდი","fifth":"გაძვირდა ცხოვრება","other":"სხვა"},"write_why_leaving":"გვირჩიე რა გამოვასწოროთ","cancel.comment.required":"სავალდებულოა არჩიოთ ერთი მაინც","loading":{"wait":"გთხოვთ დაელოდოთ","canceled":"გამოწერა გაუქმებულია","canceled_premium":"გამოწერა წარმატებით გაუქმდა. პრემიუმ ანგარიში ძალაშია გადახდილი ვადის ბოლომდე"},"after_free_trial_price":"/თვე {{duration}} დღის შემდეგ","free_trial_title1":"მიიღე პირველი","free_trial_title2":"დღე","free_trial_title3":"","visa_digital_title1":"გამოწერის საფასური","visa_digital_title2":"<span>{{duration}} დღე*</span>","after_visa_digital_price":"/თვე {{duration}} დღის შემდეგ ","visa_double_description":"*In case you pay with VISA card, your trial period will double. This plan applies only to VISA card owners","active.card":{"join_premium":"გამოიწერე პრემიუმი","sub_details":"გამოწერის დეტალები","your_package":"შენს პაკეტში შედის:","forever":"ყოველთვის","premium_plan":"პრემიუმ გეგმა","free_trial":"სცადე უფასოდ"},"visa":{"note":"* 30 დღიანი უფასო პერიოდის გასვლის შემდეგ ავტომატურად გაგიაქტიურდება ფასიანი გამოწერა","double_free_trial":"პირველი 30 დღე უფასოდ","double_free_trial2":"პირველი 30 დღე უფასოდ","activate":"გააქტიურება","deactivate":"გამორთვა","tbc":"TBC","plan_for":"ბარათით","terms_title":"აქციის პირობები","get_card":"TBC VISA ბარათის აღება","term1":"ისარგებლე შენი TBC VISA ბარათით ან აიღე ახალი TBC VISA ბარათი და მიიღე მონაწილეობა Cavea.Plus-ის კამპანიაში","term2":"გაიაქტიურე TBC VISA ბარათის კამპანია Cavea.Plus-ის გადახდის გვერდზე","term3":"კამპანიის გააქტიურებისას და TBC VISA ბარათით გადახდის შემთხვევაში მიიღე პრემიუმ გამოწერა უფასოდ 30 დღიანი (1 თვიანი) პერიოდით","term4":"30 დღიანი/1 თვიანი უფასო პერიოდის გასვლის შემდეგ შენ ავტომატურად გაგიაქტიურდება ფასიანი გამოწერა","term5":"თითო გამომწერს შეუძლია ისარგებლოს 30 დღიანი/1 თვიანი  უფასო პერიოდით მხოლოდ ერთხელ და ის მოქმედებს გააქტიურებიდან მხოლოდ პირველი 30 დღე/1 თვე"},"feature":{"line0":{"premium":"მსოფლიოს საუკეთესო სტუდიების ფილმები და სერიალები ქართულად","premium-horizon":"მსოფლიოს საუკეთესო სტუდიების ფილმები და სერიალები ქართულად","amediateka":"AMEDIATEKA: პოპულარული ფილმები და სერიალები"},"line1":{"premium":"უყურე რეკლამების გარეშე","premium-horizon":"უყურე რეკლამების გარეშე","amediateka":"უყურე რეკლამების გარეშე"},"line2":{"premium":"5 პროფილი 5 ადამიანისთვის","premium-horizon":"5 პროფილი 5 ადამიანისთვის","amediateka":"5 პროფილი 5 ადამიანისთვის"},"line3":{"premium":"უყურე სხვადასხვა მოწყობილობაზე","premium-horizon":"უყურე სხვადასხვა მოწყობილობაზე","amediateka":"უუყურე სხვადასხვა მოწყობილობაზე"},"line4":{"premium":"ყველა ქართული ფილმი","premium-horizon":"ყველა ქართული ფილმი","amediateka":"ყველა ქართული ფილმი"}},"promo_code":{"code":"პრომო კოდი","activate":"მინიჭება","label":"შეიყვანეთ კოდი","not_available":"არ არის ხელმისაწვდომი","campaign_note":"* TBC კამპანიასთან ერთად გამოყენება შეუძლებელია.","note":"* პრომო პერიოდის გასვლის შემდეგ, შენ ავტომატურად გაგიაქტიურდება სტანდარტული ფასიანი პრემიუმ  გამოწერა","code_applied":"პრომო კოდი მინიჭებულია: ","remove":"გაუქმება","error":{"invalid":"პრომო კოდი არასწორია","not_usable":"პრომო კოდი არ არის მოქმედი","inactive":"პრომო კოდი არ არის აქტიური","too_many_attempts":"ძალიან ბევრი ცდა, გთხოვთ გაიმეოროთ 1 საათში","cant_use":"თქვენ არ შეგიძლიათ ამ პრომო კოდის გამოყენება"},"card":{"title":"გამოწერის საფასური","duration":"<span>{{duration}} დღე*</span>","after_price":"/თვე {{duration}} დღის შემდეგ"}},"will_be_canceled":"თქვენი გამოწერა დასრულდება {{date}}. რის შემდეგაც დაუბრუნდებით უფასო გამოწერას.","promo_code_expires":"უფასო პერიოდის დასრულებამდე დარჩა {{day}} დღე. შემდეგ ავტომატურად გაგიაქტიურდება ფასიანი გამოწერა.","paid_promo_code_expires":"პრომო პერიოდის დასრულებამდე დარჩა {{day}} დღე. შემდეგ ავტომატურად გაგიაქტიურდება ფასიანი გამოწერა.","must_have_premium_message":"პრემიუმ გეგმის გამოწერისთვის გადადით ჩვენი პლატფორმის ვებსაიტზე ან მობილურ აპლიკაციაში"},"main":{"popular":"პოპულარული","trendy":"ტრენდული","premiering":"პრემიერა","tv_shows":"სერიალები","freaky_fridays":"Freaky Fridays","genres":"ჟანრები","boring_mondays":"მოსაწყენი ორშაბათის კოლექცია"},"subscription_modal":{"select_plan":"აირჩიეთ პაკეტი","upgrade_plan":"პაკეტის შეცვლა","ad_free":"რეკლამების გარეშე","profile_limit":"პროფილების ლიმიტი","device_limit":"მოწყობილობების ლიმიტი"},"auth":{"error":"დაფიქსირდა შეცდომა, გთხოვთ სცადოთ ხელახლა","forget_password":"დაგავიწყდა პაროლი?","cavea":{"error":"დაფიქსირდა შეცდომა, გთხოვთ ცადოთ მოგვიანებით","verification":"გთხოვთ შეამოწმოთ ელ-ფოსტა","loading":"გთხოვთ დაელოდოთ..."}},"payment":{"result":{"success":{"movie":"თქვენ წარმატებით შეიძინეთ ფილმი","subscription":"კინოთეატრი შენს განკარგულებაშია!","bought_movie":"თქვენ წარმატებით შეიძინეთ ფილმი","text":"ოპერაცია წარმატებით განხორციელდა","start_exploring":"გაგრძელება","hours":"საათი","available_until":"გამოყენების ვადა","date":"{{ date }} -მდე"},"fail":"გადახდის პროცესში დაფიქსირდა ხარვეზი","homepage":"მთავარზე დაბრუნება","save_payment_info":"შეინახე გადახდის ხერხი"}},"modal":{"cancel":"უარყოფა","save":"შენახვა","continue":"გაგრძელება","close":"დახურვა","yes":"დიახ","confirm":"დადასტურება","exit":"გასვლა"},"pages":{"suffix":"| CaveaPlus - კავეა პლუსი","home":{"title":"CaveaPlus - კავეა პლუსი","description":""},"movie":{"title":"ფილმები","description":"","not_found":"არ მოიძებნა"},"series":{"title":"სერიალები","description":"","not_found":"არ მოიძებნა"},"profile":{"select":{"title":"ვინ უყურებს"},"manage":{"title":"რედაქტირება"}},"user":{"account":{"title":"ანგარიშის პარამეტრები"},"watchlist":{"title":"კოლექცია","not_found":"შენახული ფილმები გამოჩნდება აქ"},"history":{"title":"ყურების ისტორია","not_found":"აქ გამოჩნდება ნანახი ფილმები","remove":"ისტორიიდან წაშლა","detail":"დეტალები"},"purchases":{"title":"ყიდვის ისტორია"}}},"button":{"continue":"გაგრძელება","cancel":"უარყოფა"},"report.problem":{"text":{"placeholder":"თქვენი კომენტარი","required":"გთხოვთ შეავსოთ კომენტარის ველი"},"close":"დახურვა","send":"გაგზავნა","modal":{"title":"პრობლემის დარეპორტება"},"success":"წარმატებით გაიგზავნა","failed":"დაფიქსირდა შეცდომა"},"player":{"loading":"იტვირთება...","mapper_not_found":"ფილმი არ მოიძებნა","source_not_found":"რესურსი არ მოიძებნა","episode_not_found":"ეპიზოდი არ მოიძებნა","playback_failed":"დაკვრა ვერ მოხერხდა, გთხოვთ სცადოთ თავიდან","watch_session_token_not_found":"ინიციალიზაციის ტოკენი არ მოიძებნა","watch_session_token_expired":"ინიციალიზაციის ტოკენის გამოყენების ვადა ამოიწურა","user_not_subscribed":"მომხმარებელს არ აქვს შესაბამისი გამოწერის პაკეტი","something_went_wrong":"დაფიქსირდა შეცდომა","movie_not_available_in_region":"ეს ფილმი მიუწვდომელია შენს რეგიონში","TV_serie_not_available_in_region":"ეს ფილმი/სერიალი მიუწვდომელია შენს რეგიონში","ad":{"countdown":"რეკლამა დაიწყება {{second}} წამში","skip":"რეკლამის გამოტოვება {{second}} წამში"},"end.watching":"დასრულება","skip.intro":"შესავლის გამოტოვება","watch":{"credits":"ტიტრები","again":"თავიდან ყურება","intro":"შესავლის ყურება"},"dub_language":"გახმოვანება","captions":"სუბტიტრები","languages":{"off":"გამორთვა","en":"ინგლისური","ru":"რუსული","ka":"ქართული","ge":"ქართული","fr":"ფრანგული","es":"ესპანური","it":"იტალიური","no":"ნორვეგიული","in":"ინდური","ja":"იაპონური","ua":"უკრაინული","da":"დანიური","english":"ინგლისური","georgian":"ქართული","ukrainian":"უკრაინული","russian":"რუსული","русские":"რუსული","ara":"არაბული","swd":"შვედური","ser":"სერბული","irn":"ირანული","heb":"ებრაული","he":"ებრაული","tr":"თურქული","pl":"პოლონური","pt":"პორტუგალიური","ned":"ჰოლანდიური","nl":"ჰოლანდიური","is":"ისლანდიური","hy":"სომხური","az":"აზერბაიჯანული","ko":"კორეული","el":"ბერძნული","chn":"ჩინური","zh":"ჩინური","cs":"ჩეხური","uk":"უკრაინული","de":"გერმანული"},"quality":"ხარისხი","ad_blocker":"თუ AdBlocker-ს იყენებთ, ჩართვას ვერ შეძლებთ","try_again":"გავთიშე","not_allowed":"ქვეყანაში, სადაც იმყოფებით, cavea+ ჯერ ხელმისაწვდომი არ არის.","coming_soon":"ახალი სერია, მალე..."},"footer":{"copyright":"2024 cavea.plus","rights":"ყველა უფლება დაცულია","terms_of_use":"მოხმარების პირობები","support":"დახმარება"},"terms_of_use":{"title":"Cavea+-ს გამოყენების პირობები"},"search":{"search":"ძიება","placeholder":"აბა, რას ვეძებთ?","not_found":"{{searchString}} არ მოიძებნა","clear":"წაშლა","movie":"ფილმი","tv-shows":"სერიალი"},"dub_languages":{"ENG":"ინგლისური","GEO":"ქართული","UA":"უკრაინული","RUS":"რუსული","FRA":"ფრანგული","NLD":"ჰოლანდიური","DEU":"გერმანული","DAN":"დანიური","CZE":"ჩეხური","PER":"სპარსული","IND":"ინდური","CHN":"ჩინური","ISL":"ისლანდიური","ARA":"არაბული","SWD":"შვედური","SER":"სერბული","IRN":"ირანული","HEB":"ებრაული","TR":"თურქული","PL":"პოლონური","PT":"პორტუგალიური","ARM":"სომხური","AZ":"აზერბაიჯანული","KO":"კორეული","EL":"ბერძნული","ZH":"ჩინური"},"support":{"modal":{"title":"დაგვიკავშირდით:","email":"ელ-ფოსტა:","phone":"ტელეფონი:"}},"auth_tv":{"title":"შესული ხართ როგორც","code":"შეიყვანეთ ტელევიზორზე ნაჩვენები კოდი","success":"შეგიძლიათ დახუროთ ფანჯარა.","required":"შევსება სავალდებულოა","wrong_code":"არასწორი კოდი","silk-btn":"სილქნეტის ანგარიშით","cavea-btn":"CaveaPlus ანგარიშით","loading":"იტვირთება, გთხოვთ დაელოდოთ","language-btn":"Switch to English"},"quick-auth":{"title":"დაასკანირე QR კოდი ან ეწვიე ვებსაიტს შენს კომპიუტერზე/მობილურზე:","visit":"ეწვიე","enter-code":"შეიყვანე ერთჯერადი კოდი:","close":"დახურვა"},"welcome":{"title":"პირველი ქართული სტრიმინგ პლატფორმა","log_in":"ავტორიზაცია"},"coming_soon_modal":{"movie":"ფილმი მალე დაგვემატება","series":"სერიალი მალე დაგვემატება","episode":"ეპიზოდი მალე დაგვემატება"},"buy_movie_modal":{"title":"შეიძინე ფილმი Cavea.plus-ის ვებსაიტზე, ავტორიზირდი Silknet-ის პლატფორმაზე Cavea.plus-ის ანგარიშით და უყურე ფილმს მარტივად"},"months":{"January":"იანვარს","February":"თებერვალს","March":"მარტს","April":"აპრილს","May":"მაისს","June":"ივნისს","July":"ივლისს","August":"აგვისტოს","September":"სექტემბერს","October":"ოქტომბერს","November":"ნოემბერს","December":"დეკემბერს"},"popup":{"mobile_app":"აპლიკაცია","download":"გადმოიწერე","availability":"Android და iOS"},"exit":{"text":"გსურთ აპლიკაციიდან გამოსვლა?"},"idle":{"text":"გსურს ყურების გაგრძელება?","no":"არა"},"logout":{"text":"გსურთ გამოსვლა? ხელახალი ავტორიზაციისთვის თავიდან შემოდით CaveaPlus-ის აპლიკაციაში"},"session_ended":{"text":"დაფიქსირდა შეცდომა, გთხოვთ, ავტორიზაცია თავიდან გაიაროთ."}}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MovieQualityEnum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Player; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlayerStyles_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlayerStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PlayerStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sprite_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_sprite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_sprite_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_general_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_general_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_general_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_buttons_buttonViewStyles_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_buttons_buttonViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_buttons_buttonViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlayerService__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ShakaPlayer__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_CobaltBuffered__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_loading_spinner_LoadingSpinner__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_player_PlayerProgress__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_player_PlayerControls__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_PlayerStateContext__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__context_PlayerErrorMessageContext__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__context_Auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__context_ExitModalContext__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_modals_IdlePromptModal__ = __webpack_require__(199);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





















var MovieQualityEnum;
(function (MovieQualityEnum) {
    MovieQualityEnum["HD"] = "HD";
    MovieQualityEnum["SD"] = "SD";
})(MovieQualityEnum || (MovieQualityEnum = {}));
// Work around Cobalt's broken TimeRanges before any SourceBuffer is created.
// This patches SourceBuffer rather than Shaka, so it belongs at module scope.
// It no-ops on Cobalt 21+ and in a desktop browser — see CobaltBuffered.
Object(__WEBPACK_IMPORTED_MODULE_7__utils_CobaltBuffered__["a" /* installCobaltBufferedShim */])();
// shaka.util.Error.Severity.CRITICAL. RECOVERABLE (1) means Shaka is still
// retrying — segment fetches retry forever and never escalate — so only 2 is
// worth ending playback over.
var SHAKA_SEVERITY_CRITICAL = 2;
// --- Stall watchdog tuning (Cobalt below 21) ---
// Shaka 2.5.23's own StallDetector nudges currentTime by 0.1s after 1s of no
// progress, and on these boxes that nudge does not always take. This is the
// second tier: it waits well past Shaka's attempt, then escalates to a backward
// seek, forcing the full rebuffer Shaka never asks for. It samples currentTime
// and readyState only, so the buffered mask cannot influence it.
var WATCHDOG_INTERVAL_MS = 2000;
var FIRST_STALL_TIMEOUT_MS = 3000;
var STALL_TIMEOUT_MS = 5000;
var STALL_EPSILON_SECONDS = 0.25;
var STALL_NUDGE_SECONDS = 0.5;
var STALL_REBUFFER_SECONDS = 3;
var MAX_FORWARD_NUDGES = 2;
var MAX_REBUFFER_STEPS = 3;
var IDLE_TIMEOUT_MS = 3 * 60 * 60 * 1000;
var DIGIT_CODES = [
    "Digit0",
    "Digit1",
    "Digit2",
    "Digit3",
    "Digit4",
    "Digit5",
    "Digit6",
    "Digit7",
    "Digit8",
    "Digit9",
];
var Player = function (_a) {
    var watchData = _a.watchData, lastInputAtRef = _a.lastInputAtRef;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_9__context_Router__["b" /* useRouter */])(), goBack = _b.goBack, navigate = _b.navigate;
    var isExitModalOpen = Object(__WEBPACK_IMPORTED_MODULE_18__context_ExitModalContext__["b" /* useExitModal */])().isExitModalOpen;
    var profile = Object(__WEBPACK_IMPORTED_MODULE_16__context_Auth__["b" /* useAuth */])().profile;
    var updateStateProgress = Object(__WEBPACK_IMPORTED_MODULE_13__context_PlayerStateContext__["b" /* usePlayerStateActions */])().updateStateProgress;
    var errorActions = Object(__WEBPACK_IMPORTED_MODULE_14__context_PlayerErrorMessageContext__["b" /* usePlayerErrorMessageActions */])();
    var t = Object(__WEBPACK_IMPORTED_MODULE_17_react_i18next__["b" /* useTranslation */])().t;
    var videoRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var playerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        movieId: null,
        episodeId: null,
        episodeDetails: null,
        watchSessionId: null,
        movie: null,
        profileId: profile.id,
        source: { src: "", license: "" },
        playedSegments: [],
        progress: 0,
        quality: null,
        language: null,
        caption: null,
        loaded: false,
        videoTracks: null,
        audioTracks: null,
        textTracks: null,
        playing: false,
        ended: false,
        seasons: [],
        lastWatchedSeason: null,
        mappers: null,
    }), playerState = _c[0], setPlayerState = _c[1];
    var progressRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])((watchData === null || watchData === void 0 ? void 0 : watchData.progress) || 0);
    var currentTimeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])((watchData === null || watchData === void 0 ? void 0 : watchData.currentTime) || 0);
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), loading = _d[0], setLoading = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), showControls = _e[0], setShowControls = _e[1];
    var controlsTimerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var cleanupRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var digitSeekTargetRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(-1);
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), showIdlePrompt = _f[0], setShowIdlePrompt = _f[1];
    var idleTimerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var idlePromptOpenRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var idleDisabledRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var idleWasPlayingRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    // --- Controls auto-hide ---
    var resetControlsTimer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setShowControls(true);
        if (controlsTimerRef.current)
            clearTimeout(controlsTimerRef.current);
        controlsTimerRef.current = setTimeout(function () { return setShowControls(false); }, 5000);
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        resetControlsTimer();
        return function () {
            if (controlsTimerRef.current)
                clearTimeout(controlsTimerRef.current);
        };
    }, [resetControlsTimer]);
    // --- Idle prompt ---
    var resetIdleTimer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (idlePromptOpenRef.current || idleDisabledRef.current)
            return;
        if (idleTimerRef.current)
            clearTimeout(idleTimerRef.current);
        var delay = Math.max(0, IDLE_TIMEOUT_MS - (Date.now() - lastInputAtRef.current));
        idleTimerRef.current = setTimeout(function () {
            idleTimerRef.current = null;
            if (idlePromptOpenRef.current || idleDisabledRef.current)
                return;
            idleWasPlayingRef.current =
                !!videoRef.current &&
                    !videoRef.current.paused &&
                    !videoRef.current.ended;
            if (videoRef.current)
                videoRef.current.pause();
            if (isExitModalOpen())
                return;
            idlePromptOpenRef.current = true;
            __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "exitModal", index: 0 });
            setShowIdlePrompt(true);
        }, delay);
    }, [isExitModalOpen]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (playerState.loaded)
            resetIdleTimer();
        return function () {
            if (idleTimerRef.current)
                clearTimeout(idleTimerRef.current);
            if (idlePromptOpenRef.current) {
                __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].popLayer();
                idlePromptOpenRef.current = false;
            }
        };
    }, [resetIdleTimer, playerState.loaded]);
    var handleIdleYes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].popLayer();
        idlePromptOpenRef.current = false;
        setShowIdlePrompt(false);
        if (videoRef.current && idleWasPlayingRef.current)
            videoRef.current.play();
        lastInputAtRef.current = Date.now();
        resetIdleTimer();
    }, [resetIdleTimer]);
    var handleIdleNo = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].popLayer();
        idlePromptOpenRef.current = false;
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        navigate("home");
    }, [navigate]);
    // --- Focus setup ---
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (playerState.loaded)
            return;
        __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].registerGroup({ name: "playerClose", position: 5 });
        __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].manualFocus("playerClose", 0);
        var t = setTimeout(function () { return __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].manualFocus("playerControls", 0); }, 0);
        return function () { return clearTimeout(t); };
    }, [playerState.loaded]);
    // --- Sync watchData into playerState ---
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPlayerState(function (prev) { return (__assign(__assign({}, prev), watchData)); });
        currentTimeRef.current = (watchData === null || watchData === void 0 ? void 0 : watchData.currentTime) || 0;
        progressRef.current = (watchData === null || watchData === void 0 ? void 0 : watchData.progress) || 0;
    }, [watchData]);
    // --- Player lifecycle ---
    //
    // Startup sequence:
    //   1. Create Shaka player (sync)
    //   2. Attach ALL event listeners to <video>
    //   3. Call player.load() — Shaka begins buffering
    //   4. First canplay: seek to saved position
    //   5. seeked: call video.play() from correct position, mark ready
    //
    // If no saved position (targetTime=0), steps 4-5 are skipped:
    //   first canplay plays immediately and marks ready.
    //
    // Buffer detection uses a 1200ms debounce — short micro-buffers
    // don't flash the spinner.
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var _a;
        var video = videoRef.current;
        if (!playerState.movie || !playerState.episodeId || !video)
            return;
        if (!((_a = playerState.source) === null || _a === void 0 ? void 0 : _a.src))
            return;
        // Mask the spurious-empty video.buffered on the Cobalt majors that still
        // have the bug. Shaka 2.5.23's own stall recovery reads this and gives up
        // when it reads empty, so the shim is what keeps that recovery working.
        Object(__WEBPACK_IMPORTED_MODULE_7__utils_CobaltBuffered__["c" /* shimVideoBuffered */])(video);
        // Clean up previous player instance
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        setLoading(true);
        // --- State flags (local to this effect, not React state) ---
        var ready = false;
        var initialCanPlayFired = false;
        var targetTime = progressRef.current >= 0.95 ? 0 : currentTimeRef.current || 0;
        var lastTimeCheckSecond = 0;
        // Raised once per player instance, by showFatalError below.
        var gaveUp = false;
        // Every fatal path ends in the same modal, and each one has to isolate focus
        // behind a layer first: the modal's own dismissal pops a layer, so skipping
        // the push pops one belonging to the screen underneath and leaves its focus
        // in a stale group.
        var showFatalError = function () {
            if (gaveUp)
                return;
            gaveUp = true;
            idleDisabledRef.current = true;
            if (idleTimerRef.current)
                clearTimeout(idleTimerRef.current);
            if (idlePromptOpenRef.current) {
                __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].popLayer();
                idlePromptOpenRef.current = false;
                setShowIdlePrompt(false);
            }
            __WEBPACK_IMPORTED_MODULE_15__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "modalView", index: 0 });
            errorActions.show(t("player.playback_failed"), "text-danger", null);
            errorActions.returnTo("back", t("layout.back_home"));
        };
        // --- 1. Create Shaka player ---
        // WatchScreen loads Shaka alongside the movie/episode fetch and does not
        // render this component until it is ready, so the build is here, with its
        // polyfills already installed by loadShaka(). Shaka's own API stays behind
        // createShakaPlayer — everything below speaks the facade's shape.
        // There is no error boundary in the app, so a throw here would take the
        // whole screen down rather than showing the player's own failure message.
        var player;
        try {
            player = Object(__WEBPACK_IMPORTED_MODULE_6__utils_ShakaPlayer__["a" /* createShakaPlayer */])(video);
        }
        catch (error) {
            console.error("Player create error:", error);
            showFatalError();
            return;
        }
        playerRef.current = player;
        // --- 2. Event handlers ---
        var setReady = function () {
            ready = true;
            setLoading(false);
            var dur = video.duration;
            var progress = dur > 0 ? Math.round((video.currentTime / dur) * 100) / 100 : 0;
            progressRef.current = progress;
            setPlayerState(function (s) { return (__assign(__assign({}, s), { playing: true, loaded: true, progress: progress })); });
        };
        var onCanPlay = function () {
            if (!initialCanPlayFired) {
                initialCanPlayFired = true;
                // Only resume to a stored currentTime that is known-good: finite, and
                // strictly inside a known (finite) duration. A corrupt or foreign value
                // past the end would seek past it — firing `ended` at once — or into an
                // unbuffered gap that never fires `seeked`, wedging startup on the
                // spinner. Anything else (out of range, or duration not yet known)
                // starts fresh; losing the resume point beats not being able to watch.
                var duration = video.duration;
                var canResume = targetTime > 0 &&
                    isFinite(targetTime) &&
                    isFinite(duration) &&
                    targetTime < duration;
                if (canResume) {
                    video.currentTime = targetTime;
                }
                else {
                    video.play();
                    setReady();
                }
                return;
            }
            if (ready) {
                clearBuffering();
                setPlayerState(function (s) { return (__assign(__assign({}, s), { playing: true })); });
            }
        };
        var onSeeked = function () {
            // The resume seek is what completes startup: play from the restored
            // position and only then mark ready.
            if (!ready) {
                video.play();
                setReady();
                return;
            }
            if (video.readyState >= 3) {
                setLoading(false);
            }
        };
        var onPlay = function () {
            if (ready) {
                clearBuffering();
                setPlayerState(function (s) { return (__assign(__assign({}, s), { playing: true })); });
            }
        };
        var onCanPlayThrough = function () {
            if (ready)
                clearBuffering();
        };
        // --- Buffer detection with 1200ms debounce ---
        var bufferTimer = null;
        var showBuffering = function () {
            if (bufferTimer)
                return;
            bufferTimer = setTimeout(function () {
                if (!video.paused && !video.ended) {
                    setLoading(true);
                }
                bufferTimer = null;
            }, 1200);
        };
        var clearBuffering = function () {
            if (bufferTimer) {
                clearTimeout(bufferTimer);
                bufferTimer = null;
            }
            if (ready)
                setLoading(false);
        };
        var onWaiting = function () {
            if (ready)
                showBuffering();
        };
        var onStalled = function () {
            if (ready && !video.paused && !video.ended)
                showBuffering();
        };
        var onPause = function () {
            if (!ready)
                return;
            if (video.readyState < 3) {
                setLoading(true);
                return;
            }
            setPlayerState(function (s) {
                var next = __assign(__assign({}, s), { playing: false });
                if (playerRef.current)
                    Object(__WEBPACK_IMPORTED_MODULE_5__PlayerService__["e" /* updateProgress */])(videoRef, next);
                return next;
            });
        };
        var onTimeUpdate = function () {
            if (!videoRef.current || !playerRef.current || !ready)
                return;
            var currentTime = videoRef.current.currentTime;
            if (lastTimeCheckSecond === Math.floor(currentTime))
                return;
            lastTimeCheckSecond = Math.floor(currentTime);
            clearBuffering();
            setPlayerState(function (s) {
                if (!s.loaded)
                    return s;
                var dur = videoRef.current.duration;
                var newProgress = dur > 0 ? Math.round((currentTime / dur) * 100) / 100 : 0;
                progressRef.current = newProgress;
                var next = __assign(__assign({}, s), { progress: newProgress });
                var stats = Object(__WEBPACK_IMPORTED_MODULE_5__PlayerService__["d" /* getProgresStats */])(videoRef.current, next);
                if (stats) {
                    updateStateProgress(stats.progress, stats.timeLeftSide, stats.timeRightSide);
                }
                var lastSaved = currentTimeRef.current;
                currentTimeRef.current = currentTime;
                if ((Math.floor(currentTime) % 15 === 0 ||
                    Math.abs(currentTime - lastSaved) > 15) &&
                    Math.floor(currentTime) !== Math.floor(lastSaved)) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__PlayerService__["e" /* updateProgress */])(videoRef, next);
                }
                return next;
            });
        };
        var onEnded = function () {
            setPlayerState(function (s) { return (__assign(__assign({}, s), { playing: false, ended: true })); });
        };
        var onAdaptation = function () {
            setPlayerState(function (s) {
                var videoTracks = playerRef.current.getVideoTracks();
                var audioTracks = playerRef.current.getAudioTracks();
                var textTracks = playerRef.current.getTextTracks();
                if (s.language && (audioTracks === null || audioTracks === void 0 ? void 0 : audioTracks.length)) {
                    var track = audioTracks.find(function (t) { return t.lang === s.language; });
                    if (track) {
                        playerRef.current.selectAudioTrack(track.id, true);
                    }
                }
                return __assign(__assign({}, s), { videoTracks: videoTracks, audioTracks: audioTracks, textTracks: textTracks });
            });
        };
        // Every failure after load() resolves — streaming retries exhausted,
        // key-status or DRM failure, the network going away — is delivered only as
        // Shaka's own "error" event; nothing rejects and the default failure
        // callback just logs. Without this listener those are a silent spinner.
        var onShakaError = function (event) {
            var detail = event.detail;
            console.error("[player] shaka error", detail === null || detail === void 0 ? void 0 : detail.code, detail);
            if ((detail === null || detail === void 0 ? void 0 : detail.severity) === SHAKA_SEVERITY_CRITICAL) {
                showFatalError();
            }
        };
        var onLargeGap = function (event) {
            var currentTime = event.currentTime;
            if (Math.abs(currentTime - digitSeekTargetRef.current) < 1) {
                event.preventDefault();
            }
        };
        // --- Stall watchdog ---
        var watchdogTimer = null;
        var lastSampledTime = -1;
        var stalledSince = 0;
        var recoveryAttempts = 0;
        var recovering = false;
        var stallAnchor = 0;
        var recoverFromStall = function () {
            recoveryAttempts++;
            var position = video.currentTime;
            var duration = video.duration;
            // Where this stall episode started. Backward seeks are measured from here
            // rather than from the current position, so repeated attempts do not
            // compound: a permanently wedged box would otherwise walk itself
            // backwards through the asset 3s at a time, and onTimeUpdate persists
            // that drift as the stored resume point.
            if (recoveryAttempts === 1)
                stallAnchor = position;
            // A nudge into or past the end fires `ended` and finishes the movie
            // early, so go straight to the backward rebuffer there.
            var nudgeWouldOvershoot = duration > 0 && position + STALL_NUDGE_SECONDS >= duration - 1;
            // Deepen the rebuffer over the first few attempts so each one asks for a
            // different spot, then hold at that floor for as long as the stall lasts.
            var rebufferSteps = Math.min(Math.max(1, recoveryAttempts - MAX_FORWARD_NUDGES), MAX_REBUFFER_STEPS);
            var target = recoveryAttempts <= MAX_FORWARD_NUDGES && !nudgeWouldOvershoot
                ? position + STALL_NUDGE_SECONDS
                : Math.max(0, stallAnchor - STALL_REBUFFER_SECONDS * rebufferSteps);
            console.warn("[player] stall recovery attempt " +
                recoveryAttempts +
                " — seeking " +
                position.toFixed(1) +
                "s -> " +
                target.toFixed(1) +
                "s");
            video.currentTime = target;
            // Re-baseline on the next tick from where the box actually landed, not
            // from `target`: a nudge it ignores or snaps back from would otherwise
            // read as playback progress and reset the ladder before it ever reached
            // the backward rebuffer seek.
            recovering = true;
            stalledSince = 0;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch(function (error) {
                    console.warn("[player] play() after stall recovery failed", error);
                });
            }
        };
        var watchdogTick = function () {
            // Past the fatal modal there is nothing left to recover, and the
            // readyState gate below would not stop us on its own: a key-status or DRM
            // failure can sit at readyState 4 with data still buffered.
            if (gaveUp)
                return;
            if (!ready || video.paused || video.ended || video.seeking) {
                stalledSince = 0;
                return;
            }
            var currentTime = video.currentTime;
            // Take the new baseline from where the box actually landed after a
            // recovery seek, and never read that jump as progress.
            if (recovering) {
                recovering = false;
                lastSampledTime = currentTime;
                return;
            }
            // Movement in either direction is progress — a user seek backwards is not
            // a stall — which is also what keeps a manual seek from being counted as
            // one without the seek handlers having to say so.
            if (Math.abs(currentTime - lastSampledTime) > STALL_EPSILON_SECONDS) {
                lastSampledTime = currentTime;
                stalledSince = 0;
                recoveryAttempts = 0;
                return;
            }
            var now = Date.now();
            if (stalledSince === 0) {
                stalledSince = now;
                return;
            }
            var timeout = recoveryAttempts === 0 ? FIRST_STALL_TIMEOUT_MS : STALL_TIMEOUT_MS;
            if (now - stalledSince < timeout)
                return;
            console.warn("[player] stall confirmed at " +
                currentTime.toFixed(1) +
                "s — readyState " +
                video.readyState);
            // A silent wedge fires neither `waiting` nor `stalled`, so without this
            // the frame just sits there with no spinner over it.
            showBuffering();
            // Only a wedged-but-buffered pipeline is fixable by seeking. With no
            // future data we are genuinely starved, so leave the spinner to wait it
            // out rather than seek into an unbuffered spot. Recovery never gives up:
            // a long buffering stretch on a slow box is not a dead stream.
            if (video.readyState < 3) {
                // Restart the clock so a starved stretch reports once per timeout
                // instead of on every tick.
                stalledSince = now;
                return;
            }
            recoverFromStall();
        };
        // --- Attach listeners BEFORE load ---
        video.addEventListener("canplay", onCanPlay);
        video.addEventListener("seeked", onSeeked);
        video.addEventListener("play", onPlay);
        video.addEventListener("canplaythrough", onCanPlayThrough);
        video.addEventListener("waiting", onWaiting);
        video.addEventListener("stalled", onStalled);
        video.addEventListener("pause", onPause);
        video.addEventListener("timeupdate", onTimeUpdate);
        video.addEventListener("ended", onEnded);
        player.addEventListener("adaptation", onAdaptation);
        player.addEventListener("error", onShakaError);
        player.addEventListener("largegap", onLargeGap);
        if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_CobaltBuffered__["b" /* needsStallWatchdog */])()) {
            console.warn("[player] stall watchdog armed");
            watchdogTimer = setInterval(watchdogTick, WATCHDOG_INTERVAL_MS);
        }
        // --- Cleanup ---
        var cleanup = function () {
            if (bufferTimer)
                clearTimeout(bufferTimer);
            if (watchdogTimer)
                clearInterval(watchdogTimer);
            video.removeEventListener("canplay", onCanPlay);
            video.removeEventListener("seeked", onSeeked);
            video.removeEventListener("play", onPlay);
            video.removeEventListener("canplaythrough", onCanPlayThrough);
            video.removeEventListener("waiting", onWaiting);
            video.removeEventListener("stalled", onStalled);
            video.removeEventListener("pause", onPause);
            video.removeEventListener("timeupdate", onTimeUpdate);
            video.removeEventListener("ended", onEnded);
            player.removeEventListener("adaptation", onAdaptation);
            player.removeEventListener("error", onShakaError);
            player.removeEventListener("largegap", onLargeGap);
            video.pause();
            player.unload();
            player.destroy();
            playerRef.current = null;
        };
        cleanupRef.current = cleanup;
        // --- 3. Load source ---
        player.load(playerState.source.src).catch(function (error) {
            console.error("Player load error:", error);
            // Superseded and aborted loads are swallowed in the facade, so anything
            // reaching here is terminal.
            showFatalError();
        });
        return function () {
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = null;
            }
        };
    }, [playerState.quality, playerState.episodeId]);
    // --- Keyboard interaction ---
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handleKeyInteraction = function (e) {
            if (idlePromptOpenRef.current)
                return;
            if (!showControls)
                e.preventDefault();
            resetControlsTimer();
            lastInputAtRef.current = Date.now();
            resetIdleTimer();
            var digit = DIGIT_CODES.indexOf(e.code);
            var video = videoRef.current;
            if (digit === -1 || !video || !Number.isFinite(video.duration))
                return;
            digitSeekTargetRef.current = (video.duration / 10) * digit;
            video.currentTime = digitSeekTargetRef.current;
        };
        window.addEventListener("keydown", handleKeyInteraction);
        return function () { return window.removeEventListener("keydown", handleKeyInteraction); };
    }, [showControls, resetControlsTimer, resetIdleTimer]);
    // --- Close player ---
    var closePlayer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        goBack();
    }, [goBack]);
    var playerCloseRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_Helpers__["k" /* useFocusable */])({
        group: "playerClose",
        index: 0,
        onKeyDown: closePlayer,
        onKeyBack: closePlayer,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "player-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("video", { className: "video-player" + (!playerState.loaded ? " video-hidden" : ""), ref: videoRef }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "player-close", className: "close-container " + (!showControls && "hide-controls"), ref: playerCloseRef, tabIndex: 0 },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "close" })),
        playerState.loaded && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "player-controls " + (!showControls && "hide-controls") },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_player_PlayerProgress__["a" /* PlayerProgress */], null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_player_PlayerControls__["a" /* PlayerControls */], { closePlayer: closePlayer, playerState: playerState, setPlayerState: setPlayerState, playerRef: playerRef, videoRef: videoRef }))),
        loading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_views_loading_spinner_LoadingSpinner__["a" /* LoadingSpinner */], null),
        showIdlePrompt && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "idle-prompt-overlay", tabIndex: 0, className: "modal-overlay", key: "idle-prompt-modal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__components_views_modals_IdlePromptModal__["a" /* IdlePromptModal */], { onYes: handleIdleYes, onNo: handleIdleNo })))));
};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createShakaPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoadShaka__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(23);
// One player interface over Shaka 2.5.23.
//
// The whole fleet runs 2.5.23 (see LoadShaka), whose API is not the one the app
// speaks: the player constructs bare and attaches the video separately rather
// than taking it in the constructor, it loads a URL rather than a
// DashVideoSource, and tracks are single "variants" selected by language rather
// than separate audio and video lists selected by id.
//
// Rather than translate at every call site across Player and PlayerControls, it
// is wrapped once here to look like the shape the app already speaks. That shape
// is Shaka 1.x's, which the app was written against and the Cobalt 11 boxes ran
// until they were retired (CP-2353).


// Cobalt has no video.textTracks, and every text displayer Shaka 2 ships reads
// it while constructing — which rejects load() before a single byte of media
// moves. This one does nothing, which is no loss today: the caption list in
// PlayerControls is commented out, so nothing can turn subtitles on. Rendering
// them on Cobalt needs a displayer that paints into a div (CP-2018).
var NoopTextDisplayer = /** @class */ (function () {
    function NoopTextDisplayer() {
    }
    NoopTextDisplayer.prototype.configure = function () { };
    NoopTextDisplayer.prototype.append = function () { };
    NoopTextDisplayer.prototype.remove = function () {
        return true;
    };
    NoopTextDisplayer.prototype.destroy = function () {
        return Promise.resolve();
    };
    NoopTextDisplayer.prototype.isTextVisible = function () {
        return false;
    };
    NoopTextDisplayer.prototype.setTextVisibility = function () { };
    return NoopTextDisplayer;
}());
// Shaka 2 reports a cancelled load as an error. Tearing the player down while a
// load is still running is normal here — every episode and quality change does
// it — so these two codes are noise rather than failures.
var LOAD_INTERRUPTED = 7000;
var OPERATION_ABORTED = 7001;
var isAbortError = function (error) {
    var _a;
    var code = (_a = error) === null || _a === void 0 ? void 0 : _a.code;
    return code === OPERATION_ABORTED || code === LOAD_INTERRUPTED;
};
// Shaka 2 finishes tearing a player down by taking the video element away from
// it — removeAttribute("src") then load(), inside a promise chain that settles
// long after destroy() has returned. A quality change reuses the same <video>:
// the effect re-runs, the old player is dropped and a new one attaches, and the
// old player's teardown would then strip the src the new one just set, leaving a
// black frame and a spinner that never clears. Teardowns are therefore queued
// here, and a new player waits for the outstanding ones before it attaches.
var pendingTeardown = Promise.resolve();
// Shaka's teardown waits on the in-flight SourceBuffer operations, which only
// settle from updateend/error on the SourceBuffer itself. On a wedged pipeline
// those events may never arrive, and an unbounded wait would mean every later
// title hangs on a spinner for the rest of the session. Giving up on a teardown
// risks the src-stripping race this queue exists to prevent, but a bounded race
// beats a permanent hang.
var TEARDOWN_TIMEOUT_MS = 5000;
var queueTeardown = function (step) {
    pendingTeardown = pendingTeardown
        .then(function () {
        return new Promise(function (resolve) {
            var timer = setTimeout(function () {
                console.warn("[player] Shaka teardown timed out — continuing");
                resolve();
            }, TEARDOWN_TIMEOUT_MS);
            step().then(function () {
                clearTimeout(timer);
                resolve();
            }, function () {
                clearTimeout(timer);
                resolve();
            });
        });
    })
        .catch(function () { });
};
// Which language a 2.x track id belongs to. Both variant and text tracks carry
// the same two fields this needs.
var languageOf = function (tracks, id) {
    var numericId = Number(id);
    var track = tracks.find(function (candidate) { return candidate.id === numericId; });
    if (!track) {
        return "";
    }
    return track.language || "";
};
var OWN_API_PATH = "/api/v1/";
// The headers carry the STB dev key, so they go only to this app's own API,
// never to a CDN or licence server a manifest might point at.
var isOwnApiRequest = function (uris) {
    var ownApiUrl = window.location.protocol + "//" + window.location.host + OWN_API_PATH;
    return uris.every(function (uri) { return uri.indexOf(OWN_API_PATH) === 0 || uri.indexOf(ownApiUrl) === 0; });
};
var createV2Facade = function (player, video) {
    player.configure({
        abr: { enabled: true },
        streaming: {
            bufferingGoal: 15,
            bufferBehind: 10,
            jumpLargeGaps: true,
        },
        textDisplayFactory: NoopTextDisplayer,
    });
    // Shaka does its own networking, so without this its requests skip the headers
    // the axios client adds — and a local build off the Silk host then gets its
    // DRM-free streams refused.
    player.getNetworkingEngine().registerRequestFilter(function (_type, request) {
        if (isOwnApiRequest(request.uris)) {
            Object.assign(request.headers, Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* appHeaders */])());
        }
    });
    // Whatever teardown was still outstanding when this player was built. The
    // previous player may still be holding the same <video>.
    var previousTeardown = pendingTeardown;
    // 2.x wants the video element attached separately, and attach() is async.
    // Doing it inside load() keeps construction synchronous, so the caller can
    // register listeners and tear down exactly as it does on 1.x.
    var attached;
    var attach = function () {
        if (!attached) {
            attached = previousTeardown.then(function () { return player.attach(video); });
        }
        return attached;
    };
    var variantsByLanguage = function () {
        var seen = new Set();
        var result = [];
        player.getVariantTracks().forEach(function (track) {
            var language = track.language || "";
            if (seen.has(language)) {
                return;
            }
            seen.add(language);
            result.push(track);
        });
        return result;
    };
    return {
        load: function (url) {
            return attach()
                .then(function () {
                // Silk stream URLs end in "/" with no extension, so Shaka has nothing
                // to guess a manifest parser from unless the type is named outright.
                return player.load(url, null, "application/dash+xml");
            })
                .catch(function (error) {
                if (isAbortError(error)) {
                    return;
                }
                throw error;
            });
        },
        // Fire-and-forget by design: ordering is handled by the queue, so no caller
        // has to await anything.
        //
        // destroy() already walks the full unload route on its way to detached, and
        // that route contains a hard 100ms timer, so unloading first would pay for
        // it twice on every quality change. The only caller does both back to back.
        unload: function () { },
        destroy: function () {
            queueTeardown(function () { return player.destroy(); });
        },
        // Nothing reads videoTracks — resolution switching swaps the source URL via
        // `mappers` rather than picking a rendition — so one entry per distinct
        // height is enough to keep the shape honest.
        getVideoTracks: function () {
            var seen = new Set();
            var result = [];
            player.getVariantTracks().forEach(function (track) {
                var height = track.height || 0;
                if (seen.has(height)) {
                    return;
                }
                seen.add(height);
                result.push({ id: track.id, lang: track.language || "" });
            });
            return result;
        },
        getAudioTracks: function () {
            return variantsByLanguage().map(function (track) { return ({
                id: track.id,
                lang: track.language || "",
            }); });
        },
        getTextTracks: function () {
            return player.getTextTracks().map(function (track) { return ({
                id: track.id,
                lang: track.language || "",
            }); });
        },
        // The app talks in track ids because that is what 1.x used, so the id has to
        // be resolved back to a language. Read it from the live track list rather
        // than a map the getters fill: after a quality or episode change the new
        // player's map would still be empty while the controls hold the previous
        // player's ids, and selecting would silently do nothing.
        //
        // Selecting the variant outright would pin the video rendition too and stop
        // ABR from adapting, so switch by language and let ABR keep its job.
        selectAudioTrack: function (id) {
            var language = languageOf(player.getVariantTracks(), id);
            if (language) {
                player.selectAudioLanguage(language);
            }
        },
        enableTextTrack: function (id) {
            var language = languageOf(player.getTextTracks(), id);
            if (language) {
                player.selectTextLanguage(language);
                // Async in 2.5.23, and it can reject — an unhandled rejection here
                // would be a crash rather than a subtitle that failed to appear.
                player.setTextTrackVisibility(true).catch(function (error) {
                    console.error("[player] enabling subtitles failed", error);
                });
            }
        },
        addEventListener: function (type, handler) {
            player.addEventListener(mapEventName(type), handler);
        },
        removeEventListener: function (type, handler) {
            player.removeEventListener(mapEventName(type), handler);
        },
    };
};
// The app listens for "adaptation" to mean "the track lists may have changed".
// In 2.x that news arrives as "trackschanged", which is also the event that
// fires once a manifest has been parsed.
var mapEventName = function (type) {
    if (type === "adaptation") {
        return "trackschanged";
    }
    return type;
};
/**
 * Builds a player. Synchronous, so it drops into the existing effect unchanged —
 * the asynchronous attach is folded into the first load() instead.
 */
var createShakaPlayer = function (video) {
    var shaka = Object(__WEBPACK_IMPORTED_MODULE_0__LoadShaka__["b" /* getShaka */])();
    if (!shaka.Player.isBrowserSupported()) {
        throw new Error("Shaka reports this browser is unsupported");
    }
    return createV2Facade(new shaka.Player(), video);
};


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shimVideoBuffered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return installCobaltBufferedShim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return needsStallWatchdog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoadShaka__ = __webpack_require__(27);
// Cobalt below 21 ships a broken TimeRanges implementation: both
// `HTMLMediaElement.buffered` and `SourceBuffer.buffered` intermittently report
// an EMPTY range while data is actually buffered. The Cobalt source comments
// that it is wrong; it is fixed in Cobalt 21. The HiSilicon and Broadcom boxes
// are on 19, so it is still live for most of the fleet.
//
// Shaka 2.5.23 reads both, and an empty read switches off its own recovery:
//
//   - Stall recovery never fires. StallDetector's shouldBeMakingProgress()
//     returns false when `video.buffered.length` is 0, so the moment a stall
//     needs nudging is exactly the moment Shaka decides not to nudge.
//
//   - The buffering goal is never met. StreamingEngine gates on
//     bufferedAheadOf(sourceBuffer), so a stuck-at-empty read means it keeps
//     prefetching instead of idling at `bufferingGoal`. Eviction reads the same
//     value, decides nothing is buffered and skips, so the SourceBuffer grows
//     until QUOTA_EXCEEDED — which Shaka answers by walking its buffering goal
//     down through eight reductions and, when those are exhausted, raising a
//     CRITICAL error that this app turns into the fatal "playback failed" modal.
//
//   - The spinner never clears. pollBufferState_ derives its buffer lead from
//     `video.buffered`, so BufferingObserver stays pinned at STARVING.
//
// Fix: mask the spurious empty reads. Strategy is "sticky last good" — every
// read that returns a non-empty range is remembered; a read that returns empty
// AFTER we have already seen real data (and the element is otherwise healthy)
// returns the remembered range instead of the bogus empty one. The first real
// fill is always passed through untouched, so we never fabricate buffer that
// never existed and a genuine underflow still reaches Shaka.
//
// The memory has to follow what is actually removed, or it becomes the stall it
// exists to prevent. Shaka empties buffers two ways, and they need opposite
// answers:
//
//   - A full clear (`MediaSourceEngine.clear()`, on every audio-track switch and
//     unbuffered seek) removes everything. If the memory survived it,
//     StreamingEngine would read "already at the buffering goal", fetch nothing,
//     and wait forever on data it never requested — a permanent freeze.
//
//   - Eviction (`evict_`, roughly once per appended segment) removes only the
//     front of the range, the oldest data behind the playhead. Forgetting the
//     whole range there would leave the mask disarmed for most of playback,
//     which is the starvation above.
//
// So a removal trims the remembered range and only forgets it when it takes the
// whole thing. `abort()` is deliberately NOT treated as a removal: it resets
// parser state without discarding data, and Shaka calls it on every bitrate
// switch.
//
// This is the buffered shim alone. The pause guard and the stall watchdog that
// used to sit alongside it were written for Shaka 1.6.5 and went with the Cobalt
// 11 boxes (CP-2353): 2.5.23 recovers by itself, provided it can read
// `buffered`. Keeping this half is what lets it.

var COBALT_BUFFERED_FIX_VERSION = 21;
var sourceBufferShimInstalled = false;
// Objects already carrying a mask, so re-running the player effect against the
// same <video> node doesn't stack wrappers or listeners.
var shimmedTargets = new WeakSet();
// The masks on <video> elements. `HTMLMediaElement.buffered` is the INTERSECTION
// of the SourceBuffers' ranges, so clearing any one of them genuinely empties
// it — and nothing tells the element that: an MSE wipe fires neither `emptied`
// nor `loadstart`. Every removal is therefore forwarded here as well. One entry
// per <video> the app ever creates, each holding four numbers.
var videoStickies = new Set();
var isCobalt = function () {
    return (navigator.userAgent || "").indexOf("Cobalt") !== -1;
};
// The major from window.STVVersion (e.g. "22.1.6"), or -1 where the box does not
// report one. Builds from 2026-08-06 onward carry it and it is authoritative;
// the user-agent parse is the fallback for everything older.
//
// Reads through getStvVersionNumber so this and the loading screen cannot drift
// on what the field holds. An anchored parse here returned -1 on any box that
// prefixes the field with a chipset name, retiring the source this comment
// calls authoritative and quietly leaving only the fallback.
var stvMajor = function () {
    var version = Object(__WEBPACK_IMPORTED_MODULE_0__LoadShaka__["c" /* getStvVersionNumber */])();
    if (!version) {
        return -1;
    }
    return parseInt(version, 10);
};
// Cobalt only, and only the majors that still carry the bug.
//
// A Cobalt that names no version in either source still gets the shim. Guessing
// "old" is the safe direction: on a healthy TimeRanges the mask never engages,
// because the empty reads it would replace do not happen — while missing it on a
// broken one is an unrecoverable stall. AM-BOX is in the fleet and Qarva has
// never mapped it to a Cobalt version, so this case is not hypothetical.
var shouldShim = function () {
    if (typeof navigator === "undefined") {
        return false;
    }
    var fromStv = stvMajor();
    if (fromStv >= 0) {
        return fromStv < COBALT_BUFFERED_FIX_VERSION;
    }
    var fromUserAgent = Object(__WEBPACK_IMPORTED_MODULE_0__LoadShaka__["a" /* getCobaltMajor */])();
    if (fromUserAgent >= 0) {
        return fromUserAgent < COBALT_BUFFERED_FIX_VERSION;
    }
    return isCobalt();
};
// A minimal TimeRanges-compatible object covering the single coalesced range
// Shaka reads. Every reader either takes start(0)/end(length-1) or iterates by
// index, so one range answers both. It is not a real TimeRanges: an `instanceof`
// check or a caller expecting IndexSizeError would not be satisfied. Nothing in
// Shaka 2.5.23 or this app does either.
var makeRange = function (start, end) {
    var range = {
        length: 1,
        start: function (index) {
            if (index !== 0)
                throw new Error("TimeRanges index out of bounds");
            return start;
        },
        end: function (index) {
            if (index !== 0)
                throw new Error("TimeRanges index out of bounds");
            return end;
        },
    };
    return range;
};
var createStickyRange = function () {
    var start = 0;
    var end = 0;
    var armed = false;
    var suspended = false;
    var forget = function () {
        start = 0;
        end = 0;
        armed = false;
    };
    return {
        // Ignored while a removal is in flight: between remove() and its updateend
        // the native range still describes data that is on its way out, and
        // remembering it there would mask the empty that follows.
        remember: function (from, to) {
            if (suspended) {
                return;
            }
            start = from;
            end = to;
            armed = true;
        },
        forget: forget,
        removed: function (from, to) {
            if (!armed) {
                return;
            }
            if (from <= start && to >= end) {
                // Took the whole memory — this is the deliberate clear.
                forget();
                return;
            }
            if (from <= start && to > start) {
                // Ate the front. Eviction is always this one.
                start = to;
                return;
            }
            if (to >= end && from < end) {
                // Ate the back.
                end = from;
                return;
            }
            if (from > start && to < end) {
                // Split it in two. One range cannot describe that without overstating
                // what is buffered, so drop the memory instead.
                forget();
            }
        },
        masked: function () {
            if (!armed) {
                return undefined;
            }
            return makeRange(start, end);
        },
        suspend: function () {
            suspended = true;
        },
        resume: function () {
            suspended = false;
        },
    };
};
var findBufferedGetter = function (target) {
    var current = target;
    while (current) {
        var descriptor = Object.getOwnPropertyDescriptor(current, "buffered");
        if (descriptor && typeof descriptor.get === "function") {
            return descriptor.get;
        }
        current = Object.getPrototypeOf(current);
    }
    return undefined;
};
// Replace the `buffered` accessor on a single object instance (the prototype
// accessor is shadowed by this own-property, which works even when the native
// descriptor is non-configurable on the prototype). `isHealthy` guards masking
// so a genuinely ended/torn-down element still reports its real empty range.
//
// Returns false when the mask could not be applied — not every Cobalt build
// exposes `buffered` as a redefinable accessor, and a silent no-op would look
// shimmed in the logs while behaving un-shimmed in the field.
var installBufferedMask = function (target, sticky, isHealthy) {
    // findBufferedGetter starts at the target, so masking twice would wrap our own
    // getter instead of the native one.
    if (shimmedTargets.has(target)) {
        return true;
    }
    var nativeGetter = findBufferedGetter(target);
    if (!nativeGetter) {
        console.warn("[player] no buffered accessor to shim — leaving it alone");
        return false;
    }
    try {
        Object.defineProperty(target, "buffered", {
            configurable: true,
            get: function () {
                var native = nativeGetter.call(this);
                if (native && native.length > 0) {
                    sticky.remember(native.start(0), native.end(native.length - 1));
                    return native;
                }
                if (isHealthy()) {
                    var remembered = sticky.masked();
                    if (remembered) {
                        return remembered;
                    }
                }
                return native;
            },
        });
        shimmedTargets.add(target);
        return true;
    }
    catch (error) {
        console.warn("[player] failed to shim buffered getter", error);
        return false;
    }
};
// Teach one SourceBuffer's memory about the data being taken away from it.
// Returns false if the wrapper could not be installed, which has to mean "do not
// mask this object at all": a mask nothing can disarm is a permanent freeze,
// while no mask is only the platform bug we started with.
var followRemovals = function (sourceBuffer, sticky) {
    var nativeRemove = sourceBuffer.remove;
    if (typeof nativeRemove !== "function") {
        return false;
    }
    try {
        Object.defineProperty(sourceBuffer, "remove", {
            configurable: true,
            writable: true,
            value: function (start, end) {
                // Order matters at both ends. Suspend before the native call, because a
                // platform that dispatched updateend synchronously from inside remove()
                // would resume before we suspended and retire the memory for good — and
                // this file exists because Cobalt's MSE is wrong in this very area.
                // Trim after it, so a removal that threw leaves the memory describing
                // what is still really there.
                sticky.suspend();
                try {
                    nativeRemove.call(this, start, end);
                }
                catch (error) {
                    sticky.resume();
                    throw error;
                }
                sticky.removed(start, end);
                // Trims are idempotent, so forwarding every removal is safe as well as
                // correct. These are deliberately not suspended: their latch would be
                // shared by two SourceBuffers removing independently, and one stream's
                // updateend would resume the other's window. The residue is that a read
                // taken between remove() and updateend can re-arm an element mask with a
                // range that is on its way out — bounded, corrected by the next honest
                // read, and the element mask is not in StreamingEngine's refetch loop.
                videoStickies.forEach(function (videoSticky) {
                    videoSticky.removed(start, end);
                });
            },
        });
    }
    catch (error) {
        console.warn("[player] failed to follow SourceBuffer removals", error);
        return false;
    }
    // updateend settles both appends and removals; either way the native range is
    // trustworthy again. error and abort end an operation without it, and this
    // file exists because Cobalt's MSE does not always keep to spec here — a
    // removal that never settled would strand the memory suspended for the rest of
    // the session.
    sourceBuffer.addEventListener("updateend", sticky.resume);
    sourceBuffer.addEventListener("error", sticky.resume);
    sourceBuffer.addEventListener("abort", sticky.resume);
    return true;
};
// Patch the <video> element. Masking is gated on the element still holding
// current data (readyState >= HAVE_CURRENT_DATA) and not having ended, so a real
// underflow — which drops readyState — is reported honestly to Shaka's
// StallDetector.
var shimVideoBuffered = function (video) {
    if (!shouldShim())
        return;
    // The effect re-runs on every episode and quality change against the same
    // node; the listeners below must not stack.
    if (shimmedTargets.has(video))
        return;
    var sticky = createStickyRange();
    var masked = installBufferedMask(video, sticky, function () { return video.readyState >= 2 && !video.ended; });
    if (!masked)
        return;
    // Shaka detaches by stripping src and calling load(), and attaches by setting
    // a fresh blob src. Both ends of that mark the death of one title's buffer, so
    // the next title does not inherit it.
    video.addEventListener("emptied", sticky.forget);
    video.addEventListener("loadstart", sticky.forget);
    videoStickies.add(sticky);
};
// Patch every SourceBuffer Shaka creates by wrapping MediaSource.addSourceBuffer
// once. The mask arms on the first non-empty read, so before the first append
// the real (empty) range is passed through and the initial buffering gate still
// waits for genuine data.
var installCobaltBufferedShim = function () {
    if (sourceBufferShimInstalled)
        return;
    sourceBufferShimInstalled = true;
    if (!shouldShim())
        return;
    if (typeof MediaSource === "undefined")
        return;
    var proto = MediaSource.prototype;
    var originalAddSourceBuffer = proto.addSourceBuffer;
    if (typeof originalAddSourceBuffer !== "function")
        return;
    // This runs at module scope, at app boot, on every screen. An unwritable
    // binding here would throw during module evaluation in the strict-mode bundle
    // and take the whole app down before it renders, so a failure has to stay a
    // failure to shim rather than a failure to start.
    try {
        proto.addSourceBuffer = function (type) {
            var sourceBuffer = originalAddSourceBuffer.call(this, type);
            // Everything past this point is ours, and none of it is worth failing a
            // load over — a throw escaping here would reject Shaka's init while
            // leaving the SourceBuffer attached but unknown to it.
            try {
                var sticky = createStickyRange();
                // Probe before wrapping, then disarm before masking (see
                // followRemovals). On a build that does not expose `buffered` as a
                // redefinable accessor the mask cannot go on at all, and the removal
                // feed would then cost every eviction, all session, on a no-JIT box, to
                // maintain state no getter reads.
                if (findBufferedGetter(sourceBuffer) &&
                    followRemovals(sourceBuffer, sticky)) {
                    installBufferedMask(sourceBuffer, sticky, function () { return true; });
                }
            }
            catch (error) {
                console.warn("[player] SourceBuffer shim skipped", error);
            }
            return sourceBuffer;
        };
        if (proto.addSourceBuffer !== originalAddSourceBuffer) {
            console.warn("[player] Cobalt buffered shim installed");
        }
        else {
            // Assigned without throwing and without taking — a silently read-only
            // binding. Saying nothing here is how a box looks shimmed in the logs
            // while behaving un-shimmed in the field.
            console.warn("[player] Cobalt buffered shim did not take");
        }
    }
    catch (error) {
        console.warn("[player] Cobalt buffered shim NOT installed", error);
    }
};
// The boxes that misreport `buffered` are the same ones that wedge mid-stream,
// so the shim's gate is also the stall watchdog's gate.
var needsStallWatchdog = function () { return shouldShim(); };


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerProgress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_PlayerStateContext__ = __webpack_require__(43);


var PlayerProgress = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__context_PlayerStateContext__["c" /* usePlayerStateData */])(), progress = _a.progress, timeLeftSide = _a.timeLeftSide, timeRightSide = _a.timeRightSide;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "progress-wrapper" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "current-time" }, timeLeftSide),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "progress" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "progress-bar", style: "width: " + progress * 100 + "%" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "time-left" }, timeRightSide)));
};


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerControls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_episode_list_EpisodeListView__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlayerResolutionList__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlayerDubbingList__ = __webpack_require__(198);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};









var PlayerControls = function (_a) {
    var _b;
    var playerState = _a.playerState, setPlayerState = _a.setPlayerState, videoRef = _a.videoRef, playerRef = _a.playerRef, closePlayer = _a.closePlayer;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_3__context_Router__["b" /* useRouter */])().navigate;
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), popup = _c[0], setPopup = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), showList = _d[0], setShowList = _d[1];
    var skipAccumulator = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
    var skipTimeoutRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].updateGroupOrder();
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].registerGroup({ name: "playerClose", position: 5 });
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].registerGroup({ name: "controls", position: 10 });
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].manualFocus("controls", 0);
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (playerState.ended &&
            playerState.movie &&
            playerState.movie.movieType === "series") {
            nextEpisode();
        }
    }, [playerState.ended]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (showList === "episodes") {
            videoRef.current.pause();
        }
        else if (!playerState.playing) {
            videoRef.current.play();
        }
    }, [showList]);
    var playPause = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!videoRef.current) {
            return;
        }
        setPlayerState(function (oldPlayerState) {
            var newState = __assign(__assign({}, oldPlayerState), { playing: true });
            if (videoRef.current.paused) {
                videoRef.current.play();
            }
            else {
                videoRef.current.pause();
                newState.playing = false;
            }
            return newState;
        });
    }, []);
    var skip = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (seconds) {
        if (!videoRef.current) {
            return;
        }
        if (!Number.isFinite(seconds)) {
            console.warn("Invalid skip value: not a finite number", seconds);
            return;
        }
        if (videoRef.current.duration - videoRef.current.currentTime < 10 &&
            seconds > 0) {
            return;
        }
        skipAccumulator.current += seconds;
        if (skipTimeoutRef.current) {
            clearTimeout(skipTimeoutRef.current);
        }
        skipTimeoutRef.current = setTimeout(function () {
            var currentTime = videoRef.current.currentTime;
            var duration = videoRef.current.duration;
            var maxDuration = duration - 10;
            if (!Number.isFinite(currentTime) || !Number.isFinite(duration)) {
                console.warn("Invalid video time or duration");
                skipAccumulator.current = 0;
                return;
            }
            var newTime = currentTime + skipAccumulator.current;
            newTime = Math.max(0, Math.min(newTime, maxDuration));
            try {
                videoRef.current.currentTime = newTime;
            }
            catch (error) {
                console.error("Failed to set video time:", error);
            }
            skipAccumulator.current = 0;
            skipTimeoutRef.current = null;
        }, 500);
    }, []);
    var nextEpisode = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!playerState.loaded)
            return;
        var movie = playerState.movie;
        if (!movie || !movie.episodes || !movie.episodes.length)
            return;
        var next = Object(__WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__["c" /* getNextEpisode */])(movie.episodes, playerState.episodeId);
        if (!next || next.isLast)
            return;
        setPlayerState(function (oldPlayerState) { return (__assign(__assign({}, oldPlayerState), { loading: true, loaded: false })); });
        navigate("watch", {
            slug: movie.slug,
            episode: next.id,
        });
    }, [playerState.loaded, playerState.movie, playerState.episodeId]);
    var togglePopUp = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
        if (name === "caption") {
            if (playerState.textTracks && playerState.textTracks.length === 0) {
                setPopup(null);
                return;
            }
        }
        setPopup(function (oldPopup) {
            var newPopup = oldPopup === name ? null : name;
            if (newPopup && newPopup.length > 0) {
                __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "playerPopup", index: 0 });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].popLayer();
            }
            return newPopup;
        });
    }, [playerState.textTracks]);
    var setCaption = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (caption) {
        togglePopUp("caption");
        setPlayerState(function (oldPlayerState) { return (__assign(__assign({}, oldPlayerState), { caption: caption.lang })); });
        setPopup(null);
        Object(__WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__["e" /* updateProgress */])(videoRef, __assign(__assign({}, playerState), { caption: caption.lang }));
        caption.active = true;
        playerRef.current.enableTextTrack(caption.id);
    }, [playerState, togglePopUp]);
    var setDubbing = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (dubbing) {
        var newState = __assign(__assign({}, playerState), { language: dubbing.lang });
        togglePopUp("dubbing");
        Object(__WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__["e" /* updateProgress */])(videoRef, newState);
        setPlayerState(newState);
        playerRef.current.selectAudioTrack(dubbing.id, true);
    }, [playerState, togglePopUp]);
    var setResolution = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (resolution) {
        togglePopUp("resolution");
        setPlayerState(function (oldPlayerState) {
            if (resolution === oldPlayerState.quality) {
                return oldPlayerState;
            }
            if (!oldPlayerState.mappers) {
                return oldPlayerState;
            }
            var newSource = oldPlayerState.mappers
                ? Object(__WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__["a" /* generateSource */])(oldPlayerState.mappers, resolution.toUpperCase())
                : oldPlayerState.source;
            var newState = __assign(__assign({}, oldPlayerState), { quality: resolution, source: newSource !== null && newSource !== void 0 ? newSource : oldPlayerState.source });
            Object(__WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__["e" /* updateProgress */])(videoRef, newState);
            return newState;
        });
    }, [togglePopUp]);
    var playPauseRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 0,
        onKeyDown: playPause,
        onKeyBack: closePlayer,
    });
    var skipBackwardRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 1,
        onKeyDown: function () { return skip(-10); },
        onKeyBack: closePlayer,
    });
    var skipForwardRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 2,
        onKeyDown: function () { return skip(10); },
        onKeyBack: closePlayer,
    });
    var nextEpisodeRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 3,
        onKeyDown: nextEpisode,
        onKeyBack: closePlayer,
    });
    var episodeListRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 4,
        onKeyDown: function () {
            __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].pushLayer({ groupName: "episodeListClose", index: 0 });
            setShowList("episodes");
        },
        onKeyBack: closePlayer,
    });
    var captionListRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 5,
        onKeyDown: function () { return togglePopUp("caption"); },
        onKeyBack: closePlayer,
    });
    var audioListRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 6,
        onKeyDown: function () { return togglePopUp("dubbing"); },
        onKeyBack: closePlayer,
    });
    var resolutionListRef = Object(__WEBPACK_IMPORTED_MODULE_1__utils_Helpers__["k" /* useFocusable */])({
        group: "controls",
        index: 7,
        onKeyDown: function () { return togglePopUp("resolution"); },
        onKeyBack: closePlayer,
    });
    var handleCloseEpisodeList = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].clearGroupsAndResetOrder();
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].addGroupOrder("playerClose", 5);
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].addGroupOrder("controls", 10);
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].manualFocus("controls", 4);
        __WEBPACK_IMPORTED_MODULE_5__utils_Focus__["b" /* focusManager */].popLayer();
        setShowList("");
    }, []);
    var movieType = playerState.movie ? playerState.movie.movieType : null;
    var isLastEpisode = Object(__WEBPACK_IMPORTED_MODULE_2__screens_Player_PlayerService__["c" /* getNextEpisode */])(((_b = playerState.movie) === null || _b === void 0 ? void 0 : _b.episodes) || [], playerState.episodeId).isLast;
    var nextEpisodeClass = "player-control";
    if (isLastEpisode) {
        nextEpisodeClass += " disabled";
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "controls", id: "controls" },
        showList.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-overlay", key: showList },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__views_episode_list_EpisodeListView__["a" /* EpisodeListView */], { slug: playerState.movie ? playerState.movie.slug : "", episodes: playerState.movie ? playerState.movie.episodes : [], seasons: playerState.seasons, onClose: handleCloseEpisodeList, lastWatchedSeason: playerState.lastWatchedSeason, movieStatus: playerState.movie ? playerState.movie.status : null, currentEpisodeId: playerState.episodeId }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "left-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "player-control", ref: playPauseRef, tabIndex: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: playerState.playing ? "pause" : "play" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "player-control", ref: skipBackwardRef, tabIndex: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skip-back" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "player-control", ref: skipForwardRef, tabIndex: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "skip-next" }))),
        playerState.movie && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "movie-details" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "movie-name" }, playerState.movie.name),
            playerState.movie.movieType === "series" &&
                playerState.episodeDetails && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "episode-name" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, playerState.episodeDetails.episodeNumber),
                " ",
                playerState.episodeDetails.episodeName)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "right-container " + (movieType || "") },
            movieType === "series" && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: nextEpisodeClass, ref: nextEpisodeRef, tabIndex: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "next" }))),
            movieType === "series" && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "player-control", ref: episodeListRef, tabIndex: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "episode-list" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PlayerDubbingList__["a" /* PlayerDubbingList */], { language: playerState.language, popup: popup, audioTracks: playerState.audioTracks, onSetDubbing: setDubbing, onBackPress: function () { return togglePopUp("dubbing"); }, audioListRef: audioListRef }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PlayerResolutionList__["a" /* PlayerResolutionList */], { quality: playerState.quality, popup: popup, onSetResolution: setResolution, onBackPress: function () { return togglePopUp("resolution"); }, resolutionListRef: resolutionListRef }))));
};


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EpisodeListView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_general_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_general_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_general_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EpisodeListViewStyles_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EpisodeListViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EpisodeListViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EpisodeListItemView__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Focus__ = __webpack_require__(3);









var EpisodeListView = function (_a) {
    var episodes = _a.episodes, lastWatchedSeason = _a.lastWatchedSeason, seasons = _a.seasons, onClose = _a.onClose, movieStatus = _a.movieStatus, slug = _a.slug, currentEpisodeId = _a.currentEpisodeId;
    var navigate = Object(__WEBPACK_IMPORTED_MODULE_6__context_Router__["b" /* useRouter */])().navigate;
    var t = Object(__WEBPACK_IMPORTED_MODULE_4_react_i18next__["b" /* useTranslation */])().t;
    var scrollRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(seasons ? seasons[0] : 1), currentSeason = _b[0], setCurrentSeason = _b[1];
    var episodeListCloseRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["k" /* useFocusable */])({
        group: "episodeListClose",
        index: 0,
        onKeyDown: onClose,
        onKeyBack: onClose,
    });
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var i = seasons.indexOf(currentSeason);
        if (i === -1)
            return;
        var t = setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].manualFocus("episodeListSeasons", i);
        }, 0);
        return function () { return clearTimeout(t); };
    }, [currentSeason, seasons]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].manualFocus("episodeListClose", 0);
    }, []);
    var filteredEpisodes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return episodes.filter(function (e) { return e.seasonNumber === currentSeason; }); }, [episodes, currentSeason]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].updateGroupOrder();
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].registerGroup({ name: "episodeListClose", position: 20 });
        __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].registerGroup({ name: "episodeListSeasons", position: 25 });
        filteredEpisodes.forEach(function (e, i) {
            return __WEBPACK_IMPORTED_MODULE_7__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "season-" + e.seasonNumber + "-" + i,
                position: i + 30,
                itemHeight: 132,
                verticalContainer: scrollRef.current,
            });
        });
    }, [currentSeason, filteredEpisodes]);
    var currentSeasonEpisodesLength = filteredEpisodes.length;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var current = currentEpisodeId
            ? episodes.find(function (e) { return e.id === currentEpisodeId; })
            : undefined;
        setCurrentSeason((current === null || current === void 0 ? void 0 : current.seasonNumber) || lastWatchedSeason || seasons[0] || 1);
    }, [currentEpisodeId, lastWatchedSeason, episodes, seasons]);
    var handleEpisodePress = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (episode) {
        Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["i" /* onEpisodePress */])(episode, slug, navigate);
        onClose();
    }, [slug, navigate, onClose]);
    var renderItem = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (episode, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: index, className: "episode-list-item" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__EpisodeListItemView__["a" /* EpisodeListItemView */], { focusRaw: ["season-" + episode.seasonNumber + "-" + index, 0], episode: episode, isComingSoon: movieStatus === "CS" || episode.status === "CS", onEpisodePress: handleEpisodePress, isCurrentEpisode: episode.id === currentEpisodeId, onClose: onClose }))); }, [movieStatus, handleEpisodePress, currentEpisodeId, onClose]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "episodes-list", className: "episode-list-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "episode-list-header", className: "episode-list-header" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "close-btn-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "close", ref: episodeListCloseRef, tabIndex: 0 }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "current-season", key: currentSeason },
                    t("movie.season"),
                    " ",
                    currentSeason),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "current-season-episodes" },
                    currentSeasonEpisodesLength,
                    " ",
                    currentSeasonEpisodesLength > 1
                        ? t("movie.episodes")
                        : t("movie.episode"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "seasons", className: "seasons-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "seasons" },
                    t("movie.seasons"),
                    ": "),
                seasons.map(function (season, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](EpisodeListSeasonView, { focusRaw: ["episodeListSeasons", i], key: "season-" + season, handleSeasonChange: setCurrentSeason, season: season, currentSeason: currentSeason, onClose: onClose })); }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "episode-list-wrapper" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: scrollRef, className: "episodes-list-scroll-content" }, filteredEpisodes.map(function (episode, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: "episode-wrapper-" + episode.id, "data-scroll-index-wrapper": true }, renderItem(episode, index))); })))));
};
var EpisodeListSeasonView = function (_a) {
    var currentSeason = _a.currentSeason, handleSeasonChange = _a.handleSeasonChange, season = _a.season, focusRaw = _a.focusRaw, onClose = _a.onClose;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return handleSeasonChange(season); },
        onKeyBack: onClose,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, className: "season " + (currentSeason === season ? "active" : ""), tabIndex: 0 }, season));
};


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EpisodeListItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EpisodeListViewStyles_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EpisodeListViewStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EpisodeListViewStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__movie_MoviePoster__ = __webpack_require__(20);





var EpisodeListItemView = function (_a) {
    var episode = _a.episode, isComingSoon = _a.isComingSoon, onEpisodePress = _a.onEpisodePress, isCurrentEpisode = _a.isCurrentEpisode, focusRaw = _a.focusRaw, onClose = _a.onClose;
    var t = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])().t;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onEpisodePress(episode); },
        onKeyBack: onClose,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "episode-" + episode.id, className: "episode-item-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: ref, tabIndex: 0, className: "episode-item" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__movie_MoviePoster__["a" /* MoviePoster */], { url: episode.thumbnail, className: "episode-item-img" }),
            isComingSoon && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "coming-soon-episode" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t("layout.coming_soon")))),
            isCurrentEpisode ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "episode-current" }, t("movie.currently_playing"))) : null,
            episode.watchHistory ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "progress-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "progress-box" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "bar", style: "width: " + (episode.watchHistory.progress > 0.05
                            ? episode.watchHistory.progress * 100
                            : 5) + "%" })))) : null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "details-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "episode-number" },
                t("movie.episode"),
                " ",
                episode.episodeNumber),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "episode-name" }, episode.name))));
};


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerResolutionList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Focus__ = __webpack_require__(3);




var PlayerResolutionList = function (_a) {
    var quality = _a.quality, popup = _a.popup, onSetResolution = _a.onSetResolution, onBackPress = _a.onBackPress, resolutionListRef = _a.resolutionListRef;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "resolution-list", ref: resolutionListRef, tabIndex: 0 },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, quality.toUpperCase()),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "popup", style: "display: " + (popup === "resolution" ? "block" : "none") },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { id: "resolution-list", "data-direction": "1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "popup-title" }, t("player.quality")),
                popup === "resolution"
                    ? ["HD", "SD"].map(function (resolution, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PlayerResolutionItemView, { active: quality === resolution, focusRaw: ["playerPopup", index], key: index, resolution: resolution, setResolution: onSetResolution, handleBackPress: onBackPress })); })
                    : null))));
};
var PlayerResolutionItemView = function (_a) {
    var active = _a.active, focusRaw = _a.focusRaw, resolution = _a.resolution, setResolution = _a.setResolution, handleBackPress = _a.handleBackPress;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_2__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        direction: __WEBPACK_IMPORTED_MODULE_3__utils_Focus__["a" /* FocusableItemDirectionEnum */].Vertical,
        onKeyDown: function () { return setResolution(resolution); },
        onKeyBack: function () { return handleBackPress(); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { ref: ref, tabIndex: 0, className: active ? "active" : "" }, resolution));
};


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerDubbingList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Focus__ = __webpack_require__(3);




var PlayerDubbingList = function (_a) {
    var language = _a.language, popup = _a.popup, audioTracks = _a.audioTracks, onSetDubbing = _a.onSetDubbing, onBackPress = _a.onBackPress, audioListRef = _a.audioListRef;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dubbing-list", ref: audioListRef, tabIndex: 0 },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, language ? language.toUpperCase() : null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "popup", style: "display: " + (popup === "dubbing" ? "block" : "none") },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { id: "dubbing-list", "data-direction": "1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "popup-title" }, t("player.dub_language")),
                audioTracks &&
                    popup === "dubbing" &&
                    audioTracks.map(function (track, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PlayerAudioTrackItemView, { key: index, track: track, handleSetDubbing: onSetDubbing, handleBackPress: onBackPress, focusRaw: ["playerPopup", index], active: language === track.lang })); })))));
};
var PlayerAudioTrackItemView = function (_a) {
    var focusRaw = _a.focusRaw, track = _a.track, handleSetDubbing = _a.handleSetDubbing, handleBackPress = _a.handleBackPress, active = _a.active;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    var ref = Object(__WEBPACK_IMPORTED_MODULE_2__utils_Helpers__["k" /* useFocusable */])({
        group: focusRaw[0],
        index: focusRaw[1],
        direction: __WEBPACK_IMPORTED_MODULE_3__utils_Focus__["a" /* FocusableItemDirectionEnum */].Vertical,
        onKeyDown: function () { return handleSetDubbing(track); },
        onKeyBack: function () { return handleBackPress(); },
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { ref: ref, tabIndex: 0, className: active ? "active" : "" }, t("player.languages." + track.lang)));
};


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdlePromptModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttons_ExitButtonView__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalStyles_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modalStyles_css__);




var IdlePromptModal = function (_a) {
    var onYes = _a.onYes, onNo = _a.onNo;
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])().t;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "large-modal" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "info-text" }, t("idle.text")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__buttons_ExitButtonView__["a" /* ExitButtonView */], { onClose: onYes, onExit: onNo, closeLabel: t("modal.yes"), exitLabel: t("idle.no") }))));
};


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockMoviesScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlockMoviesScreenStyles_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlockMoviesScreenStyles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BlockMoviesScreenStyles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_Router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_movie_service__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_movie_MovieRowView__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Focus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_buttons_ScrollToTopButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_footer_FooterView__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hooks_useTVScroll__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_SkeletonContentLayout__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_ModalContext__ = __webpack_require__(11);
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};















var BlockMoviesScreen = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3__context_Router__["b" /* useRouter */])(), params = _a.params, navigate = _a.navigate, goBack = _a.goBack;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_7_react_i18next__["b" /* useTranslation */])(), t = _b.t, i18n = _b.i18n;
    var verticalRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), movies = _c[0], setMovies = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), blockTitle = _d[0], setBlockTitle = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), hasMore = _e[0], setHasMore = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(6), loadedRowsCount = _g[0], setLoadedRowsCount = _g[1];
    var showModal = Object(__WEBPACK_IMPORTED_MODULE_13__context_ModalContext__["b" /* useModalContext */])().showModal;
    var rows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_6__utils_Helpers__["a" /* chunkArray */])(movies, 6); }, [movies]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (__WEBPACK_IMPORTED_MODULE_8__utils_Focus__["b" /* focusManager */].getCurrentGroup() === "main-navbar")
            return;
        __WEBPACK_IMPORTED_MODULE_8__utils_Focus__["b" /* focusManager */].manualFocus("main-navbar", 0);
    }, []);
    var handleMoviePress = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (movie) {
        var result = Object(__WEBPACK_IMPORTED_MODULE_6__utils_Helpers__["j" /* onMoviePress */])(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    var handleBack = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        goBack();
        return true;
    }, [goBack]);
    var requestId = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
    var fetchMovies = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (offset, force) {
        if (offset === void 0) { offset = 0; }
        if (force === void 0) { force = false; }
        if ((!force && (isLoading || !hasMore)) || !params.slug)
            return;
        setIsLoading(true);
        var limit = 18;
        var id = ++requestId.current;
        Object(__WEBPACK_IMPORTED_MODULE_4__services_movie_service__["a" /* getBlockMovies */])(params.slug, {
            lang: i18n.language,
            limit: limit,
            offset: offset,
        })
            .then(function (res) {
            var _a;
            if (id !== requestId.current)
                return;
            var newItems = res.items || [];
            if ((_a = res.block) === null || _a === void 0 ? void 0 : _a.title) {
                setBlockTitle(res.block.title);
            }
            setMovies(function (prev) {
                return offset === 0 ? newItems : __spreadArrays(prev, newItems);
            });
            setHasMore(offset + newItems.length < res.count);
            setIsLoading(false);
        })
            .catch(function (err) {
            if (id !== requestId.current)
                return;
            console.error(err);
            setIsLoading(false);
        });
    }, [params.slug, i18n.language, isLoading, hasMore]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setMovies([]);
        setBlockTitle("");
        setHasMore(true);
        setLoadedRowsCount(6);
        setIsLoading(false);
        fetchMovies(0, true);
    }, [params.slug, i18n.language]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        rows.slice(0, loadedRowsCount).forEach(function (_, index) {
            __WEBPACK_IMPORTED_MODULE_8__utils_Focus__["b" /* focusManager */].registerGroup({
                name: "row-" + index,
                position: index + 100,
                itemHeight: 530,
                verticalContainer: verticalRef.current,
            });
        });
    }, [rows, loadedRowsCount]);
    var onEndReached = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (loadedRowsCount < rows.length) {
            setLoadedRowsCount(function (prev) { return prev + 3; });
        }
        else {
            fetchMovies(movies.length);
        }
    }, [loadedRowsCount, rows.length, movies.length, fetchMovies]);
    var _h = Object(__WEBPACK_IMPORTED_MODULE_11__hooks_useTVScroll__["b" /* useTVScroll */])({ onEndReached: onEndReached }), scrollToTopVisible = _h.scrollToTopVisible, focusedGroup = _h.focusedGroup;
    var focusedRowIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        if (focusedGroup && focusedGroup.indexOf("row-") === 0) {
            var parsed = parseInt(focusedGroup.slice(4), 10);
            if (!Number.isNaN(parsed))
                return parsed;
        }
        return 0;
    }, [focusedGroup]);
    var renderedRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return rows
            .slice(0, loadedRowsCount)
            .map(function (row, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_views_movie_MovieRowView__["a" /* MovieRowView */], { key: index, index: index, hasHorizontalScroll: false, movies: row, active: Object(__WEBPACK_IMPORTED_MODULE_11__hooks_useTVScroll__["a" /* isWithinPosterWindow */])(index, focusedRowIndex), onMoviePress: handleMoviePress, onKeyBack: handleBack })); });
    }, [rows, loadedRowsCount, handleMoviePress, handleBack, focusedRowIndex]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* Header */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: verticalRef, className: "screen-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "see-more-screen" }, isLoading && movies.length === 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_views_SkeletonContentLayout__["a" /* SkeletonContentLayout */], { showTitle: true, isBlockMoviesScreen: true, skeletonCount: 6 })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                !!blockTitle && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, blockTitle),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: params.slug },
                    renderedRows,
                    !hasMore && !isLoading && movies.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_views_footer_FooterView__["a" /* FooterView */], null)))))),
        scrollToTopVisible && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_views_buttons_ScrollToTopButton__["a" /* ScrollToTopButton */], null)));
};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRenderResolution; });
var getRenderResolution = function () {
    var innerWidth = window.innerWidth || 0;
    var innerHeight = window.innerHeight || 0;
    if (innerWidth === 0 || innerHeight === 0) {
        innerWidth = screen.width || 1280;
        innerHeight = screen.height || 720;
        console.warn("[RenderRes] window dimensions unavailable, using screen fallback");
    }
    if (innerWidth < 640 || innerHeight < 360) {
        console.error("[RenderRes] Invalid dimensions (" + innerWidth + "\u00D7" + innerHeight + "), using fallback");
        innerWidth = 1280;
        innerHeight = 720;
    }
    var devicePixelRatio = window.devicePixelRatio || 1;
    return {
        width: Math.round(innerWidth * devicePixelRatio),
        height: Math.round(innerHeight * devicePixelRatio),
        innerWidth: innerWidth,
        innerHeight: innerHeight,
        devicePixelRatio: devicePixelRatio,
    };
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};if(!Element.prototype.closest){Element.prototype.closest=function(css){var node=this;while(node){if(node.matches(css))return node;else node=node.parentElement;}return null;};}if(!Element.prototype.matches){Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector||Element.prototype.oMatchesSelector||Element.prototype.webkitMatchesSelector||function(s){var matches=(this.document||this.ownerDocument).querySelectorAll(s),i=matches.length;while(--i>=0&&matches.item(i)!==this){}return i>-1;};}if(!window.scrollTo){window.scrollTo=function(options){if(typeof options==="number"){// Legacy two-argument support
arguments[0]={top:arguments[0],left:arguments[1]||0};}if(options.behavior==="smooth"){// Default smooth scroll duration
var scroll=function scroll(){var time=performance.now();var elapsed=time-startTime;var progress=Math.min(elapsed/duration,1);window.scrollTo(startX+(targetX-startX)*progress,startY+(targetY-startY)*progress);if(progress<1){requestAnimationFrame(scroll);}};// Fallback for browsers without smooth scrolling
var startX=window.pageXOffset;var startY=window.pageYOffset;var targetX=options.left||0;var targetY=options.top||0;var startTime=performance.now();var duration=300;requestAnimationFrame(scroll);}else{// Default scroll behavior
window.scrollTo(options.left||0,options.top||0);}};}if(!global.URLSearchParams){var URLSearchParams=function URLSearchParams(init){this._params={};if(!init){return this;}if(typeof init==="string"){init=init.replace(/^[?#]/,"");var pairs=init.split("&");for(var i=0;i<pairs.length;i++){var pair=pairs[i].split("=");var key=decodeURIComponent(pair[0]||"");var value=decodeURIComponent(pair[1]||"");if(this._params[key]===undefined){this._params[key]=value;}else if(Array.isArray(this._params[key])){this._params[key].push(value);}else{this._params[key]=[this._params[key],value];}}}else if((typeof init==="undefined"?"undefined":_typeof(init))==="object"){for(var _key in init){if(init.hasOwnProperty(_key)){this._params[_key]=init[_key];}}}};URLSearchParams.prototype={get:function get(name){var values=this._params[name];return Array.isArray(values)?values[0]:values;},getAll:function getAll(name){var values=this._params[name];return Array.isArray(values)?values:values?[values]:[];},set:function set(name,value){this._params[name]=value;},append:function append(name,value){if(this._params[name]===undefined){this._params[name]=value;}else if(Array.isArray(this._params[name])){this._params[name].push(value);}else{this._params[name]=[this._params[name],value];}},delete:function _delete(name){delete this._params[name];},has:function has(name){return name in this._params;},toString:function toString(){var parts=[];for(var key in this._params){var values=this.getAll(key);for(var i=0;i<values.length;i++){parts.push(encodeURIComponent(key)+"="+encodeURIComponent(values[i]));}}return parts.join("&");}};global.URLSearchParams=URLSearchParams;}if(!Object.values){Object.values=function(obj){return Object.keys(obj).map(function(key){return obj[key];});};}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.af67eb40.js